(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
Falcon.addBinding('dateText', true, (function() {
  var FORMAT;
  FORMAT = "M/D/YYYY";
  return function(element, valueAccessor) {
    var m, node, offset, ref, value;
    value = ko.unwrap(valueAccessor());
    if (_.isDate(value) || _.isString(value)) {
      m = moment.utc(value);
    } else if (moment.isMoment(value)) {
      m = value;
    } else if (_.isObject(value)) {
      ref = value, value = ref.value, offset = ref.offset;
      value = ko.unwrap(value);
      offset = ko.unwrap(offset);
      m = moment.utc(value);
      if (offset) {
        m = m.utcOffset(offset);
      }
    } else {
      m = moment(null);
    }
    if (m.isValid()) {
      node = document.createTextNode(m.format(FORMAT));
    } else {
      node = document.createTextNode("Invalid Date");
    }
    return ko.virtualElements.setDomNodeChildren(element, [node]);
  };
})());

},{}],2:[function(require,module,exports){
Falcon.addBinding('dateTimeText', true, (function() {
  var FORMAT;
  FORMAT = "MM/DD/YYYY h:mma";
  return function(element, valueAccessor) {
    var m, node, value;
    value = ko.unwrap(valueAccessor());
    m = moment(value);
    if (m.isValid()) {
      node = document.createTextNode(m.format(FORMAT));
    } else {
      node = document.createTextNode("Invalid Date");
    }
    return ko.virtualElements.setDomNodeChildren(element, [node]);
  };
})());

},{}],3:[function(require,module,exports){
var CONSTANTS;

CONSTANTS = require("../$constants/default.constants");

Falcon.addBinding("dateValue", {
  'init': function(element, valueAccessor, allBindings, viewModel, bindingContext) {
    var obs, onChange;
    obs = valueAccessor();
    if (!ko.isObservable(obs)) {
      return;
    }
    ko.computed({
      disposeWhenNodeIsRemoved: element,
      read: function() {
        var value;
        value = obs();
        if (value != null) {
          value = moment(value).format(CONSTANTS.DATE_FORMAT);
        }
        return element.value = value != null ? value : "";
      }
    });
    element.addEventListener('change', onChange = function() {
      var m, value;
      value = element.value;
      m = moment(value, CONSTANTS.DATE_FORMAT);
      element.removeEventListener('change', onChange);
      if (m.isValid()) {
        obs(m.toDate());
      } else {
        obs(null);
      }
      return element.addEventListener('change', onChange);
    });
    return Falcon.onDispose(element, function() {
      return element.removeEventListener('change', onChange);
    });
  }
});

},{"../$constants/default.constants":36}],4:[function(require,module,exports){
Falcon.addBinding('daysUntilText', true, function(element, valueAccessor) {
  var m, node, offset, ref, value;
  value = ko.unwrap(valueAccessor());
  if (_.isDate(value) || _.isString(value)) {
    m = moment.utc(value);
  } else if (moment.isMoment(value)) {
    m = value;
  } else if (_.isObject(value)) {
    ref = value, value = ref.value, offset = ref.offset;
    value = ko.unwrap(value);
    offset = ko.unwrap(offset);
    m = moment.utc(value);
    if (offset) {
      m = m.utcOffset(offset);
    }
  } else {
    m = moment(null);
  }
  node = document.createTextNode(m.diff(moment.utc(), 'days'));
  return ko.virtualElements.setDomNodeChildren(element, [node]);
});

},{}],5:[function(require,module,exports){
Falcon.addBinding('decimal', true, function(element, valueAccessor) {
  var node, value;
  value = ko.unwrap(valueAccessor());
  node = document.createTextNode(numeral(value).format('0,0.00'));
  return ko.virtualElements.setDomNodeChildren(element, [node]);
});

},{}],6:[function(require,module,exports){
Falcon.addBinding('followCursor', (function() {
  return {
    'init': function(element, valueAccessor) {
      var $childElemens, $element;
      $element = $(element);
      $childElemens = null;
      ko.computed((function(_this) {
        return function() {
          var querySelector;
          querySelector = ko.unwrap(valueAccessor());
          return $childElemens = $element.find(querySelector);
        };
      })(this));
      return element.addEventListener('mousemove', function(event) {
        var left, ref, top, x, y;
        ref = $element.offset(), top = ref.top, left = ref.left;
        x = event.pageX - left;
        y = event.pageY - top;
        return $childElemens.css({
          position: 'absolute',
          top: y,
          left: x
        });
      });
    }
  };
})());

},{}],7:[function(require,module,exports){
Falcon.addBinding('fromNowText', true, function(element, valueAccessor) {
  var m, node, offset, ref, value;
  value = ko.unwrap(valueAccessor());
  if (_.isDate(value) || _.isString(value)) {
    m = moment.utc(value);
  } else if (moment.isMoment(value)) {
    m = value;
  } else if (_.isObject(value)) {
    ref = value, value = ref.value, offset = ref.offset;
    value = ko.unwrap(value);
    offset = ko.unwrap(offset);
    m = moment.utc(value);
    if (offset) {
      m = m.utcOffset(offset);
    }
  } else {
    m = moment(null);
  }
  if (m.isValid()) {
    node = document.createTextNode(m.fromNow());
  } else {
    node = document.createTextNode("Invalid Date");
  }
  return ko.virtualElements.setDomNodeChildren(element, [node]);
});

},{}],8:[function(require,module,exports){
Falcon.addBinding('hashHref', {
  'update': function(element, valueAccessor, allBindings, viewModel, bindingContext) {
    var ref, ref1, ref2, url, value;
    value = (ref = valueAccessor()) != null ? ref : "";
    if (ko.isObservable(value)) {
      url = ((ref1 = value()) != null ? ref1 : "").toString();
    } else if (_.isFunction(value)) {
      url = ((ref2 = value(bindingContext['$data'])) != null ? ref2 : "").toString();
    } else {
      url = value.toString();
    }
    return element.setAttribute("href", "#" + url);
  }
});

},{}],9:[function(require,module,exports){
Falcon.addBinding('href', function(element, valueAccessor) {
  element.setAttribute('href', ko.unwrap(valueAccessor()));
  return element.setAttribute('target', '_blank');
});

},{}],10:[function(require,module,exports){
Falcon.addBinding('integer', true, function(element, valueAccessor) {
  var node, value;
  value = ko.unwrap(valueAccessor());
  node = document.createTextNode(numeral(value).format('0,0'));
  return ko.virtualElements.setDomNodeChildren(element, [node]);
});

},{}],11:[function(require,module,exports){
Falcon.addBinding('isHovered', {
  'init': function(element, valueAccessor) {
    var $element, mouseenter, mouseleave, obs;
    obs = valueAccessor();
    if (!ko.isObservable(obs)) {
      return;
    }
    $element = $(element);
    $element.on('mouseenter', mouseenter = function() {
      return obs(true);
    });
    $element.on('mouseleave', mouseleave = function() {
      return obs(false);
    });
    return Falcon.onDispose(element, function() {
      $element.off('mouseenter', mouseenter);
      return $element.off('mouseleave', mouseleave);
    });
  }
});

},{}],12:[function(require,module,exports){
Falcon.addBinding('moment', true, (function() {
  var $hours, $minutes, $seconds;
  $seconds = ko.observable(0);
  $minutes = ko.observable(0);
  $hours = ko.observable(0);
  setInterval(function() {
    return $seconds($seconds() + 1);
  }, 1000);
  setInterval(function() {
    return $minutes($minutes() + 1);
  }, 30 * 1000);
  setInterval(function() {
    return $hours($hours() + 1);
  }, 30 * 60 * 1000);
  return {
    'update': function(element, valueAccessor, allBindings) {
      var current_moment, now, textNode, value;
      ko.virtualElements.emptyNode(element);
      value = ko.unwrap(valueAccessor());
      if (value == null) {
        return;
      }
      current_moment = moment(value);
      now = moment().subtract(1, 'seconds');
      if (current_moment.isAfter(now)) {
        current_moment = now;
      }
      if (current_moment.isAfter(moment().subtract(1, 'minute'))) {
        current_moment = current_moment.fromNow();
        $seconds();
      } else if (current_moment.isAfter(moment().subtract(1, 'hour'))) {
        current_moment = current_moment.fromNow();
        $minutes();
      } else if (current_moment.isAfter(moment().subtract(1, 'days'))) {
        current_moment = current_moment.fromNow();
        $hours();
      } else if (current_moment.isAfter(moment().subtract(1, 'weeks'))) {
        current_moment = current_moment.format('dddd');
      } else {
        current_moment = current_moment.format('l');
      }
      textNode = document.createTextNode(current_moment);
      return ko.virtualElements.setDomNodeChildren(element, [textNode]);
    }
  };
})());

},{}],13:[function(require,module,exports){
Falcon.addBinding('monthText', true, (function() {
  var FORMAT;
  FORMAT = "MMMM";
  return function(element, valueAccessor) {
    var m, node, value;
    value = ko.unwrap(valueAccessor());
    m = moment(value);
    if (m.isValid()) {
      node = document.createTextNode(m.format(FORMAT));
    } else {
      node = document.createTextNode("Invalid Date");
    }
    return ko.virtualElements.setDomNodeChildren(element, [node]);
  };
})());

},{}],14:[function(require,module,exports){
Falcon.addBinding('monthYearText', true, (function() {
  var FORMAT;
  FORMAT = "MMMM, YYYY";
  return function(element, valueAccessor) {
    var m, node, value;
    value = ko.unwrap(valueAccessor());
    m = moment(value);
    if (m.isValid()) {
      node = document.createTextNode(m.format(FORMAT));
    } else {
      node = document.createTextNode("Invalid Date");
    }
    return ko.virtualElements.setDomNodeChildren(element, [node]);
  };
})());

},{}],15:[function(require,module,exports){
Falcon.addBinding("onEnter", {
  'init': function(element, valueAccessor) {
    var keydown;
    element.addEventListener('keydown', keydown = function(event) {
      var callback, keyCode, ref;
      keyCode = (ref = event.keyCode) != null ? ref : event.which;
      if (keyCode !== KeyboardCommands.ENTER_KEY) {
        return true;
      }
      event.preventDefault();
      callback = valueAccessor();
      if (_.isFunction(callback)) {
        callback();
      }
      return false;
    });
    return Falcon.onDispose(element, function() {
      return element.removeEventListener('keydown', keydown);
    });
  }
});

},{}],16:[function(require,module,exports){
Falcon.addBinding('onScrollBottom', (function() {
  var THRESHOLD;
  THRESHOLD = 100;
  return {
    'init': function(element, valueAccessor, allBindings) {
      var callback, clientHeight, isDisabled, is_refreshing, onScroll, ref, scrollHeight, scrollTop;
      is_refreshing = false;
      callback = valueAccessor();
      if (!_.isFunction(callback)) {
        callback = (function() {});
      }
      isDisabled = (ref = allBindings.get('onScrollBottomDisabled')) != null ? ref : false;
      scrollHeight = 0;
      clientHeight = 0;
      scrollTop = 0;
      element.addEventListener('scroll', onScroll = function() {
        var scrollTopTrigger, scrollableAmount;
        if (ko.unwrap(isDisabled)) {
          return;
        }
        scrollableAmount = element.scrollHeight - element.clientHeight;
        scrollTopTrigger = scrollableAmount - THRESHOLD;
        if (element.scrollTop >= scrollTopTrigger) {
          return callback();
        }
      });
      return Falcon.onDispose(element, function() {
        return element.removeEventListener('scroll', onScroll);
      });
    }
  };
})());

},{}],17:[function(require,module,exports){
Falcon.addBinding('percent', true, function(element, valueAccessor) {
  var node, value;
  value = ko.unwrap(valueAccessor());
  node = document.createTextNode(numeral(value).format('0.00%'));
  return ko.virtualElements.setDomNodeChildren(element, [node]);
});

},{}],18:[function(require,module,exports){
Falcon.addBinding('preventDefault', (function() {
  var stop;
  stop = function(event) {
    return event.preventDefault();
  };
  return {
    'init': function(element, valueAccessor) {
      var $element, value;
      $element = $(element);
      value = ko.unwrap(valueAccessor());
      if (!_.isString(value)) {
        value = "";
      }
      if (_.isEmpty(value)) {
        return;
      }
      if (value === 'touch') {
        element.addEventListener('touchstart', stop);
        element.addEventListener('touchend', stop);
      } else if (value === 'mouse') {
        element.addEventListener('mousedown', stop);
        element.addEventListener('mouseup', stop);
        element.addEventListener('click', stop);
      } else {
        element.addEventListener(value, stop);
      }
    }
  };
})());

},{}],19:[function(require,module,exports){
var RPC;

RPC = require("../rpc");

Falcon.addBinding('s3Upload', (function() {
  var bucket;
  bucket = null;
  return {
    'init': function(element, valueAccessor, allBindings, viewModel, bindingContent) {
      var fileNameObs, fileUrlObs, isUploadingObs, onChange, options, ref;
      options = (ref = ko.unwrap(valueAccessor())) != null ? ref : {};
      fileUrlObs = options.fileUrl;
      fileNameObs = options.fileName;
      isUploadingObs = options.isUploading;
      if (!ko.isObservable(fileUrlObs)) {
        return typeof console !== "undefined" && console !== null ? console.error("'fileUrl' assignment must be an observable") : void 0;
      }
      element.addEventListener('change', onChange = function() {
        var file;
        if (!(element.files.length > 0)) {
          fileUrlObs(null);
          if (ko.isWriteableObservable(fileNameObs)) {
            fileNameObs(null);
          }
          return;
        }
        file = element.files[0];
        element.disabled = true;
        if (ko.isWriteableObservable(isUploadingObs)) {
          isUploadingObs(true);
        }
        return RPC.promiseUploadFile(file).then((function(_this) {
          return function(url) {
            fileUrlObs(url);
            if (ko.isWriteableObservable(fileNameObs)) {
              return fileNameObs(file.name);
            }
          };
        })(this)).fail((function(_this) {
          return function() {
            if (typeof console !== "undefined" && console !== null) {
              console.error("An error occurred while uploading file");
            }
            fileUrlObs(null);
            if (ko.isWriteableObservable(fileNameObs)) {
              return fileNameObs(null);
            }
          };
        })(this)).fin((function(_this) {
          return function() {
            element.disabled = false;
            if (ko.isWriteableObservable(isUploadingObs)) {
              return isUploadingObs(false);
            }
          };
        })(this)).done();
      });
      return Falcon.onDispose(element, function() {
        return element.removeEventListener('change', onChange);
      });
    }
  };
})());

},{"../rpc":65}],20:[function(require,module,exports){
var Contest, FPT, Franchise, Region, User;

User = require("../$models/user.model");

Franchise = require("../$models/franchise.model");

FPT = require("../$models/fpt.model");

Contest = require("../$models/contest.model");

Region = require("../$models/region.model");

Falcon.addBinding('selectize', (function() {
  var generateOption, generateOptions;
  generateOption = function(option) {
    var label, search, value;
    value = label = search = null;
    if (option instanceof User) {
      value = option.get("id");
      label = (option.get("name")) + " (" + (option.get("email")) + ")";
      search = label;
    } else if (option instanceof Franchise) {
      value = option.get("id");
      label = option.get("name");
      search = label;
    } else if (option instanceof FPT) {
      value = option.get("id");
      label = option.get("name");
      search = label;
    } else if (option instanceof Contest) {
      value = option.get("id");
      label = option.get("name");
      search = label;
    } else if (option instanceof Region) {
      value = option.get("id");
      label = option.get("name");
      search = label;
    } else {
      if (typeof console !== "undefined" && console !== null) {
        console.error("[selectize.binding] Could not generate option for: ", option);
      }
    }
    return {
      value: value,
      label: label,
      search: search
    };
  };
  generateOptions = function(options) {
    var option;
    if (Falcon.isCollection(options)) {
      options = options.all();
    }
    return (function() {
      var i, len, results1;
      results1 = [];
      for (i = 0, len = options.length; i < len; i++) {
        option = options[i];
        results1.push(generateOption(option));
      }
      return results1;
    })();
  };
  return {
    'init': function(element, valueAccessor, allBindings, viewModel, bindingContext) {
      var $element, _change, is_setting, observable, selectize, selectizeLoad, selectizeMaxItems, selectizeMaxOptions, selectizeOnCreate, selectizeOnRemove, selectizeOptions, values;
      values = null;
      selectizeOptions = {
        valueField: 'value',
        labelField: 'label',
        searchField: 'search',
        closeAfterSelect: false,
        hideSelected: true,
        persist: true
      };
      selectizeOnCreate = allBindings.get('selectizeOnCreate');
      selectizeOnRemove = allBindings.get('selectizeOnRemove');
      selectizeLoad = allBindings.get('selectizeLoad');
      selectizeMaxItems = ko.unwrap(allBindings.get('selectizeMaxItems'));
      selectizeMaxOptions = ko.unwrap(allBindings.get('selectizeMaxOptions'));
      if (_.isFunction(selectizeOnCreate)) {
        selectizeOptions['create'] = function(value) {
          var d;
          d = selectizeOnCreate.call(viewModel, value);
          return generateOption(d);
        };
      }
      if (_.isNumber(selectizeMaxItems)) {
        selectizeOptions['maxItems'] = selectizeMaxItems;
      }
      if (_.isNumber(selectizeMaxOptions)) {
        selectizeOptions['maxOptions'] = selectizeMaxOptions;
      }
      if (_.isFunction(selectizeLoad)) {
        selectizeOptions['load'] = function(query, callback) {
          return selectizeLoad(query, (function(_this) {
            return function(results) {
              results = generateOptions(results);
              return callback(results);
            };
          })(this));
        };
      }
      $element = $(element).selectize(selectizeOptions);
      selectize = $element.get(0).selectize;
      if (_.isFunction(selectizeOnRemove)) {
        selectize.on('item_remove', function(value) {
          return selectizeOnRemove.call(viewModel, value);
        });
      }
      ko.computed({
        disposeWhenNodeIsRemoved: element,
        read: function() {
          values = ko.unwrap(valueAccessor());
          selectize.clearOptions();
          selectize.addOption(generateOptions(values));
          return selectize.refreshOptions(false);
        }
      });
      if (allBindings.get('selectizeValue')) {
        observable = allBindings.get('selectizeValue');
        is_setting = false;
        ko.computed({
          disposeWhenNodeIsRemoved: element,
          read: function() {
            values = ko.unwrap(observable);
            if (is_setting) {
              return;
            }
            if (!_.isArray(values)) {
              values = [values];
            }
            values = _.uniq(values);
            return selectize.setValue(values);
          }
        });
        if (ko.isObservable(observable)) {
          selectize.on("change", _change = function() {
            var value;
            is_setting = true;
            value = selectize.getValue();
            if (selectize.settings.mode === "multi") {
              if (_.isString(value)) {
                value = value.split(",");
              }
              if (!_.isArray(value)) {
                value = [];
              }
              value = _.chain(value).uniq().compact().value();
            }
            observable(value);
            return is_setting = false;
          });
          return Falcon.onDispose(element, function() {
            return selectize.off("change", _change);
          });
        }
      }
    }
  };
})());

},{"../$models/contest.model":44,"../$models/fpt.model":48,"../$models/franchise.model":50,"../$models/region.model":55,"../$models/user.model":58}],21:[function(require,module,exports){
Falcon.addBinding("src", (function() {
  var ERROR_SRC, _loadImage, _resolveFileSrc, _resolveSrc;
  ERROR_SRC = "";
  _resolveSrc = function(src) {
    src = ko.unwrap(src);
    if (src instanceof Comment) {
      src = src.get('user');
    }
    if (src instanceof User) {
      src = src.get('default_avatar_url');
    }
    return Helpers.trim(src);
  };
  _resolveFileSrc = function(src) {
    var mimetype, thumbnail;
    thumbnail = src.get('thumbnail');
    if (!_.isEmpty(thumbnail)) {
      return thumbnail;
    }
    mimetype = Helpers.trim(src.get('mimetype')).toLowerCase();
    thumbnail = (function() {
      switch (mimetype) {
        case 'video/x-ms-asf':
          return "asf.png";
        case 'video/3gpp':
        case 'video/3gpp2':
          return "3gp.png";
        case 'application/x-7z-compressed':
          return "7z.png";
        case 'application/illustrator':
          return "ai.png";
        case 'application/vnd.android.package-archive':
          return "apk.png";
        case 'video/x-ms-asf':
          return "asf.png";
        case 'video/avi':
        case 'video/x-msvideo':
          return "avi.png";
        case 'image/bmp':
          return "bmp.png";
        case 'text/css':
          return "css.png";
        case 'text/csv':
          return "csv.png";
        case 'video/divx':
          return "divx.png";
        case 'application/x-msdownload':
          return "dll.png";
        case 'application/msword':
        case 'application/vnd.ms-word':
          return "doc.png";
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          return "docx.png";
        case 'image/vnd.dwg':
        case 'image/x-dwg':
          return "dwg.png";
        case 'application/postscript':
        case 'application/eps':
        case 'application/x-eps':
        case 'image/eps':
        case 'image/x-eps':
          return "eps.png";
        case 'application/x-msdos-program':
        case 'application/x-msdownload':
          return "exe.png";
        case 'video/x-flv':
          return "flv.png";
        case 'image/gif':
          return "gif.png";
        case 'application/gzip':
          return "gz.png";
        case 'text/html':
          return "html.png";
        case 'image/x-ico':
          return "ico.png";
        case 'application/x-iso9660-image':
          return "iso.png";
        case 'application/java-archive':
          return "jar.png";
        case 'image/jpeg':
          return "jpg.png";
        case 'application/javascript':
        case 'text/javascript':
          return "js.png";
        case 'video/quicktime':
          return "mov.png";
        case 'audio/mpeg':
        case 'audio/mpa':
        case 'audio/mpa-robust':
          return "mp3.png";
        case 'video/mp4':
        case 'audio/mp4':
          return "mp4.png";
        case 'video/mpeg':
          return "mpeg.png";
        case 'application/pdf':
        case 'application/x-pdf':
        case 'application/x-bzpdf':
        case 'application/x-gzpdf':
          return "pdf.png";
        case 'application/x-php':
          return "php.png";
        case 'image/png':
        case 'image/x-png':
          return "png.png";
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.ms-powerpoint.presentation.macroEnabled.12':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          return "ppt.png";
        case 'application/photoshop':
        case 'image/vnd.adobe.photoshop':
        case 'application/psd':
        case 'application/x-photoshop':
        case 'image/photoshop':
        case 'image/psd':
        case 'image/x-photoshop':
        case 'image/x-psd':
          return "psd.png";
        case 'application/rar':
        case 'application/x-rar-compressed':
          return "rar.png";
        case 'image/svg+xml':
          return "svg.png";
        case 'application/vnd.adobe.flash-movie':
        case 'application/x-shockwave-flash':
        case 'application/futuresplash':
          return "swf.png";
        case 'application/x-tar':
        case 'application/tar':
        case 'application/x-gtar':
          return "tar.png";
        case 'image/tiff':
        case 'application/tif':
        case 'application/tiff':
        case 'application/x-tif':
        case 'application/x-tiff':
        case 'image/tif':
        case 'image/x-tif':
        case 'image/x-tiff':
          return "tiff.png";
        case 'text/plain':
          return "txt.png";
        case 'audio/vnd.wave':
        case 'audio/wav':
        case 'audio/wave':
        case 'audio/x-wav':
        case 'audio/s-wav':
          return "wav.png";
        case 'application/zip':
        case 'application/x-compress':
        case 'application/x-compressed':
        case 'application/x-zip':
        case 'application/x-zip-compressed':
        case 'application/zip-compressed':
        case 'application/x-7zip-compressed':
          return "zip.png";
        default:
          return "blank.png";
      }
    })();
    return "/images/fileicons/" + thumbnail;
  };
  _loadImage = function(element, src, callback) {
    var _complete, _error, _load, image;
    if (element.getAttribute('src') === src) {
      return;
    }
    if ((!_.isString(src)) || _.isEmpty(src)) {
      DOMHelpers.addClass(element, 'loaded');
      element.setAttribute('src', "");
      return typeof callback === "function" ? callback() : void 0;
    }
    image = new Image;
    DOMHelpers.removeClass(element, 'loaded');
    _complete = function() {
      DOMHelpers.addClass(element, 'loaded');
      image.removeEventListener('load', _load);
      image.removeEventListener('error', _error);
      return typeof callback === "function" ? callback() : void 0;
    };
    image.addEventListener('load', _load = function() {
      if (image.height > image.width) {
        DOMHelpers.addClass(element, 'portrait');
        DOMHelpers.removeClass(element, 'landscape');
      } else {
        DOMHelpers.removeClass(element, 'portrait');
        DOMHelpers.addClass(element, 'landscape');
      }
      element.setAttribute('src', src);
      return _complete();
    });
    image.addEventListener('error', _error = function() {
      element.setAttribute('src', ERROR_SRC);
      return _complete();
    });
    return image.src = src;
  };
  return {
    'init': function(element, valueAccessor, allBindings) {
      var current_src;
      current_src = null;
      return ko.computed({
        disposeWhenNodeIsRemoved: element,
        read: function() {
          var is_loading, src, value;
          value = valueAccessor();
          src = _resolveSrc(value);
          if (src === current_src) {
            return;
          }
          current_src = src;
          is_loading = allBindings.get('srcIsLoading');
          if (ko.isObservable(is_loading)) {
            is_loading(true);
            return _loadImage(element, src, function() {
              return is_loading(false);
            });
          } else {
            return _loadImage(element, src);
          }
        }
      });
    }
  };
})());

},{}],22:[function(require,module,exports){
Falcon.addBinding('stopEvent', (function() {
  var stop;
  stop = function(event) {
    event.stopPropagation();
    event.preventDefault();
    return false;
  };
  return {
    'init': function(element, valueAccessor) {
      var $element, value;
      $element = $(element);
      value = ko.unwrap(valueAccessor());
      if (!_.isString(value)) {
        value = "";
      }
      if (_.isEmpty(value)) {
        return;
      }
      if (value === 'touch') {
        element.addEventListener('touchstart', stop);
        element.addEventListener('touchend', stop);
      } else if (value === 'mouse') {
        element.addEventListener('mousedown', stop);
        element.addEventListener('mouseup', stop);
        element.addEventListener('click', stop);
      } else {
        element.addEventListener(value, stop);
      }
    }
  };
})());

},{}],23:[function(require,module,exports){
Falcon.addBinding('stopPropagation', (function() {
  var stop;
  stop = function(event) {
    return event.stopPropagation();
  };
  return {
    'init': function(element, valueAccessor) {
      var $element, value;
      $element = $(element);
      value = ko.unwrap(valueAccessor());
      if (!_.isString(value)) {
        value = "";
      }
      if (_.isEmpty(value)) {
        return;
      }
      if (value === 'touch') {
        element.addEventListener('touchstart', stop);
        element.addEventListener('touchend', stop);
      } else if (value === 'mouse') {
        element.addEventListener('mousedown', stop);
        element.addEventListener('mouseup', stop);
        element.addEventListener('click', stop);
      } else {
        element.addEventListener(value, stop);
      }
    }
  };
})());

Falcon.addBinding('stopBubble', Falcon.getBinding('stopPropagation'));

},{}],24:[function(require,module,exports){
var ContestFinalist, ContestFinalists, PromiseBaseCollection,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseCollection = require("./promise.base.collection");

ContestFinalist = require("../$models/contest_finalist.model");

module.exports = ContestFinalists = (function(superClass) {
  extend(ContestFinalists, superClass);

  function ContestFinalists() {
    return ContestFinalists.__super__.constructor.apply(this, arguments);
  }

  ContestFinalists.prototype.model = ContestFinalist;

  ContestFinalists.prototype.label = "ContestFinalists";

  return ContestFinalists;

})(PromiseBaseCollection);

},{"../$models/contest_finalist.model":45,"./promise.base.collection":32}],25:[function(require,module,exports){
var ContestWinner, ContestWinners, PromiseBaseCollection,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseCollection = require("./promise.base.collection");

ContestWinner = require("../$models/contest_winner.model");

module.exports = ContestWinners = (function(superClass) {
  extend(ContestWinners, superClass);

  function ContestWinners() {
    return ContestWinners.__super__.constructor.apply(this, arguments);
  }

  ContestWinners.prototype.model = ContestWinner;

  ContestWinners.prototype.label = "ContestWinners";

  return ContestWinners;

})(PromiseBaseCollection);

},{"../$models/contest_winner.model":46,"./promise.base.collection":32}],26:[function(require,module,exports){
var Contest, Contests, PromiseBaseCollection,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseCollection = require("./promise.base.collection");

Contest = require("../$models/contest.model");

module.exports = Contests = (function(superClass) {
  extend(Contests, superClass);

  function Contests() {
    return Contests.__super__.constructor.apply(this, arguments);
  }

  Contests.prototype.model = Contest;

  Contests.prototype.label = "Contests";

  return Contests;

})(PromiseBaseCollection);

},{"../$models/contest.model":44,"./promise.base.collection":32}],27:[function(require,module,exports){
var Entries, Entry, PromiseBaseCollection,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseCollection = require("./promise.base.collection");

Entry = require("../$models/entry.model");

module.exports = Entries = (function(superClass) {
  extend(Entries, superClass);

  function Entries() {
    return Entries.__super__.constructor.apply(this, arguments);
  }

  Entries.prototype.model = Entry;

  Entries.prototype.label = "Entries";

  return Entries;

})(PromiseBaseCollection);

},{"../$models/entry.model":47,"./promise.base.collection":32}],28:[function(require,module,exports){
var FPTContestStatistic, FPTContestStatistics, PromiseBaseCollection,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseCollection = require("./promise.base.collection");

FPTContestStatistic = require("../$models/fpt_contest_statistic.model");

module.exports = FPTContestStatistics = (function(superClass) {
  extend(FPTContestStatistics, superClass);

  function FPTContestStatistics() {
    return FPTContestStatistics.__super__.constructor.apply(this, arguments);
  }

  FPTContestStatistics.prototype.model = FPTContestStatistic;

  FPTContestStatistics.prototype.label = "FPTContestStatistics";

  return FPTContestStatistics;

})(PromiseBaseCollection);

},{"../$models/fpt_contest_statistic.model":49,"./promise.base.collection":32}],29:[function(require,module,exports){
var FPT, FPTs, PromiseBaseCollection,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseCollection = require("./promise.base.collection");

FPT = require("../$models/fpt.model");

module.exports = FPTs = (function(superClass) {
  extend(FPTs, superClass);

  function FPTs() {
    return FPTs.__super__.constructor.apply(this, arguments);
  }

  FPTs.prototype.model = FPT;

  FPTs.prototype.label = "FPTs";

  return FPTs;

})(PromiseBaseCollection);

},{"../$models/fpt.model":48,"./promise.base.collection":32}],30:[function(require,module,exports){
var FranchiseContestStatistic, FranchiseContestStatistics, PromiseBaseCollection,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseCollection = require("./promise.base.collection");

FranchiseContestStatistic = require("../$models/franchise_contest_statistic.model");

module.exports = FranchiseContestStatistics = (function(superClass) {
  extend(FranchiseContestStatistics, superClass);

  function FranchiseContestStatistics() {
    return FranchiseContestStatistics.__super__.constructor.apply(this, arguments);
  }

  FranchiseContestStatistics.prototype.model = FranchiseContestStatistic;

  FranchiseContestStatistics.prototype.label = "FranchiseContestStatistics";

  return FranchiseContestStatistics;

})(PromiseBaseCollection);

},{"../$models/franchise_contest_statistic.model":51,"./promise.base.collection":32}],31:[function(require,module,exports){
var Franchise, Franchises, PromiseBaseCollection,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseCollection = require("./promise.base.collection");

Franchise = require("../$models/franchise.model");

module.exports = Franchises = (function(superClass) {
  extend(Franchises, superClass);

  function Franchises() {
    return Franchises.__super__.constructor.apply(this, arguments);
  }

  Franchises.prototype.model = Franchise;

  Franchises.prototype.label = "Franchises";

  return Franchises;

})(PromiseBaseCollection);

},{"../$models/franchise.model":50,"./promise.base.collection":32}],32:[function(require,module,exports){
var PromiseBaseCollection,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  slice = [].slice;

module.exports = PromiseBaseCollection = (function(superClass) {
  var DATETIME_FORMAT, makeFilterKey;

  extend(PromiseBaseCollection, superClass);

  DATETIME_FORMAT = "";

  PromiseBaseCollection.prototype.label = "";

  PromiseBaseCollection.prototype.filters = null;

  PromiseBaseCollection.prototype.meta = null;

  PromiseBaseCollection.prototype.count = null;

  PromiseBaseCollection.prototype.is_paged = true;

  PromiseBaseCollection.prototype.page_size = null;

  PromiseBaseCollection.prototype.page_number = null;

  PromiseBaseCollection.prototype.hasNextPage = null;

  PromiseBaseCollection.prototype.sort_key = null;

  PromiseBaseCollection.prototype.sort_parameter = null;

  PromiseBaseCollection.prototype.sort_direction = null;

  function PromiseBaseCollection() {
    PromiseBaseCollection.__super__.constructor.apply(this, arguments);
    this.hasNextPage = ko.observable(true);
    this.sort_key = ko.observable(this.sort_key);
    this.sort_parameter = ko.observable(this.sort_parameter);
    this.sort_direction = ko.observable(this.sort_direction);
  }

  PromiseBaseCollection.prototype.promiseFetch = function(options) {
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        options = RequestHelpers.preparePromiseOptions(resolve, reject, options, "An error occurred while fetching " + _this.label);
        return _this.fetch(options);
      };
    })(this));
  };

  PromiseBaseCollection.prototype.promiseFetchNextPage = function(options) {
    if (options == null) {
      options = {};
    }
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        var next_page_number, previous_page_number;
        previous_page_number = _this.getPageNumber();
        next_page_number = (previous_page_number != null ? previous_page_number : 1) + 1;
        _this.setPageNumber(next_page_number);
        if (options['fill_options'] == null) {
          options['fill_options'] = {
            'method': 'append'
          };
        }
        return _this.promiseFetch(options).then(resolve).fail(function(error) {
          _this.setPageNumber(previous_page_number);
          return reject(error);
        });
      };
    })(this));
  };

  PromiseBaseCollection.prototype.promiseCreateAll = function(options) {
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        var promises;
        promises = [];
        _this.each(function(model) {
          return promises.push(model.promiseCreate(options));
        });
        return Q.all(promises).then(resolve, reject);
      };
    })(this));
  };

  PromiseBaseCollection.prototype.parseResponseData = function(data, type, options) {
    if (type === Falcon.DELETE) {
      return [];
    }
    return this.model.prototype.expand(data).toArray();
  };

  PromiseBaseCollection.prototype.sync = function(type, options, context) {
    var filter, previous_length, ref, success, value;
    if (_.isFunction(options)) {
      options = {
        complete: options
      };
    }
    if (!_.isObject(options)) {
      options = {};
    }
    if (options['params'] == null) {
      options['params'] = {};
    }
    if (this.filters != null) {
      ref = this.filters;
      for (filter in ref) {
        value = ref[filter];
        if (!(!(filter in options['params']))) {
          continue;
        }
        value = ko.unwrap(value);
        options['params'][filter] = encodeURIComponent((function() {
          switch (false) {
            case !_.isArray(value):
              return value.join(",");
            case !Falcon.isCollection(value):
              return value.pluck("id").join(",");
            case !Falcon.isModel(value):
              return value.get("id");
            case !_.isDate(value):
              return moment(value).format();
            default:
              return value;
          }
        })());
      }
    }
    if (this.is_paged) {
      if (this.hasPageSize()) {
        options['params']['page[size]'] = this.getPageSize();
      }
      if (this.hasPageNumber()) {
        options['params']['page[number]'] = this.getPageNumber();
      }
    } else {
      options['params']['page'] = false;
    }
    if (this.hasSort()) {
      options['params']['sort'] = encodeURIComponent(this.getSortQueryParam());
    }
    previous_length = this.length();
    success = options['success'];
    options['success'] = (function(_this) {
      return function(collection, response) {
        var count, has_next_page, number, page, ref1, ref2, size;
        has_next_page = false;
        _this.meta = (ref1 = response != null ? response['meta'] : void 0) != null ? ref1 : null;
        if (_this.meta != null) {
          ref2 = _this.meta, count = ref2.count, page = ref2.page;
          _this.count = count;
          if (page != null) {
            size = page.size, number = page.number;
            _this.setPageSize(size);
            _this.setPageNumber(number);
            if ((size != null) && (number != null) && (count != null)) {
              has_next_page = (size * number) < _this.count;
            }
          }
        } else {
          has_next_page = previous_length !== _this.length();
        }
        _this.hasNextPage(has_next_page);
        return success != null ? success.apply(_this, arguments) : void 0;
      };
    })(this);
    return PromiseBaseCollection.__super__.sync.call(this, type, options, context);
  };

  makeFilterKey = function(keys) {
    var i, k, key, len;
    key = 'filter';
    for (i = 0, len = keys.length; i < len; i++) {
      k = keys[i];
      key += "[" + k + "]";
    }
    return key;
  };

  PromiseBaseCollection.prototype.clearFilters = function() {
    this.filters = null;
    return this;
  };

  PromiseBaseCollection.prototype.clearFilter = function() {
    var key, keys;
    keys = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    if (this.filters == null) {
      return this;
    }
    key = makeFilterKey(keys);
    if (!(key in this.filters)) {
      return this;
    }
    delete this.filters[key];
    return this;
  };

  PromiseBaseCollection.prototype.getFilter = function() {
    var key, keys;
    keys = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    if (this.filters == null) {
      return void 0;
    }
    key = makeFilterKey(keys);
    return this.filters[key];
  };

  PromiseBaseCollection.prototype.setFilter = function() {
    var i, key, keys, limit, value;
    keys = 2 <= arguments.length ? slice.call(arguments, 0, i = arguments.length - 1) : (i = 0, []), value = arguments[i++];
    key = makeFilterKey(keys);
    if (this.filters == null) {
      this.filters = {};
    }
    this.filters[key] = value;
    limit = Helpers.trim(limit).toLowerCase();
    return this;
  };

  PromiseBaseCollection.prototype.toggleFilter = function() {
    var i, is_empty, keys, value;
    keys = 2 <= arguments.length ? slice.call(arguments, 0, i = arguments.length - 1) : (i = 0, []), value = arguments[i++];
    is_empty = (function() {
      switch (false) {
        case !_.isArray(value):
          return value.length === 0;
        case !_.isString(value):
          return value.length === 0;
        case !Falcon.isCollection(value):
          return value.length() === 0;
        default:
          return value == null;
      }
    })();
    if (is_empty) {
      this.clearFilter.apply(this, keys);
    } else {
      this.setFilter.apply(this, slice.call(keys).concat([value]));
    }
    return this;
  };

  PromiseBaseCollection.prototype.getIsPaged = function() {
    return this.is_paged;
  };

  PromiseBaseCollection.prototype.setIsPaged = function(is_paged) {
    this.is_paged = is_paged;
    return this;
  };

  PromiseBaseCollection.prototype.getPageSize = function() {
    return this.page_size;
  };

  PromiseBaseCollection.prototype.hasPageSize = function() {
    return this.page_size != null;
  };

  PromiseBaseCollection.prototype.setPageSize = function(size) {
    this.page_size = size;
    return this;
  };

  PromiseBaseCollection.prototype.getPageNumber = function() {
    return this.page_number;
  };

  PromiseBaseCollection.prototype.hasPageNumber = function() {
    return this.page_number != null;
  };

  PromiseBaseCollection.prototype.setPageNumber = function(number) {
    this.page_number = number;
    return this;
  };

  PromiseBaseCollection.prototype.hasSort = function() {
    return this.sort_key() != null;
  };

  PromiseBaseCollection.prototype.sortBy = function(key, direction, parameter) {
    if (direction == null) {
      direction = "asc";
    }
    if (parameter == null) {
      parameter = null;
    }
    if (key == null) {
      this.clearSort();
    }
    if (!_.isString(key)) {
      throw new Error("key must be a String");
    }
    this.setSortKey(key);
    this.setSortDirection(direction);
    this.setSortParameter(parameter);
    return this;
  };

  PromiseBaseCollection.prototype.clearSort = function() {
    this.sort_key(null);
    this.sort_direction(null);
    this.sort_parameter(null);
    return this;
  };

  PromiseBaseCollection.prototype.getSortQueryParam = function() {
    var sort_query_param;
    if (!this.hasSort()) {
      return null;
    }
    sort_query_param = "";
    if (this.getSortDirection() === "descending") {
      sort_query_param = "-";
    } else {
      sort_query_param = "+";
    }
    sort_query_param += this.getSortKey();
    if (this.hasSortParameter()) {
      sort_query_param += "[" + (this.getSortParameter()) + "]";
    }
    return sort_query_param;
  };

  PromiseBaseCollection.prototype.getSortKey = function() {
    return this.sort_key();
  };

  PromiseBaseCollection.prototype.hasSortKey = function() {
    return this.sort_key() != null;
  };

  PromiseBaseCollection.prototype.setSortKey = function(key) {
    this.sort_key(key);
    return this;
  };

  PromiseBaseCollection.prototype.getSortDirection = function() {
    var ref;
    if ((ref = this.sort_direction()) === "-" || ref === "desc" || ref === "descending") {
      return "descending";
    } else {
      return "ascending";
    }
  };

  PromiseBaseCollection.prototype.setSortDirection = function(sort_direction) {
    if (!_.isString(sort_direction)) {
      sort_direction = "ascending";
    }
    sort_direction = Helpers.trim(sort_direction).toLowerCase();
    if (sort_direction === "-" || sort_direction === "desc" || sort_direction === "descending") {
      this.sort_direction("descending");
    } else {
      this.sort_direction("ascending");
    }
    return this;
  };

  PromiseBaseCollection.prototype.toggleSortDirection = function() {
    if (this.getSortDirection() === "descending") {
      this.setSortDirection("ascending");
    } else {
      this.setSortDirection("descending");
    }
    return this;
  };

  PromiseBaseCollection.prototype.getSortParameter = function() {
    return this.sort_parameter();
  };

  PromiseBaseCollection.prototype.hasSortParameter = function() {
    return this.sort_parameter() != null;
  };

  PromiseBaseCollection.prototype.setSortParameter = function(parameter) {
    this.sort_parameter(parameter);
    return this;
  };

  PromiseBaseCollection.prototype.clearSortParameter = function() {
    return this.setSortParameter(null);
  };

  PromiseBaseCollection.prototype.clone = function() {
    var clone;
    clone = PromiseBaseCollection.__super__.clone.apply(this, arguments);
    clone.filters = _.clone(this.filters);
    clone.sort_key = this.sort_key;
    clone.sort_direction = this.sort_direction;
    clone.page_size = this.page_size;
    clone.page_number = this.page_number;
    return clone;
  };

  PromiseBaseCollection.prototype.reset = function() {
    var ret;
    ret = PromiseBaseCollection.__super__.reset.apply(this, arguments);
    this.page_size = null;
    this.page_number = null;
    this.hasNextPage(true);
    return ret;
  };

  PromiseBaseCollection.prototype.hardReset = function() {
    var ret;
    ret = this.reset();
    this.filters = null;
    this.sort_key = null;
    this.sort_direction = "+";
    return ret;
  };

  return PromiseBaseCollection;

})(Falcon.Collection);

},{}],33:[function(require,module,exports){
var PromiseBaseCollection, RegionContestStatistic, RegionContestStatistics,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseCollection = require("./promise.base.collection");

RegionContestStatistic = require("../$models/region_contest_statistic.model");

module.exports = RegionContestStatistics = (function(superClass) {
  extend(RegionContestStatistics, superClass);

  function RegionContestStatistics() {
    return RegionContestStatistics.__super__.constructor.apply(this, arguments);
  }

  RegionContestStatistics.prototype.model = RegionContestStatistic;

  RegionContestStatistics.prototype.label = "RegionContestStatistics";

  return RegionContestStatistics;

})(PromiseBaseCollection);

},{"../$models/region_contest_statistic.model":56,"./promise.base.collection":32}],34:[function(require,module,exports){
var PromiseBaseCollection, UserContestStatistic, UserContestStatistics,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseCollection = require("./promise.base.collection");

UserContestStatistic = require("../$models/user_contest_statistic.model");

module.exports = UserContestStatistics = (function(superClass) {
  extend(UserContestStatistics, superClass);

  function UserContestStatistics() {
    return UserContestStatistics.__super__.constructor.apply(this, arguments);
  }

  UserContestStatistics.prototype.model = UserContestStatistic;

  UserContestStatistics.prototype.label = "UserContestStatistics";

  return UserContestStatistics;

})(PromiseBaseCollection);

},{"../$models/user_contest_statistic.model":59,"./promise.base.collection":32}],35:[function(require,module,exports){
var PromiseBaseCollection, User, Users,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseCollection = require("./promise.base.collection");

User = require("../$models/user.model");

module.exports = Users = (function(superClass) {
  extend(Users, superClass);

  function Users() {
    return Users.__super__.constructor.apply(this, arguments);
  }

  Users.prototype.model = User;

  Users.prototype.label = "Users";

  return Users;

})(PromiseBaseCollection);

},{"../$models/user.model":58,"./promise.base.collection":32}],36:[function(require,module,exports){
module.exports = {
  URL_REGEX: /(https?:\/\/)?(([^\s]+\.)?[^\s]+\.[^\s]+)/gi,
  STRICT_URL_REGEX: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]+)([\/\w \.-]*)*\/?$/i,
  EMAIL_REGEX: /^([a-z0-9_\.\+\-]+)@([\da-z\.\+\-]+)\.([a-z\.]+)$/i,
  PASSWORD_REGEX: /^([^\s]{5}[^\s]+)$/i,
  HASHTAG_REGEX: /#([a-zA-Z0-9\-_]+)/gi,
  HTML_TAG_REGEX: /<[^>]+>/gi,
  DATE_FORMAT: "M/D/YYYY"
};

},{}],37:[function(require,module,exports){
var STATES;

STATES = [];

STATES.push(STATES['AL'] = {
  abbr: "AL",
  name: "Alabama"
});

STATES.push(STATES['AK'] = {
  abbr: "AK",
  name: "Alaska"
});

STATES.push(STATES['AZ'] = {
  abbr: "AZ",
  name: "Arizona"
});

STATES.push(STATES['AR'] = {
  abbr: "AR",
  name: "Arkansas"
});

STATES.push(STATES['CA'] = {
  abbr: "CA",
  name: "California"
});

STATES.push(STATES['CO'] = {
  abbr: "CO",
  name: "Colorado"
});

STATES.push(STATES['CT'] = {
  abbr: "CT",
  name: "Connecticut"
});

STATES.push(STATES['DE'] = {
  abbr: "DE",
  name: "Delaware"
});

STATES.push(STATES['DC'] = {
  abbr: "DC",
  name: "District Of Columbia"
});

STATES.push(STATES['FL'] = {
  abbr: "FL",
  name: "Florida"
});

STATES.push(STATES['GA'] = {
  abbr: "GA",
  name: "Georgia"
});

STATES.push(STATES['HI'] = {
  abbr: "HI",
  name: "Hawaii"
});

STATES.push(STATES['ID'] = {
  abbr: "ID",
  name: "Idaho"
});

STATES.push(STATES['IL'] = {
  abbr: "IL",
  name: "Illinois"
});

STATES.push(STATES['IN'] = {
  abbr: "IN",
  name: "Indiana"
});

STATES.push(STATES['IA'] = {
  abbr: "IA",
  name: "Iowa"
});

STATES.push(STATES['KS'] = {
  abbr: "KS",
  name: "Kansas"
});

STATES.push(STATES['KY'] = {
  abbr: "KY",
  name: "Kentucky"
});

STATES.push(STATES['LA'] = {
  abbr: "LA",
  name: "Louisiana"
});

STATES.push(STATES['ME'] = {
  abbr: "ME",
  name: "Maine"
});

STATES.push(STATES['MD'] = {
  abbr: "MD",
  name: "Maryland"
});

STATES.push(STATES['MA'] = {
  abbr: "MA",
  name: "Massachusetts"
});

STATES.push(STATES['MI'] = {
  abbr: "MI",
  name: "Michigan"
});

STATES.push(STATES['MN'] = {
  abbr: "MN",
  name: "Minnesota"
});

STATES.push(STATES['MS'] = {
  abbr: "MS",
  name: "Mississippi"
});

STATES.push(STATES['MO'] = {
  abbr: "MO",
  name: "Missouri"
});

STATES.push(STATES['MT'] = {
  abbr: "MT",
  name: "Montana"
});

STATES.push(STATES['NE'] = {
  abbr: "NE",
  name: "Nebraska"
});

STATES.push(STATES['NV'] = {
  abbr: "NV",
  name: "Nevada"
});

STATES.push(STATES['NH'] = {
  abbr: "NH",
  name: "New Hampshire"
});

STATES.push(STATES['NJ'] = {
  abbr: "NJ",
  name: "New Jersey"
});

STATES.push(STATES['NM'] = {
  abbr: "NM",
  name: "New Mexico"
});

STATES.push(STATES['NY'] = {
  abbr: "NY",
  name: "New York"
});

STATES.push(STATES['NC'] = {
  abbr: "NC",
  name: "North Carolina"
});

STATES.push(STATES['ND'] = {
  abbr: "ND",
  name: "North Dakota"
});

STATES.push(STATES['OH'] = {
  abbr: "OH",
  name: "Ohio"
});

STATES.push(STATES['OK'] = {
  abbr: "OK",
  name: "Oklahoma"
});

STATES.push(STATES['OR'] = {
  abbr: "OR",
  name: "Oregon"
});

STATES.push(STATES['PA'] = {
  abbr: "PA",
  name: "Pennsylvania"
});

STATES.push(STATES['RI'] = {
  abbr: "RI",
  name: "Rhode Island"
});

STATES.push(STATES['SC'] = {
  abbr: "SC",
  name: "South Carolina"
});

STATES.push(STATES['SD'] = {
  abbr: "SD",
  name: "South Dakota"
});

STATES.push(STATES['TN'] = {
  abbr: "TN",
  name: "Tennessee"
});

STATES.push(STATES['TX'] = {
  abbr: "TX",
  name: "Texas"
});

STATES.push(STATES['UT'] = {
  abbr: "UT",
  name: "Utah"
});

STATES.push(STATES['VT'] = {
  abbr: "VT",
  name: "Vermont"
});

STATES.push(STATES['VA'] = {
  abbr: "VA",
  name: "Virginia"
});

STATES.push(STATES['WA'] = {
  abbr: "WA",
  name: "Washington"
});

STATES.push(STATES['WV'] = {
  abbr: "WV",
  name: "West Virginia"
});

STATES.push(STATES['WI'] = {
  abbr: "WI",
  name: "Wisconsin"
});

STATES.push(STATES['WY'] = {
  abbr: "WY",
  name: "Wyoming"
});

module.exports = STATES;

},{}],38:[function(require,module,exports){
var EMAIL_REGEX, Helpers, PASSWORD_REGEX, STRICT_URL_REGEX, URL_REGEX, ref;

ref = require("../$constants/default.constants"), URL_REGEX = ref.URL_REGEX, EMAIL_REGEX = ref.EMAIL_REGEX, STRICT_URL_REGEX = ref.STRICT_URL_REGEX, PASSWORD_REGEX = ref.PASSWORD_REGEX;

module.exports = Helpers = new ((function() {
  function _Class() {}

  _Class.prototype.IS_SAFARI = navigator.userAgent.indexOf("Safari") > -1;

  _Class.prototype.trim = (function() {
    if (String.prototype.trim != null) {
      return function(str) {
        return String.prototype.trim.call((str != null ? str : "").toString());
      };
    } else {
      return function(str) {
        return (str != null ? str : "").toString().replace(/^\s+/, '').replace(/\s+$/, '');
      };
    }
  })();

  _Class.prototype.trimSlashes = function(str) {
    return (str != null ? str : "").toString().replace(/^\/+/, '').replace(/\/+$/, '');
  };

  _Class.prototype.reduceSlashes = function(str) {
    return Helpers.trimSlashes(str).replace(/\/\/+/gi, '/');
  };

  _Class.prototype.injectHTMLEntities = function(str) {
    return str.replace("&", "&amp;").replace("<", "&lt;").replace(">", "&gt;").replace("  ", " &nbsp;");
  };

  _Class.prototype.injectAnchorTags = function(str) {
    var label, match, protocol, regex, returned_str, start_index, url;
    returned_str = "";
    regex = new RegExp(URL_REGEX);
    start_index = 0;
    while (match = regex.exec(str)) {
      returned_str += str.slice(start_index, match.index);
      start_index = regex.lastIndex;
      label = match[0], protocol = match[1], url = match[2];
      if (protocol == null) {
        protocol = "http://";
      }
      url = protocol + url;
      returned_str += "<a href=\"" + url + "\">" + label + "</a>";
    }
    returned_str += str.slice(start_index);
    return returned_str;
  };

  _Class.prototype.concat = function() {
    var arg, i, len, ret;
    ret = "";
    for (i = 0, len = arguments.length; i < len; i++) {
      arg = arguments[i];
      arg = ko.unwrap(arg);
      if (arg != null) {
        ret += arg.toString();
      }
    }
    return ret;
  };

  _Class.prototype.join = function(arr, glue) {
    arr = ko.unwrap(arr);
    if (!_.isArray(arr)) {
      arr = [];
    }
    return arr.join(glue);
  };

  _Class.prototype.isEmail = function(emailStr) {
    emailStr = ko.unwrap(emailStr);
    if (!_.isString(emailStr)) {
      return false;
    }
    emailStr = Helpers.trim(emailStr);
    return (new RegExp(EMAIL_REGEX)).test(emailStr);
  };

  _Class.prototype.isUrl = function(urlStr) {
    urlStr = ko.unwrap(urlStr);
    if (!_.isString(urlStr)) {
      return false;
    }
    urlStr = Helpers.trim(urlStr);
    return (new RegExp(STRICT_URL_REGEX)).test(urlStr);
  };

  _Class.prototype.hasUrl = function(string) {
    if (!_.isString(string)) {
      return false;
    }
    return (new RegExp(URL_REGEX)).test(string);
  };

  _Class.prototype.isPassword = function(password) {
    password = ko.unwrap(password);
    if (!_.isString(password)) {
      return false;
    }
    return (new RegExp(PASSWORD_REGEX)).test(password);
  };

  _Class.prototype.makeErrorData = function(error) {
    return {
      errors: [error]
    };
  };

  _Class.prototype.parseError = function(response, default_human) {
    var ref1;
    if (default_human == null) {
      default_human = "An error occurred";
    }
    if (response instanceof Error) {
      return {
        human: response.message
      };
    }
    if (!_.isObject(response)) {
      return {
        human: default_human
      };
    }
    if (!response.hasOwnProperty('human')) {
      return {
        human: default_human
      };
    }
    return {
      human: (ref1 = response.human) != null ? ref1 : default_human,
      validations: {}
    };
  };

  _Class.prototype.parseDate = function(date_string) {
    var date;
    date = date_string;
    return date;
  };

  _Class.prototype.parseInt = function(value) {
    if (value === null) {
      return null;
    }
    value = parseInt(value);
    if (_.isNaN(value)) {
      return null;
    } else {
      return value;
    }
  };

  _Class.prototype.pluralize = function(count, one_label, many_label) {
    count = ko.unwrap(count);
    if (count === 1) {
      return count + " " + one_label;
    } else {
      return count + " " + many_label;
    }
  };

  _Class.prototype.possessive = function(obs) {
    var value;
    value = Helpers.trim(ko.unwrap(obs));
    if (!_.isString(value)) {
      return "";
    }
    if (value.lastIndexOf("s") === value.length - 1) {
      return value + "'";
    } else {
      return value + "'s";
    }
  };

  _Class.prototype.toggle = function(predicate, true_value, false_value) {
    predicate = ko.unwrap(predicate);
    if (_.isNumber(predicate)) {
      predicate = predicate === 1;
    }
    return (predicate ? true_value : false_value);
  };

  _Class.prototype.isLessThan = function(a, b) {
    a = ko.unwrap(a);
    b = ko.unwrap(b);
    return a < b;
  };

  _Class.prototype.isGreaterThan = function(a, b) {
    a = ko.unwrap(a);
    b = ko.unwrap(b);
    return a > b;
  };

  _Class.prototype.isBetween = function(count, min, max) {
    count = ko.unwrap(count);
    if (count <= min) {
      return false;
    }
    if (count >= max) {
      return false;
    }
    return true;
  };

  _Class.prototype.isntBetween = function(count, min, max) {
    return !Helpers.isBetween.apply(Helpers, arguments);
  };

  _Class.prototype.not = function(value) {
    return !ko.unwrap(value);
  };

  _Class.prototype.formatUrl = function(url) {
    var has_protocol;
    url = Helpers.trim(ko.unwrap(url));
    has_protocol = (url.toLowerCase().indexOf("http://") === 0) || (url.toLowerCase().indexOf("https://") === 0);
    if (!has_protocol) {
      url = "http://" + url;
    }
    return url;
  };

  _Class.prototype.compare = function(a, b) {
    a = ko.unwrap(a);
    b = ko.unwrap(b);
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  };

  _Class.prototype.compareInt = function(a, b) {
    a = parseInt(ko.unwrap(a));
    b = parseInt(ko.unwrap(b));
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  };

  _Class.prototype.compareFloat = function(a, b) {
    a = parseFloat(ko.unwrap(a));
    b = parseFloat(ko.unwrap(b));
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  };

  _Class.prototype.regexIndexOf = function(str, regex, offset) {
    var index;
    if (offset == null) {
      offset = 0;
    }
    if (!_.isString(str)) {
      return -1;
    }
    if (!_.isRegExp(regex)) {
      return -1;
    }
    index = str.substring(offset).search(regex);
    return (index < 0 ? -1 : index + offset);
  };

  _Class.prototype.randomId = function() {
    return Math.floor(Math.random() * 1000000000 + 1);
  };

  _Class.prototype.hasWord = function(string, word) {
    var regex, regex_str;
    string = Helpers.trim(ko.unwrap(string)) + " ";
    regex_str = Helpers.trim(ko.unwrap(word)).replace(/([!$^{[.+\\(?])/gi, "\\$1");
    regex = new RegExp(regex_str + "([^a-zA-Z0-9-_])", "gi");
    return regex.test(string);
  };

  _Class.prototype.equals = function(one, two, strict) {
    if (strict == null) {
      strict = true;
    }
    if (strict) {
      return ko.unwrap(one) === ko.unwrap(two);
    } else {
      return ko.unwrap(one) === ko.unwrap(two);
    }
  };

  _Class.prototype.padLeft = function(string, padding, length) {
    if (!((padding != null) && padding.length > 0)) {
      return string;
    }
    while (string.length < length) {
      string = "" + padding + string;
    }
    return string;
  };

  return _Class;

})());

},{"../$constants/default.constants":36}],39:[function(require,module,exports){
var DOMHelpers;

window.DOMHelpers = module.exports = DOMHelpers = new ((function() {
  function _Class() {}

  _Class.prototype.defer = function(duration, callback) {
    var ref;
    if (_.isFunction(duration)) {
      ref = [duration, null], callback = ref[0], duration = ref[1];
    }
    if (_.isNumber(duration)) {
      return setTimeout((function() {
        return requestAnimationFrame(callback);
      }), duration);
    } else {
      return setTimeout(function() {
        return requestAnimationFrame(callback);
      });
    }
  };

  _Class.prototype.classList = function(element) {
    var classList, item, ref;
    if (element == null) {
      return [];
    }
    if ('classList' in element) {
      return element.classList;
    }
    classList = ((ref = element.className) != null ? ref : "").replace(/\s+/, " ").split(" ");
    classList = (function() {
      var j, len, results;
      results = [];
      for (j = 0, len = classList.length; j < len; j++) {
        item = classList[j];
        if (item.length > 0) {
          results.push(item);
        }
      }
      return results;
    })();
    classList.contains = function(item) {
      return Array.prototype.indexOf.call(classList, item) > -1;
    };
    return classList;
  };

  _Class.prototype.findScrollParent = function(element) {
    var parent, ref;
    parent = element.parentNode;
    if (parent == null) {
      return element;
    }
    if ((parent === document.body) || ((ref = window.getComputedStyle(parent).overflowY) === 'auto' || ref === 'scroll')) {
      return parent;
    }
    return DOMHelpers.findScrollParent(parent);
  };

  _Class.prototype.findFormParent = function(element) {
    var parent, ref;
    if ((parent = element.parentNode) == null) {
      return null;
    }
    if (((ref = parent.tagName) != null ? ref : "").toString().toLowerCase() === "form") {
      return parent;
    }
    return DOMHelpers.findFormParent(parent);
  };

  _Class.prototype.findParentByTagName = function(element, tag_name) {
    var parent;
    tag_name = tag_name.toLowerCase();
    parent = element.parentNode;
    while ((parent != null) && parent.nodeType !== Node.ELEMENT_NODE) {
      parent = parent.parentNode;
    }
    if (parent == null) {
      return null;
    }
    if (parent.tagName.toLowerCase() === tag_name) {
      return parent;
    }
    return DOMHelpers.findParentByTagName(parent, tag_name);
  };

  _Class.prototype.findParentByClassName = function(element, class_name) {
    var parent;
    parent = element.parentNode;
    while ((parent != null) && parent.nodeType !== Node.ELEMENT_NODE) {
      parent = parent.parentNode;
    }
    if (parent == null) {
      return null;
    }
    if (DOMHelpers.classList(parent).contains(class_name)) {
      return parent;
    }
    return DOMHelpers.findParentByClassName(parent, class_name);
  };

  _Class.prototype.findSiblingByClassName = function(element, class_name) {
    var sibling;
    sibling = element.nextSibling;
    while ((sibling != null) && sibling.nodeType !== Node.ELEMENT_NODE) {
      sibling = sibling.nextSibling;
    }
    if (sibling == null) {
      return null;
    }
    if (DOMHelpers.classList(sibling).contains(class_name)) {
      return sibling;
    }
    return DOMHelpers.findSiblingByClassName(sibling, class_name);
  };

  _Class.prototype.findDescendantByClassName = function(element, class_name) {
    return element.querySelector("." + class_name);
  };

  _Class.prototype.hasClass = function(element, className) {
    return DOMHelpers.classList(element).contains(className);
  };

  _Class.prototype.addClass = function(element, className) {
    if (element == null) {
      return this;
    }
    if ('classList' in element) {
      if (!element.classList.contains(className)) {
        element.classList.add(className);
      }
    } else {
      if (!DOMHelpers.classList(element).contains(className)) {
        element.className += " " + className;
      }
    }
    return this;
  };

  _Class.prototype.addClassAsync = function(element, className) {
    DOMHelpers.defer(67, function() {
      return DOMHelpers.addClass(element, className);
    });
    return this;
  };

  _Class.prototype.removeClass = function(element, className) {
    if (element == null) {
      return this;
    }
    if ('classList' in element) {
      if (element.classList.contains(className)) {
        element.classList.remove(className);
      }
    } else {
      element.className = element.className.replace(className, "");
    }
    return this;
  };

  _Class.prototype.removeClassAsync = function(element, className) {
    DOMHelpers.defer(67, function() {
      return DOMHelpers.removeClass(element, className);
    });
    return this;
  };

  _Class.prototype.toggleClass = function(element, className, predicate) {
    if (predicate) {
      DOMHelpers.addClass(element, className);
    } else {
      DOMHelpers.removeClass(element, className);
    }
    return this;
  };

  _Class.prototype.toggleClassAsync = function(element, className, predicate) {
    DOMHelpers.defer(function() {
      return DOMHelpers.toggleClass(element, className, predicate);
    });
    return this;
  };

  _Class.prototype.hasPreviousSibling = function(element) {
    var previous;
    previous = element.previousSibling;
    if (previous == null) {
      return false;
    }
    if (previous.nodeType === Node.ELEMENT_NODE) {
      return true;
    }
    return DOMHelpers.hasPreviousSibling(previous);
  };

  _Class.prototype.hasNextSibling = function(element) {
    var next;
    next = element.nextSibling;
    if (next == null) {
      return false;
    }
    if (next.nodeType === Node.ELEMENT_NODE) {
      return true;
    }
    return DOMHelpers.hasNextSibling(next);
  };

  _Class.prototype.removeNode = function(element) {
    element.parentNode.removeChild(element);
    return this;
  };

  _Class.prototype.getDuration = function(element) {
    var computed_duration, duration;
    computed_duration = window.getComputedStyle(element).transitionDuration;
    duration = parseFloat(computed_duration);
    return Math.floor(duration * 1000);
  };

  _Class.prototype.scrollToInputElement = function(element, scroll_parent) {
    var $element, ref, ref1;
    if (scroll_parent == null) {
      scroll_parent = DOMHelpers.findScrollParent(element);
    }
    if (!((element != null) && (scroll_parent != null))) {
      return;
    }
    if ((ref = window.getComputedStyle(element).position) === 'absolute' || ref === 'fixed') {
      return;
    }
    if ((ref1 = element.tagName.toLowerCase()) !== 'input' && ref1 !== 'textarea') {
      return;
    }
    $element = $(element);
    return scroll_parent.scrollTop = $element.offset().top + $element.outerHeight();
  };

  _Class.prototype.getTransformString = function(element) {
    var computed_style;
    computed_style = window.getComputedStyle(element, null);
    return computed_style.getPropertyValue('transform') || computed_style.getPropertyValue('-webkit-transform') || computed_style.getPropertyValue('-moz-transform') || computed_style.getPropertyValue('-ms-transform') || computed_style.getPropertyValue('-o-transform');
  };

  _Class.prototype.setTransform = function(element, transformString) {
    element.style.webkitTransform = transformString;
    element.style.MozTransform = transformString;
    element.style.msTransform = transformString;
    element.style.OTransform = transformString;
    element.style.transform = transformString;
    return this;
  };

  _Class.prototype.removeTransform = function(element) {
    element.style.webkitTransform = null;
    element.style.MozTransform = null;
    element.style.msTransform = null;
    element.style.OTransform = null;
    element.style.transform = null;
    return this;
  };

  _Class.prototype.afterTransition = function(element, callback) {
    var _callback, duration, timeout;
    duration = DOMHelpers.getDuration(element);
    timeout = null;
    _callback = function() {
      element.removeEventListener("webkitTransitionEnd", _callback);
      if (timeout != null) {
        clearTimeout(timeout);
      }
      _callback = null;
      return callback();
    };
    element.addEventListener("webkitTransitionEnd", _callback);
    if (duration) {
      timeout = setTimeout(_callback, duration + 50);
    }
    return this;
  };

  _Class.prototype.setOpacity = function(element, opacity) {
    element.style.opacity = opacity;
    element.style.filter = "alpha(opacity=" + (opacity * 100) + ")";
    return this;
  };

  _Class.prototype.setScale = function(element, scale_x, scale_y) {
    if (scale_y == null) {
      scale_y = scale_x;
    }
    DOMHelpers.setTransform(element, 'scale(#{scale_x}, #{scale_y})');
    return this;
  };

  _Class.prototype.getStyle = function(element, key) {
    var ref;
    return (ref = window.getComputedStyle(element)) != null ? ref[key] : void 0;
  };

  _Class.prototype.hideKeyboard = function() {
    var activeElement;
    if ((activeElement = document.activeElement) == null) {
      return this;
    }
    activeElement.blur();
    return this;
  };

  _Class.prototype.getOffsetTop = function(element) {
    var offsetParent, parentOffsetTop, ref, ref1;
    offsetParent = element.offsetParent;
    parentOffsetTop = 0;
    if ((offsetParent != null ? offsetParent.nodeType : void 0) === Node.ELEMENT_NODE) {
      parentOffsetTop = (ref = DOMHelpers.getOffsetTop(offsetParent)) != null ? ref : 0;
    }
    return ((ref1 = element.offsetTop) != null ? ref1 : 0) + parentOffsetTop;
  };

  _Class.prototype.findNodeByClassName = function(node_list, class_name) {
    var j, len, node;
    for (j = 0, len = node_list.length; j < len; j++) {
      node = node_list[j];
      if (node.nodeType === Node.ELEMENT_NODE) {
        if (DOMHelpers.classList(node).contains(class_name)) {
          return node;
        }
      }
    }
    return null;
  };

  _Class.prototype.getCaretPosition = function(element) {
    var $document, $window, pre_caret_range, range, ref, ref1, selection, text_range;
    $document = (ref = element.ownerDocument) != null ? ref : element.document;
    $window = (ref1 = $document.defaultView) != null ? ref1 : $document.parentWindow;
    if ('getSelection' in $window) {
      selection = $window.getSelection();
      if (!(selection.rangeCount > 0)) {
        return 0;
      }
      range = selection.getRangeAt(0);
      pre_caret_range = range.cloneRange();
      pre_caret_range.selectNodeContents(element);
      pre_caret_range.setEnd(range.endContainer, range.endOffset);
      return pre_caret_range.toString().length;
    } else if ((selection = $document.selection) && selection.type !== "Control") {
      text_range = selection.createRange();
      pre_caret_range = $document.body.createTextRange();
      pre_caret_range.moveToElementText(element);
      pre_caret_range.setEndPoint("EndToEnd", text_range);
      return pre_caret_range.text.length;
    }
    return 0;
  };

  _Class.prototype.setCaretPosition = function(node, offset) {
    var range, recurse, result, selection;
    if (node == null) {
      return;
    }
    recurse = function(node) {
      var j, len, ref, result;
      if (node.nodeType === Node.TEXT_NODE) {
        return {
          node: node,
          offset: offset
        };
      }
      ref = node.childNodes;
      for (j = 0, len = ref.length; j < len; j++) {
        node = ref[j];
        if (typeof result !== "undefined" && result !== null) {
          return result;
        }
        switch (node.nodeType) {
          case Node.TEXT_NODE:
            if (offset <= node.length) {
              return {
                node: node,
                offset: offset
              };
            }
            offset -= node.length;
            break;
          case Node.ELEMENT_NODE:
            result = recurse(node);
            if (result != null) {
              return result;
            }
        }
      }
      return null;
    };
    result = recurse(node);
    if (result != null) {
      node = result.node, offset = result.offset;
      range = document.createRange();
      selection = window.getSelection();
      range.setStart(node, offset);
      range.collapse(true);
      selection.removeAllRanges();
      return selection.addRange(range);
    }
  };

  _Class.prototype.getCaretNode = function(element) {
    var node, selection;
    selection = typeof window.getSelection === "function" ? window.getSelection() : void 0;
    if (selection == null) {
      return null;
    }
    node = selection.anchorNode;
    if (node == null) {
      return null;
    }
    if (!element.contains(node)) {
      return null;
    }
    return node;
  };

  _Class.prototype.injectNodeAtCaret = function(node) {
    var range, selection;
    selection = window.getSelection();
    if (selection.rangeCount > 0) {
      range = selection.getRangeAt(0);
      range.deleteContents();
      range.insertNode(node);
      range.setStartAfter(node);
      range.collapse(true);
      selection.removeAllRanges();
      return selection.addRange(range);
    }
  };

  _Class.prototype.collapseAllHighlghts = function() {
    var ref;
    return (ref = window.getSelection()) != null ? ref.removeAllRanges() : void 0;
  };

  _Class.prototype.collapseHighlight = function() {
    var endContainer, endOffset, range, ref, selection;
    selection = window.getSelection();
    if (!(selection.rangeCount > 0)) {
      return 0;
    }
    ref = selection.getRangeAt(0), endOffset = ref.endOffset, endContainer = ref.endContainer;
    selection.removeAllRanges();
    range = document.createRange();
    range.setStart(endContainer, endOffset);
    range.collapse(true);
    return selection.addRange(range);
  };

  _Class.prototype.highlight = function(element, start_offset, end_offset) {
    var childNode, currentNode, endNode, j, len, previousNode, range, ref, selection, startNode;
    if (!_.isNumber(start_offset)) {
      return;
    }
    if (!_.isNumber(end_offset)) {
      return;
    }
    if (!(start_offset < end_offset)) {
      return;
    }
    range = document.createRange();
    selection = window.getSelection();
    startNode = null;
    endNode = null;
    currentNode = null;
    previousNode = null;
    ref = element.childNodes;
    for (j = 0, len = ref.length; j < len; j++) {
      childNode = ref[j];
      previousNode = currentNode;
      currentNode = childNode;
      while (currentNode.childNodes.length > 0) {
        currentNode = currentNode.childNodes[0];
      }
      if (previousNode != null) {
        if (startNode == null) {
          start_offset -= previousNode.length;
        }
        if (endNode == null) {
          end_offset -= previousNode.length;
        }
      }
      if ((startNode == null) && start_offset <= currentNode.length) {
        startNode = currentNode;
      }
      if ((endNode == null) && end_offset <= currentNode.length) {
        endNode = currentNode;
      }
      if ((startNode != null) && (endNode != null)) {
        break;
      }
    }
    if (startNode == null) {
      startNode = element;
    }
    if (endNode == null) {
      endNode = currentNode;
    }
    if ((startNode != null) && (endNode != null)) {
      range.setStart(startNode, start_offset);
      range.setEnd(endNode, end_offset);
      selection.removeAllRanges();
      return selection.addRange(range);
    }
  };

  _Class.prototype.hasSelection = function(element) {
    var i, j, range, ref, selection;
    selection = window.getSelection();
    if (!(selection.rangeCount > 0)) {
      return false;
    }
    for (i = j = 0, ref = selection.rangeCount; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
      range = selection.getRangeAt(i);
      if (!range.collapsed) {
        if (element.contains(range.startContainer)) {
          return true;
        }
        if (element.contains(range.endContainer)) {
          return true;
        }
      }
    }
    return false;
  };

  _Class.prototype.getText = function(node) {
    switch (false) {
      case !('textContent' in node):
        return node.textContent;
      case !('text' in node):
        return node.text;
      case !('innerText' in node):
        return node.innerText;
      case !('data' in node):
        return node.data;
      default:
        throw new Error("Could not get text of node");
    }
  };

  _Class.prototype.setText = function(node, text) {
    switch (false) {
      case !('textContent' in node):
        return node.textContent = text;
      case !('text' in node):
        return node.text = text;
      case !('innerText' in node):
        return node.innerText = text;
      case !('data' in node):
        return node.data = text;
      default:
        throw new Error("Could not set text of node");
    }
  };

  _Class.prototype.concatText = function(target_text_node, text) {
    switch (false) {
      case !('textContent' in target_text_node):
        return target_text_node.textContent += text;
      case !('text' in target_text_node):
        return target_text_node.text += text;
      case !('innerText' in target_text_node):
        return target_text_node.innerText += text;
      case !('data' in target_text_node):
        return target_text_node.data += text;
      default:
        throw new Error("Could not set text of node");
    }
  };

  return _Class;

})());

},{}],40:[function(require,module,exports){
var RequestHelpers;

module.exports = RequestHelpers = new ((function() {
  var UNAUTHORIZED;

  function _Class() {}

  UNAUTHORIZED = {
    human: "Session Expired"
  };

  _Class.prototype.preparePromiseOptions = function(resolve, reject, options, default_human_error) {
    var _error, _success;
    if (_.isFunction(options)) {
      options = {
        complete: options
      };
    }
    if (!_.isObject(options)) {
      options = {};
    }
    _success = options.success;
    options.success = function(model) {
      resolve(model);
      if (_.isFunction(_success)) {
        return _success.apply(this, arguments);
      }
    };
    _error = options.error;
    options.error = function(model, error, options, arg) {
      var xhr;
      xhr = arg.xhr;
      error = (function() {
        var ref;
        switch (parseInt((ref = xhr != null ? xhr.status : void 0) != null ? ref : 0)) {
          case 401:
            return UNAUTHORIZED;
          default:
            return Helpers.parseError(error, default_human_error);
        }
      })();
      reject(error);
      if (_.isFunction(_error)) {
        return _error.apply(this, arguments);
      }
    };
    return options;
  };

  _Class.prototype.isUnauthorized = function(error) {
    return error === UNAUTHORIZED;
  };

  return _Class;

})());

},{}],41:[function(require,module,exports){
module.exports = {
  code: "en/ca",
  translations: {
    "USA/English": "Canada/English",
    "Enter Your Game Code": "Enter Your Game Code"
  }
};

},{}],42:[function(require,module,exports){
module.exports = {
  code: "en/us",
  translations: {
    "USA/English": "USA/English",
    "Enter Your Game Code": "Enter Your Game Code"
  }
};

},{}],43:[function(require,module,exports){
var AgraveUni, CcedillaUni, EacuteUni, EcircUni, EgraveUni, agraveUni, ccedillaUni, eacuteUni, ecircUni, egraveUni;

AgraveUni = "\u00C0";

CcedillaUni = "\u00C7";

EgraveUni = "\u00C8";

EacuteUni = "\u00C9";

EcircUni = "\u00CA";

agraveUni = "\u00E0";

ccedillaUni = "\u00E7";

egraveUni = "\u00E8";

eacuteUni = "\u00E9";

ecircUni = "\u00EA";

module.exports = {
  code: "fr/ca",
  translations: {
    "USA/English": "Canada/Fran" + ccedillaUni + "ais",
    "Snap-on Rollin' Cold!": "Snap-on Rollin' Cold!",
    "Sign In": "Ouvrir une session",
    "Sign Out": "Fermer une session",
    "Rule the Road 2017": "Rule the Road 2017",
    "Win a Snap-on® special edition Traxxax® X-Maxx Monster Truck": "Gagnez un Monster Truck Snap-on® Traxxas® X-Maxx " + EacuteUni + "dition sp" + eacuteUni + "ciale",
    "Every entry also gives you a chance to win.": "Chaque bulletin vous donne une chance de gagner.",
    "Snap-on® Shopping Spree $5,000": "Magasinage en folie Snap-on® de 5 000 $",
    "$50,000 Tool Package": "50 000 $ en outils",
    "Contest Re-opens soon!": "Le concours commence bientôt!",
    "Own the Water 2017": "Own the Water 2017",
    "Win a Snap-on® special edition Traxxas® DCB M41 Widebody 4” Race Boat": "Gagnez un bateau de course Snap-on® Traxxas DCB M41 Widebody 41 po " + EacuteUni + "dition sp" + eacuteUni + "ciale",
    "Enter Your Game Code": "ENTRER VOTRE CODE",
    "Continue": "CONTINUER",
    "Email": "Courriel",
    "Snap-on is a trademark of Snap-on Incorporated.": "SNAP-ON EST UNE MARQUE DE COMMERCE DE SNAP-ON INCORPORATED.",
    "&copy;Snap-on Incorporated 2017.": "&copy;SNAP-ON INCORPORATED 2017.",
    "All other marks are trademarks of their respective holders.": "TOUTES LES AUTRES MARQUES DE COMMERCE SONT LA PROPRI" + EacuteUni + "T" + EacuteUni + " DE LEUR D" + EacuteUni + "TENTEUR RESPECTIF.",
    "Privacy": "CONFIDENTIALIT" + EacuteUni,
    "Terms of Use": "CONDITIONS D'UTILISATION",
    "Official Rules": "R" + EgraveUni + "GLEMENT OFFICIEL",
    "We think you're in the": "Nous pensons que vous " + EcircUni + "tes r" + EacuteUni + "sidents de",
    "Is that correct?": "Est-ce exact?",
    "Excellent!": "Excellent!",
    "is a valid code.": "est un code valide.",
    "Sign in or register to claim this entry": "Ouvrir une session ou s'inscrire pour r" + eacuteUni + "clamer votre bulletin",
    "Sign In": "Ouvrir une session",
    "Register": "S'inscrire",
    "Your Email Address": "Votre adresse de courriel",
    "Password": "Mot de passe",
    "Enter your Password": "Entrer votre mot de passe",
    "Enter Your Password": "Entrer votre mot de passe",
    "Keep me signed in": "Garder ma session ouverte",
    "Continue": "Continuer",
    "Forgot Your Password?": "Vous avez oubli" + eacuteUni + " votre mot de passe?",
    "Name - First Name Last Name": "Nom - Pr" + eacuteUni + "nom",
    "Name": "Nom",
    "Your Name": "Votre nom",
    "Email Address": "ADRESSE DE COURRIEL",
    "Your Email Address": "Votre adresse de courriel",
    "Phone Number": "NUM" + EacuteUni + "RO DE T" + EacuteUni + "L" + EacuteUni + "PHONE",
    "Your Phone Number": "Votre num" + EacuteUni + "ro de t" + EacuteUni + "l" + EacuteUni + "phone",
    "PASSWORD": "MOT DE PASSE",
    "Choose A Password": "Choisir un mot de passe",
    "Verify Password": "V" + EacuteUni + "RIFIER LE MOT DE PASSE",
    "Verify Your Password": "V" + EacuteUni + "rifier le mot de passe",
    "Check this box to verify that you have read the": "Cochez cette case pour confirmer que vous avez lu",
    "official rules": "les r" + EgraveUni + "glements officiels",
    "(Official Rules)": "(les r" + EgraveUni + "glements officiels)",
    "Opt-in for a chance to win the Custom Snap-on RC Truck or Boat": "S'inscrire pour courir la chance de gagner une t" + EacuteUni + "l" + EacuteUni + "commande pour bateau ou camion Snap-on.",
    "(See your Snap-on franchisee for contest rules)": "(voir votre franchis" + EacuteUni + " Snap-on pour les d" + EacuteUni + "tails)",
    "Opt-in for a chance to win the 5,000 Snap-on Shopping Spree": "S'inscrire pour courir la chance de gagner un magasinage en folie Snap-on de 5 000 $.",
    "Opt-in for a chance to win the 50,000 Ultimate Snap-on Tool Set": "S'inscrire pour courir la chance de gagner un ensemble ultime de 50 000 $ en outils.",
    "Would you like Snap-on Tools <br /> to send you game updates?": "Voulez-vous que Outils Snap-on <br /> vous envoie des mises " + AgraveUni + " jour sur le concours?",
    "Send me Snap-on game updates, newsletters and promotions by email.": "Envoyez-moi des mises " + AgraveUni + " jour, des bulletins " + EacuteUni + "lectroniques et des promotions par courriel.",
    "YOU'RE ENTERED [FIRST NAME]!": "VOUS ÊTES INSCRIT [PR" + EacuteUni + "NOM]!",
    "GOOD LUCK!": "BONNE CHANCE!",
    "YOU'VE JUST ADDED [X] ENTRY FOR THIS DRAWING": "VOUS VENEZ D'AJOUTER [X] BULLETIN(S) POUR CE TIRAGE.",
    "Entries in this phase": "Bulletin(s) dans cette phase",
    "Days Until Prize Drawing": "Jour(s) avant le tirage",
    "Days Until Contest Opens": "Jour(s) avant le d" + EacuteUni + "but du concours",
    "won this phase!": "a remport" + EacuteUni + " cette phase!",
    "Sorry our login information doesn't match our records.": "D" + eacuteUni + "sol" + eacuteUni + ", vos donn" + eacuteUni + "es d'ouverture de session ne correspondent pas " + agraveUni + " celles de nos dossiers.",
    "An unspecified error has occurred.": "Une erreur inconnue est survenue.",
    "Please try reloading the page.": "Veuillez actualiser cette page.",
    "Sorry, this game code isn't valid.": "D" + eacuteUni + "sol" + eacuteUni + ", ce code de jeu est non valide.",
    "./images/desktop-hero-1-graphic.png": "./images/desktop-hero-1-graphic.fr.png",
    "./images/desktop-hero-2-text.png": "./images/desktop-hero-2-text.fr.png",
    "./images/desktop-hero-3-text.png": "./images/desktop-hero-3-text.fr.png",
    "./images/mobile-hero-1-graphic.png": "./images/mobile-hero-1-graphic.fr.png",
    "./images/mobile-hero-2-text.png": "./images/mobile-hero-2-text.fr.png",
    "./images/mobile-hero-3-text.png": "./images/mobile-hero-3-text.fr.png",
    "./images/rollin-cold-header.png": "./images/rollin-cold-header.fr.png",
    "https://www1.snapon.com/display/termsandconditions.nws": "http://public.snapon.com/Canada/legal/SnaponConditionsdUtilisationFrancais.htm",
    "https://www1.snapon.com/display/privacypolicy.nws": "http://public.snapon.com/Canada/legal/SnaponPolitiqueConfidentialiteFrancais.htm",
    "Edit Profile": "modifier le profil",
    "Enter Another Game Code": "entrer un autre code de jeu",
    "Add This Code": "ajouter ce code",
    "Account Information": "RENSEIGNEMENTS SUR LE COMPTE",
    "Change Password": "CHANGER LE MOT DE PASSE",
    "Current Password": "MOT DE PASSE ACTUEL",
    "Your Current Password...": "Votre mot de passe actuel...",
    "New Password": "NOUVEAU MOT DE PASSE",
    "New Password...": "NOUVEAU MOT DE PASSE...",
    "Retype New Password": "CONFIRMER LE MOT DE PASSE",
    "Retype New Password...": "CONFIRMER LE MOT DE PASSE...",
    "Change": "MODIFIER",
    "Address": "ADRESSE",
    "Apt/Suite #": "App./Suite",
    "City": "VILLE",
    "State": EacuteUni + "TAT",
    "Save": "ENREGISTRER",
    "Zip Code": "CODE POSTA",
    "Hello": "Bonjour",
    "Home": "Accueil",
    "Changing...": "En cours de modification...",
    "Saving...": "En cours d'enregistrement...",
    "Province": "Province",
    "Retype Password...": "Tapez de nouveau le mot de passe...",
    "Email Address...": "ADRESSE DE COURRIEL...",
    "Email Must Not Be Empty": "Adresse de courriel obligatoire",
    "Email must not be empty": "Adresse de courriel obligatoire",
    "Your Name...": "Votre nom...",
    "Name must not be empty": "Nom obligatoire",
    "Password must be at least 6 characters long and must not contain white space": "LE MOT DE PASSE DOIT COMPTER AU MOINS 6 CARACT" + EgraveUni + "RES ET NE CONTENIR AUCUN ESPACE",
    "Email is formatted incorrectly": "FORMAT DE COURRIEL NON VALIDE",
    "Invalid email or password": "COURRIEL OU MOT DE PASSE NON VALIDE",
    "Please enter a valid phone number": "Veuillez entrer un num" + egraveUni + "ro de t" + egraveUni + "l" + egraveUni + "phone valide",
    "That&apos;s A Valid Code. Good Luck!": "C&apos;EST UN CODE VALIDE. BONNE CHANCE!",
    "You&apos;ve Just Added": "VOUS VENEZ D'AJOUTER",
    "Entry for This Drawing": "BULLETIN(S) POUR CE TIRAGE.",
    "Enter Contest": "PARTICIPER",
    "Retype Email Address": "Inscrire votre adresse de courriel de nouveau",
    "Retype Your Email Address": "Inscrire votre adresse de courriel de nouveau",
    "Please re-enter your email": "Veuillez inscrire votre adresse de courriel de nouveau",
    "Emails do not match": "Les adresses de courriel ne concordent pas",
    "./videos/boat_en.mp4": "./videos/boat_fr.mp4",
    "./videos/boat_en.ogv": "./videos/boat_fr.ogv",
    "./videos/boat_en.webm": "./videos/boat_fr.webm",
    "Winning Entries": void 0,
    "SEE YOUR FRANCHISEE FOR OFFICIAL GAME RULES": "VOYEZ VOTRE FRANCHIS" + EacuteUni + " POUR CONNAÎTRE LES R" + EgraveUni + "GLEMENTS OFFICIELS",
    "DID YOU SIGN UP FOR DOUBLE-PLAY?": "VOUS VOUS " + EcircUni + "TES INSCRIT AU DOUBLE JEU?",
    "THAT'S GREAT - YOU CAN USE THE SAME LOGIN!": "MERVEILLEUX – VOUS POUVEZ ALORS UTILISER LE M" + EcircUni + "ME IDENTIFIANT!",
    "Entries for cooler cart": "Bulletins pour le chariot-glaci" + egraveUni + "re"
  }
};

},{}],44:[function(require,module,exports){
var Contest, JSONApiExpander, PromiseBaseModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseModel = require("./promise.base.model");

JSONApiExpander = require("../jsonapi_expander");

module.exports = Contest = (function(superClass) {
  extend(Contest, superClass);

  function Contest() {
    return Contest.__super__.constructor.apply(this, arguments);
  }

  Contest.prototype.endpoint = 'contests';

  Contest.prototype.type = 'contests';

  Contest.prototype.label = 'Contest';

  Contest.STATUSES = [Contest.NOT_STARTED_STATUS = "not_started", Contest.STARTED_STATUS = "started", Contest.COMPLETED_STATUS = "completed"];

  Contest.TYPES = [Contest.GLOBAL_TYPE = "global", Contest.FPT_TYPE = "fpt", Contest.FRANCHISE_TYPE = "franchise"];

  Contest.CODES = [Contest.ROLLIN_COLD_2017 = "rollin_cold_2017"];

  Contest.prototype.attributes = ['id', 'name', 'type', 'code', 'status', 'winners_count', 'start_date', 'end_date', 'created_at', 'updated_at'];

  Contest.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'code': void 0,
    'type': Contest.GLOBAL_TYPE,
    'status': Contest.NOT_STARTED_STATUS,
    'start_date': void 0,
    'end_date': void 0,
    'winners_count': void 0,
    'created_at': void 0,
    'updated_at': void 0
  };

  Contest.prototype.isGlobalType = function() {
    return this.get('type') === Contest.GLOBAL_TYPE;
  };

  Contest.prototype.isFPTType = function() {
    return this.get('type') === Contest.FPT_TYPE;
  };

  Contest.prototype.isFranchiseType = function() {
    return this.get('type') === Contest.FRANCHISE_TYPE;
  };

  Contest.prototype.expand = function(data) {
    return new JSONApiExpander(data).attributes(Contest.prototype.attributes);
  };

  Contest.prototype.hasEnded = function() {
    var m;
    m = moment.utc(this.get('end_date'));
    if (!m.isValid()) {
      return false;
    }
    return m.isBefore(moment.utc());
  };

  return Contest;

})(PromiseBaseModel);

},{"../jsonapi_expander":63,"./promise.base.model":54}],45:[function(require,module,exports){
var Contest, ContestFinalist, FPT, Franchise, Helpers, JSONApiExpander, PromiseBaseModel, User,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseModel = require("./promise.base.model");

JSONApiExpander = require("../jsonapi_expander");

Contest = require("./contest.model");

User = require("./user.model");

FPT = require("./fpt.model");

Franchise = require("./franchise.model");

Helpers = require("../$helpers/default.helpers");

module.exports = ContestFinalist = (function(superClass) {
  extend(ContestFinalist, superClass);

  function ContestFinalist() {
    return ContestFinalist.__super__.constructor.apply(this, arguments);
  }

  ContestFinalist.prototype.endpoint = 'contest_finalists';

  ContestFinalist.prototype.type = 'contest_finalists';

  ContestFinalist.prototype.label = 'Contest Finalist';

  ContestFinalist.prototype.attributes = ['id', 'rank', 'contest_id', 'entry_id', 'franchise_id', 'fpt_id', 'created_at', 'updated_at'];

  ContestFinalist.prototype.defaults = {
    'contest': function() {
      return new Contest;
    },
    'redeemer': function() {
      return new User;
    },
    'fpt': function() {
      return new FPT;
    },
    'franchise': function() {
      return new Franchise;
    }
  };

  ContestFinalist.prototype.observables = {
    'id': void 0,
    'rank': void 0,
    'entry_id': void 0,
    'contest_id': void 0,
    'franchise_id': void 0,
    'fpt_id': void 0,
    'created_at': "",
    'updated_at': ""
  };

  ContestFinalist.prototype.expand = function(data) {
    return new JSONApiExpander(data).relation('contest').attributes(Contest.prototype.attributes).done().relation('redeemer').attributes(User.prototype.attributes).done().relation('fpt').attributes(FPT.prototype.attributes).done().relation('franchise').attributes(Franchise.prototype.attributes).done().attributes(ContestFinalist.prototype.attributes);
  };

  return ContestFinalist;

})(PromiseBaseModel);

},{"../$helpers/default.helpers":38,"../jsonapi_expander":63,"./contest.model":44,"./fpt.model":48,"./franchise.model":50,"./promise.base.model":54,"./user.model":58}],46:[function(require,module,exports){
var Contest, ContestWinner, FPT, Franchise, Helpers, JSONApiExpander, PromiseBaseModel, User,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseModel = require("./promise.base.model");

JSONApiExpander = require("../jsonapi_expander");

Contest = require("./contest.model");

User = require("./user.model");

FPT = require("./fpt.model");

Franchise = require("./franchise.model");

Helpers = require("../$helpers/default.helpers");

module.exports = ContestWinner = (function(superClass) {
  extend(ContestWinner, superClass);

  function ContestWinner() {
    return ContestWinner.__super__.constructor.apply(this, arguments);
  }

  ContestWinner.prototype.endpoint = 'contest_winners';

  ContestWinner.prototype.type = 'contest_winners';

  ContestWinner.prototype.label = 'Contest Winner';

  ContestWinner.prototype.attributes = ['id', 'contest_id', 'entry_id', 'franchise_id', 'fpt_id', 'winner_name', 'created_at', 'updated_at'];

  ContestWinner.prototype.defaults = {
    'contest': function() {
      return new Contest;
    },
    'redeemer': function() {
      return new User;
    },
    'fpt': function() {
      return new FPT;
    },
    'franchise': function() {
      return new Franchise;
    }
  };

  ContestWinner.prototype.observables = {
    'id': void 0,
    'entry_id': void 0,
    'contest_id': void 0,
    'franchise_id': void 0,
    'fpt_id': void 0,
    'winner_name': void 0,
    'created_at': "",
    'updated_at': ""
  };

  ContestWinner.prototype.hasWinner = function() {
    if (parseInt(this.get('entry_id')) > 0) {
      return true;
    }
    if (Helpers.trim((this.get('winner_name') || "").toString()).length > 0) {
      return true;
    }
    return false;
  };

  ContestWinner.prototype.expand = function(data) {
    return new JSONApiExpander(data).relation('contest').attributes(Contest.prototype.attributes).done().relation('redeemer').attributes(User.prototype.attributes).done().relation('fpt').attributes(FPT.prototype.attributes).done().relation('franchise').attributes(Franchise.prototype.attributes).done().attributes(ContestWinner.prototype.attributes);
  };

  return ContestWinner;

})(PromiseBaseModel);

},{"../$helpers/default.helpers":38,"../jsonapi_expander":63,"./contest.model":44,"./fpt.model":48,"./franchise.model":50,"./promise.base.model":54,"./user.model":58}],47:[function(require,module,exports){
var Contest, Contests, Entry, Franchise, JSONApiExpander, PromiseBaseModel, User,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseModel = require("./promise.base.model");

JSONApiExpander = require("../jsonapi_expander");

Franchise = require("./franchise.model");

User = require("./user.model");

Contest = require("./contest.model");

Contests = require("../$collections/contests.collection");

module.exports = Entry = (function(superClass) {
  extend(Entry, superClass);

  function Entry() {
    return Entry.__super__.constructor.apply(this, arguments);
  }

  Entry.prototype.endpoint = 'entries';

  Entry.prototype.type = 'entries';

  Entry.prototype.label = 'Entry';

  Entry.prototype.attributes = ['id', 'code', 'redeemer_id', 'redeemed_at', 'created_at', 'updated_at'];

  Entry.prototype.defaults = {
    'redeemer': function() {
      return new User;
    },
    'franchise': function() {
      return new Franchise;
    },
    'contests': function() {
      return new Contests;
    }
  };

  Entry.prototype.observables = {
    'id': void 0,
    'code': void 0,
    'redeemer_id': void 0,
    'redeemed_at': void 0,
    'created_at': void 0,
    'updated_at': void 0
  };

  Entry.prototype.expand = function(data) {
    return new JSONApiExpander(data).relation('redeemer').attributes(User.prototype.attributes).done().relation('franchise').attributes(Franchise.prototype.attributes).done().relation('contests').attributes(Contest.prototype.attributes).done().attributes(Entry.prototype.attributes);
  };

  Entry.isValidCode = function(code) {
    if (!_.isString(code)) {
      return false;
    }
    return /^[a-z]{10}$/i.test(code);
  };

  return Entry;

})(PromiseBaseModel);

},{"../$collections/contests.collection":26,"../jsonapi_expander":63,"./contest.model":44,"./franchise.model":50,"./promise.base.model":54,"./user.model":58}],48:[function(require,module,exports){
var FPT, FPTContestStatistic, FPTContestStatistics, JSONApiExpander, PromiseBaseModel, Region, RegionContestStatistic, User,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseModel = require("./promise.base.model");

JSONApiExpander = require("../jsonapi_expander");

User = require("./user.model");

Region = require("./region.model");

FPTContestStatistic = require("./fpt_contest_statistic.model");

FPTContestStatistics = require("../$collections/fpt_contest_statistics.collection");

RegionContestStatistic = require("./region_contest_statistic.model");

module.exports = FPT = (function(superClass) {
  extend(FPT, superClass);

  function FPT() {
    return FPT.__super__.constructor.apply(this, arguments);
  }

  FPT.prototype.endpoint = 'fpts';

  FPT.prototype.type = 'fpts';

  FPT.prototype.label = 'FPT';

  FPT.prototype.attributes = ['id', 'name', 'email', 'owner_id', 'region_id', 'entry_count', 'entrant_count', 'redeemed_entry_count', 'franchise_count', 'created_at', 'updated_at'];

  FPT.prototype.defaults = {
    'owner': function() {
      return new User;
    },
    'region': function() {
      return new Region;
    },
    'contest_statistics': function() {
      return new FPTContestStatistics;
    }
  };

  FPT.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'email': void 0,
    'owner_id': void 0,
    'region_id': void 0,
    'entry_count': void 0,
    'entrant_count': void 0,
    'redeemed_entry_count': void 0,
    'franchise_count': void 0,
    'created_at': void 0,
    'updated_at': void 0,
    'average_entries_per_user': function() {
      var entrant_count, redeemed_entry_count;
      entrant_count = this.get('entrant_count') || 0;
      if (!(entrant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / entrant_count;
    }
  };

  FPT.prototype.hasOwner = function() {
    return parseInt(this.get('owner_id')) > 0;
  };

  FPT.prototype.expand = function(data) {
    return new JSONApiExpander(data).relation('owner').attributes(User.prototype.attributes).done().relation('region').attributes(Region.prototype.attributes).relation('contest_statistics').attributes(RegionContestStatistic.prototype.attributes).done().done().relation('contest_statistics').attributes(FPTContestStatistic.prototype.attributes).done().attributes(FPT.prototype.attributes);
  };

  return FPT;

})(PromiseBaseModel);

},{"../$collections/fpt_contest_statistics.collection":28,"../jsonapi_expander":63,"./fpt_contest_statistic.model":49,"./promise.base.model":54,"./region.model":55,"./region_contest_statistic.model":56,"./user.model":58}],49:[function(require,module,exports){
var Contest, FPTContestStatistic, JSONApiExpander, PromiseBaseModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseModel = require("./promise.base.model");

JSONApiExpander = require("../jsonapi_expander");

Contest = require("./contest.model");

module.exports = FPTContestStatistic = (function(superClass) {
  extend(FPTContestStatistic, superClass);

  function FPTContestStatistic() {
    return FPTContestStatistic.__super__.constructor.apply(this, arguments);
  }

  FPTContestStatistic.prototype.endpoint = 'fpt_contest_statistics';

  FPTContestStatistic.prototype.type = 'fpt_contest_statistics';

  FPTContestStatistic.prototype.label = 'FPT Contest Statistics';

  FPTContestStatistic.prototype.attributes = ['fpt_id', 'contest_id', 'entry_count', 'redeemed_entry_count', 'entrant_count', 'registered_franchise_count'];

  FPTContestStatistic.prototype.defaults = {
    'fpt_id': void 0,
    'contest_id': void 0
  };

  FPTContestStatistic.prototype.observables = {
    'entry_count': 0,
    'redeemed_entry_count': 0,
    'entrant_count': 0,
    'average_entries_per_user': function() {
      var entrant_count, redeemed_entry_count;
      entrant_count = this.get('entrant_count') || 0;
      if (!(entrant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / entrant_count;
    }
  };

  FPTContestStatistic.prototype.expand = function(data) {
    return new JSONApiExpander(data).attributes(FPTContestStatistic.prototype.attributes).relation('contest').attributes(Contest.prototype.attributes).done();
  };

  return FPTContestStatistic;

})(PromiseBaseModel);

},{"../jsonapi_expander":63,"./contest.model":44,"./promise.base.model":54}],50:[function(require,module,exports){
var FPT, Franchise, FranchiseContestStatistic, FranchiseContestStatistics, JSONApiExpander, PromiseBaseModel, Region, User, Users,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseModel = require("./promise.base.model");

JSONApiExpander = require("../jsonapi_expander");

FPT = require("./fpt.model");

Region = require("./region.model");

FranchiseContestStatistic = require("./franchise_contest_statistic.model");

FranchiseContestStatistics = require("../$collections/franchise_contest_statistics.collection");

User = require("./user.model");

Users = require("../$collections/users.collection");

module.exports = Franchise = (function(superClass) {
  extend(Franchise, superClass);

  function Franchise() {
    return Franchise.__super__.constructor.apply(this, arguments);
  }

  Franchise.prototype.endpoint = 'franchises';

  Franchise.prototype.type = 'franchises';

  Franchise.prototype.label = 'Franchise';

  Franchise.prototype.attributes = ['id', 'name', 'email', 'address_1', 'address_2', 'city', 'state', 'country', 'zip_code', 'phone_number', 'bp_number', 'entry_count', 'entrant_count', 'redeemed_entry_count', 'owner_id', 'fpt_id', 'contest_ids', 'created_at', 'updated_at'];

  Franchise.prototype.defaults = {
    'fpt': function() {
      return new FPT;
    },
    'region': function() {
      return new Region;
    },
    'owner': function() {
      return new User;
    },
    'users': function() {
      return new Users;
    },
    'contest_statistics': function() {
      return new FranchiseContestStatistics;
    }
  };

  Franchise.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'email': void 0,
    'address_1': void 0,
    'address_2': void 0,
    'city': void 0,
    'state': void 0,
    'country': void 0,
    'zip_code': void 0,
    'phone_number': void 0,
    'bp_number': void 0,
    'entry_count': void 0,
    'entrant_count': void 0,
    'redeemed_entry_count': void 0,
    'owner_id': void 0,
    'fpt_id': void 0,
    'contest_ids': [],
    'created_at': void 0,
    'updated_at': void 0,
    'average_entries_per_user': function() {
      var entrant_count, redeemed_entry_count;
      entrant_count = this.get('entrant_count') || 0;
      if (!(entrant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / entrant_count;
    }
  };

  Franchise.prototype.hasOwner = function() {
    return parseInt(this.get('owner_id')) > 0;
  };

  Franchise.prototype.hasFPT = function() {
    return parseInt(this.get('fpt_id')) > 0;
  };

  Franchise.prototype.expand = function(data) {
    return new JSONApiExpander(data).relation('fpt').attributes(FPT.prototype.attributes).done().relation('region').attributes(Region.prototype.attributes).done().relation('owner').attributes(User.prototype.attributes).done().relation('users').attributes(User.prototype.attributes).done().relation('contest_statistics').attributes(FranchiseContestStatistic.prototype.attributes).done().attributes(Franchise.prototype.attributes);
  };

  return Franchise;

})(PromiseBaseModel);

},{"../$collections/franchise_contest_statistics.collection":30,"../$collections/users.collection":35,"../jsonapi_expander":63,"./fpt.model":48,"./franchise_contest_statistic.model":51,"./promise.base.model":54,"./region.model":55,"./user.model":58}],51:[function(require,module,exports){
var Contest, FranchiseContestStatistic, JSONApiExpander, PromiseBaseModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseModel = require("./promise.base.model");

JSONApiExpander = require("../jsonapi_expander");

Contest = require("./contest.model");

module.exports = FranchiseContestStatistic = (function(superClass) {
  extend(FranchiseContestStatistic, superClass);

  function FranchiseContestStatistic() {
    return FranchiseContestStatistic.__super__.constructor.apply(this, arguments);
  }

  FranchiseContestStatistic.prototype.endpoint = 'franchise_contest_statistics';

  FranchiseContestStatistic.prototype.type = 'franchise_contest_statistics';

  FranchiseContestStatistic.prototype.label = 'Franchise Contest Statistics';

  FranchiseContestStatistic.prototype.attributes = ['franchise_id', 'contest_id', 'entry_count', 'redeemed_entry_count', 'entrant_count'];

  FranchiseContestStatistic.prototype.defaults = {
    'franchise_id': void 0,
    'contest_id': void 0
  };

  FranchiseContestStatistic.prototype.observables = {
    'entry_count': 0,
    'redeemed_entry_count': 0,
    'entrant_count': 0,
    'average_entries_per_user': function() {
      var entrant_count, redeemed_entry_count;
      entrant_count = this.get('entrant_count') || 0;
      if (!(entrant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / entrant_count;
    }
  };

  FranchiseContestStatistic.prototype.expand = function(data) {
    return new JSONApiExpander(data).attributes(FranchiseContestStatistic.prototype.attributes).relation('contest').attributes(Contest.prototype.attributes).done();
  };

  return FranchiseContestStatistic;

})(PromiseBaseModel);

},{"../jsonapi_expander":63,"./contest.model":44,"./promise.base.model":54}],52:[function(require,module,exports){
var Contest, Contests, Entries, Entry, Franchise, GameKit, JSONApiExpander, PromiseBaseModel, User,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseModel = require("./promise.base.model");

JSONApiExpander = require("../jsonapi_expander");

Entry = require("./entry.model");

Entries = require("../$collections/entries.collection");

Contests = require("../$collections/contests.collection");

Contest = require("./contest.model");

Franchise = require("./franchise.model");

User = require("./user.model");

module.exports = GameKit = (function(superClass) {
  extend(GameKit, superClass);

  function GameKit() {
    return GameKit.__super__.constructor.apply(this, arguments);
  }

  GameKit.prototype.endpoint = 'game_kits';

  GameKit.prototype.type = 'game_kits';

  GameKit.prototype.label = 'Game Kit';

  GameKit.prototype.attributes = ['id', 'name', 'code', 'entry_count', 'contest_ids', 'entry_count', 'entrant_count', 'redeemed_entry_count', 'franchise_id', 'redeemed_at', 'created_at', 'updated_at'];

  GameKit.prototype.defaults = {
    'franchise': function() {
      return new Franchise;
    },
    'entries': function() {
      return new Entries;
    },
    'contests': function() {
      return new Contests;
    },
    'redeemer': function() {
      return new User;
    }
  };

  GameKit.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'code': void 0,
    'entry_count': void 0,
    'entrant_count': void 0,
    'redeemed_entry_count': void 0,
    'contest_ids': [],
    'franchise_id': void 0,
    'redeemed_at': void 0,
    'created_at': void 0,
    'updated_at': void 0,
    'average_entries_per_user': function() {
      var entrant_count, redeemed_entry_count;
      entrant_count = this.get('entrant_count') || 0;
      if (!(entrant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / entrant_count;
    }
  };

  GameKit.prototype.expand = function(data) {
    return new JSONApiExpander(data).relation('franchise').attributes(Franchise.prototype.attributes).done().relation('entries').attributes(Entry.prototype.attributes).done().relation('contests').attributes(Contest.prototype.attributes).done().relation('redeemer').attributes(User.prototype.attributes).done().attributes(GameKit.prototype.attributes);
  };

  GameKit.isValidCode = function(code) {
    if (!_.isString(code)) {
      return false;
    }
    return /^[0-9]{8}$/.test(code);
  };

  return GameKit;

})(PromiseBaseModel);

},{"../$collections/contests.collection":26,"../$collections/entries.collection":27,"../jsonapi_expander":63,"./contest.model":44,"./entry.model":47,"./franchise.model":50,"./promise.base.model":54,"./user.model":58}],53:[function(require,module,exports){
var FPT, Franchise, Invite, JSONApiExpander, PromiseBaseModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseModel = require("./promise.base.model");

JSONApiExpander = require("../jsonapi_expander");

FPT = require("./fpt.model");

Franchise = require("./franchise.model");

module.exports = Invite = (function(superClass) {
  extend(Invite, superClass);

  function Invite() {
    return Invite.__super__.constructor.apply(this, arguments);
  }

  Invite.prototype.endpoint = "invites";

  Invite.prototype.label = "Invite";

  Invite.TYPES = [Invite.ADMIN_TYPE = "admin", Invite.FPT_TYPE = "fpt", Invite.FRANCHISE_TYPE = "franchise"];

  Invite.prototype.attributes = ['id', 'code', 'type', 'email', 'fpt_id', 'franchise_id', 'created_at', 'updated_at'];

  Invite.prototype.defaults = {
    'fpt': function() {
      return new FPT;
    },
    'franchise': function() {
      return new Franchise;
    }
  };

  Invite.prototype.observables = {
    'id': void 0,
    'code': "",
    'type': Invite.ADMIN_TYPE,
    'email': "",
    'fpt_id': void 0,
    'franchise_id': void 0,
    'created_at': void 0,
    'updated_at': void 0
  };

  Invite.prototype.expand = function(data) {
    return new JSONApiExpander(data).relation('fpt').attributes(FPT.prototype.attributes).done().relation('franchise').attributes(Franchise.prototype.attributes).done().attributes(Invite.prototype.attributes);
  };

  return Invite;

})(PromiseBaseModel);

},{"../jsonapi_expander":63,"./fpt.model":48,"./franchise.model":50,"./promise.base.model":54}],54:[function(require,module,exports){
var PromiseBaseModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

module.exports = PromiseBaseModel = (function(superClass) {
  extend(PromiseBaseModel, superClass);

  function PromiseBaseModel() {
    return PromiseBaseModel.__super__.constructor.apply(this, arguments);
  }

  PromiseBaseModel.prototype.attributes = [];

  PromiseBaseModel.prototype.label = "";

  PromiseBaseModel.prototype.type = "";

  PromiseBaseModel.prototype.expand = function() {
    throw new Error("expand not implemented for " + this.endpoint);
  };

  PromiseBaseModel.prototype.makeUrl = function(type, parent) {
    var endpoint, parent_url;
    if (parent == null) {
      return PromiseBaseModel.__super__.makeUrl.call(this, type, parent);
    }
    parent_url = parent.makeUrl(Falcon.GET);
    endpoint = (function() {
      switch (type) {
        case Falcon.GET:
        case Falcon.PUT:
          return this.endpoint + "/" + this.get('id');
        case Falcon.POST:
          return "links/" + this.endpoint;
        case Falcon.DELETE:
          return "links/" + this.endpoint + "/" + this.get('id');
        default:
          return this.endpoint;
      }
    }).call(this);
    return parent_url + "/" + endpoint;
  };

  PromiseBaseModel.prototype.serializeRequestData = function(type, options) {
    var data;
    data = PromiseBaseModel.__super__.serializeRequestData.call(this, type, options);
    if ((options.parent != null) && type === Falcon.POST) {
      data = [data];
    }
    return {
      data: data
    };
  };

  PromiseBaseModel.prototype.promiseFetch = function(options) {
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        options = RequestHelpers.preparePromiseOptions(resolve, reject, options, "An error occurred while fetching " + _this.label);
        return _this.fetch(options);
      };
    })(this));
  };

  PromiseBaseModel.prototype.promiseCreate = function(options) {
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        options = RequestHelpers.preparePromiseOptions(resolve, reject, options, "An error occurred while creating " + _this.label);
        return _this.create(options);
      };
    })(this));
  };

  PromiseBaseModel.prototype.promiseSave = function(options) {
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        options = RequestHelpers.preparePromiseOptions(resolve, reject, options, "An error occurred while saving " + _this.label);
        return _this.save(options);
      };
    })(this));
  };

  PromiseBaseModel.prototype.promiseDestroy = function(options) {
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        options = RequestHelpers.preparePromiseOptions(resolve, reject, options, "An error occurred while destroying " + _this.label);
        return _this.destroy(options);
      };
    })(this));
  };

  PromiseBaseModel.prototype.parseResponseData = function(data, type, options) {
    if (type === Falcon.DELETE) {
      return {};
    }
    return this.expand(data).toObject();
  };

  return PromiseBaseModel;

})(Falcon.Model);

},{}],55:[function(require,module,exports){
var JSONApiExpander, PromiseBaseModel, Region, RegionContestStatistic, RegionContestStatistics,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseModel = require("./promise.base.model");

JSONApiExpander = require("../jsonapi_expander");

RegionContestStatistic = require("./region_contest_statistic.model");

RegionContestStatistics = require("../$collections/region_contest_statistics.collection");

module.exports = Region = (function(superClass) {
  extend(Region, superClass);

  function Region() {
    return Region.__super__.constructor.apply(this, arguments);
  }

  Region.prototype.endpoint = 'regions';

  Region.prototype.type = 'regions';

  Region.prototype.label = 'Region';

  Region.prototype.attributes = ['id', 'name', 'entry_count', 'entrant_count', 'redeemed_entry_count', 'franchise_count', 'created_at', 'updated_at'];

  Region.prototype.defaults = {
    'contest_statistics': function() {
      return new RegionContestStatistics;
    }
  };

  Region.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'entry_count': void 0,
    'entrant_count': void 0,
    'redeemed_entry_count': void 0,
    'franchise_count': void 0,
    'created_at': void 0,
    'updated_at': void 0,
    'average_entries_per_user': function() {
      var entrant_count, redeemed_entry_count;
      entrant_count = this.get('entrant_count') || 0;
      if (!(entrant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / entrant_count;
    }
  };

  Region.prototype.hasOwner = function() {
    return parseInt(this.get('owner_id')) > 0;
  };

  Region.prototype.hasFPT = function() {
    return parseInt(this.get('fpt_id')) > 0;
  };

  Region.prototype.expand = function(data) {
    return new JSONApiExpander(data).attributes(Region.prototype.attributes).relation('contest_statistics').attributes(RegionContestStatistic.prototype.attributes).done();
  };

  return Region;

})(PromiseBaseModel);

},{"../$collections/region_contest_statistics.collection":33,"../jsonapi_expander":63,"./promise.base.model":54,"./region_contest_statistic.model":56}],56:[function(require,module,exports){
var Contest, JSONApiExpander, PromiseBaseModel, RegionContestStatistic,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseModel = require("./promise.base.model");

JSONApiExpander = require("../jsonapi_expander");

Contest = require("./contest.model");

module.exports = RegionContestStatistic = (function(superClass) {
  extend(RegionContestStatistic, superClass);

  function RegionContestStatistic() {
    return RegionContestStatistic.__super__.constructor.apply(this, arguments);
  }

  RegionContestStatistic.prototype.endpoint = 'region_contest_statistics';

  RegionContestStatistic.prototype.type = 'region_contest_statistics';

  RegionContestStatistic.prototype.label = 'Region Contest Statistics';

  RegionContestStatistic.prototype.attributes = ['region_id', 'contest_id', 'entry_count', 'redeemed_entry_count', 'entrant_count', 'registered_franchise_count'];

  RegionContestStatistic.prototype.defaults = {
    'region_id': void 0,
    'contest_id': void 0
  };

  RegionContestStatistic.prototype.observables = {
    'entry_count': 0,
    'redeemed_entry_count': 0,
    'entrant_count': 0,
    'average_entries_per_user': function() {
      var entrant_count, redeemed_entry_count;
      entrant_count = this.get('entrant_count') || 0;
      if (!(entrant_count > 0)) {
        return 0;
      }
      redeemed_entry_count = this.get('redeemed_entry_count') || 0;
      return redeemed_entry_count / entrant_count;
    }
  };

  RegionContestStatistic.prototype.expand = function(data) {
    return new JSONApiExpander(data).attributes(RegionContestStatistic.prototype.attributes).relation('contest').attributes(Contest.prototype.attributes).done();
  };

  return RegionContestStatistic;

})(PromiseBaseModel);

},{"../jsonapi_expander":63,"./contest.model":44,"./promise.base.model":54}],57:[function(require,module,exports){
var FPT, FPTs, Franchise, Franchises, JSONApiExpander, PromiseBaseModel, Session, User,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

User = require("./user.model");

Franchise = require("./franchise.model");

Franchises = require("../$collections/franchises.collection");

FPT = require("./fpt.model");

FPTs = require("../$collections/fpts.collection");

PromiseBaseModel = require("./promise.base.model");

JSONApiExpander = require("../jsonapi_expander");

module.exports = Session = (function(superClass) {
  extend(Session, superClass);

  function Session() {
    return Session.__super__.constructor.apply(this, arguments);
  }

  Session.prototype.endpoint = 'sessions';

  Session.prototype.type = 'sessions';

  Session.prototype.label = 'Session';

  Session.prototype.attributes = ['email', 'auth_token'];

  Session.prototype.defaults = {
    'email': "",
    'auth_token': null,
    'user': function() {
      return new User;
    },
    'franchises': function() {
      return new Franchises;
    },
    'fpts': function() {
      return new FPTs;
    }
  };

  Session.prototype.makeUrl = function() {
    return Falcon.baseApiUrl + "/" + this.endpoint;
  };

  Session.prototype.serializeRequestData = function(type, options) {
    var data;
    data = Session.__super__.serializeRequestData.call(this, type, options).data;
    if ('user' in data) {
      data['users'] = data['user'];
      delete data['user'];
    }
    return {
      data: data
    };
  };

  Session.prototype.promiseCreate = function() {
    return Session.__super__.promiseCreate.apply(this, arguments).then(function(session) {
      Falcon.dataAdapter.setToken(session.get('auth_token'));
      return session;
    });
  };

  Session.prototype.expand = function(data) {
    return new JSONApiExpander(data).relation('user').attributes(User.prototype.attributes).done().relation('franchises').attributes(Franchise.prototype.attributes).done().relation('fpts').attributes(FPT.prototype.attributes).done().attributes(Session.prototype.attributes);
  };

  return Session;

})(PromiseBaseModel);

},{"../$collections/fpts.collection":29,"../$collections/franchises.collection":31,"../jsonapi_expander":63,"./fpt.model":48,"./franchise.model":50,"./promise.base.model":54,"./user.model":58}],58:[function(require,module,exports){
var JSONApiExpander, PromiseBaseModel, User, UserContestStatistic, UserContestStatistics,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  slice = [].slice,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

PromiseBaseModel = require("./promise.base.model");

JSONApiExpander = require("../jsonapi_expander");

UserContestStatistic = require("../$models/user_contest_statistic.model");

UserContestStatistics = require("../$collections/user_contest_statistics.collection");

module.exports = User = (function(superClass) {
  extend(User, superClass);

  function User() {
    return User.__super__.constructor.apply(this, arguments);
  }

  User.prototype.endpoint = 'users';

  User.prototype.type = 'users';

  User.prototype.label = 'User';

  User.ROLES = [User.ADMIN_ROLE = 'admin', User.FPT_ROLE = 'fpt', User.FRANCHISE_ROLE = 'franchise', User.USER_ROLE = 'user'];

  User.prototype.attributes = ['id', 'email', 'name', 'roles', 'created_at', 'updated_at', 'address_1', 'address_2', 'city', 'state', 'country', 'zip_code', 'phone_number', 'legal_agreements', 'is_subscribed_to_newsletter'];

  User.prototype.defaults = {
    'contest_statistics': function() {
      return new UserContestStatistics;
    }
  };

  User.prototype.observables = {
    'id': void 0,
    'name': void 0,
    'email': void 0,
    'roles': [],
    'password': void 0,
    'address_1': void 0,
    'address_2': void 0,
    'city': void 0,
    'state': void 0,
    'country': void 0,
    'zip_code': void 0,
    'phone_number': void 0,
    'legal_agreements': void 0,
    'is_subscribed_to_newsletter': void 0,
    'created_at': void 0,
    'updated_at': void 0,
    'first_name': function() {
      var name, ref, ref1;
      name = Helpers.trim((ref = this.get('name')) != null ? ref : "");
      return (ref1 = name.split(" ")[0]) != null ? ref1 : "";
    },
    'last_name': function() {
      var first, name, ref, ref1, rest;
      name = Helpers.trim((ref = this.get('name')) != null ? ref : "");
      ref1 = name.split(" "), first = ref1[0], rest = 2 <= ref1.length ? slice.call(ref1, 1) : [];
      return rest.join(" ");
    }
  };

  User.prototype.hasRole = function() {
    var assigned_roles, i, len, ref, role, roles;
    roles = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    assigned_roles = (ref = this.get('roles')) != null ? ref : [];
    for (i = 0, len = roles.length; i < len; i++) {
      role = roles[i];
      if (indexOf.call(assigned_roles, role) >= 0) {
        return true;
      }
    }
    return false;
  };

  User.prototype.expand = function(data) {
    return new JSONApiExpander(data).relation('contest_statistics').attributes(UserContestStatistic.prototype.attributes).done().attributes(User.prototype.attributes);
  };

  return User;

})(PromiseBaseModel);

},{"../$collections/user_contest_statistics.collection":34,"../$models/user_contest_statistic.model":59,"../jsonapi_expander":63,"./promise.base.model":54}],59:[function(require,module,exports){
var JSONApiExpander, PromiseBaseModel, UserContestStatistic,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

PromiseBaseModel = require("./promise.base.model");

JSONApiExpander = require("../jsonapi_expander");

module.exports = UserContestStatistic = (function(superClass) {
  extend(UserContestStatistic, superClass);

  function UserContestStatistic() {
    return UserContestStatistic.__super__.constructor.apply(this, arguments);
  }

  UserContestStatistic.prototype.endpoint = 'user_contest_statistics';

  UserContestStatistic.prototype.type = 'user_contest_statistics';

  UserContestStatistic.prototype.label = 'Contest Winner';

  UserContestStatistic.prototype.attributes = ['user_id', 'contest_id', 'entry_count'];

  UserContestStatistic.prototype.defaults = {
    'user_id': void 0,
    'contest_id': void 0
  };

  UserContestStatistic.prototype.observables = {
    'entry_count': void 0
  };

  UserContestStatistic.prototype.expand = function(data) {
    return new JSONApiExpander(data).attributes(UserContestStatistic.prototype.attributes);
  };

  return UserContestStatistic;

})(PromiseBaseModel);

},{"../jsonapi_expander":63,"./promise.base.model":54}],60:[function(require,module,exports){
var base;

if ((base = Function.prototype).bind == null) {
  base.bind = function(oThis) {
    var aArgs, fBound, fToBind, noop;
    if (typeof this !== "function") {
      throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
    }
    aArgs = Array.prototype.slice.call(arguments, 1);
    fToBind = this;
    noop = (function() {});
    fBound = function() {
      var context;
      context = this instanceof noop && oThis ? this : oThis;
      return fToBind.apply(context, aArgs.concat(Array.prototype.slice.call(arguments)));
    };
    noop.prototype = this.prototype;
    fBound.prototype = new noop();
    return fBound;
  };
}

},{}],61:[function(require,module,exports){
(function() {
  var browserRaf, canceled, i, len, ref, targetTime, vendor, w;
  w = window;
  ref = ['ms', 'moz', 'webkit', 'o'];
  for (i = 0, len = ref.length; i < len; i++) {
    vendor = ref[i];
    if (w.requestAnimationFrame) {
      break;
    }
    w.requestAnimationFrame = w[vendor + "RequestAnimationFrame"];
    w.cancelAnimationFrame = w[vendor + "CancelAnimationFrame"] || w[vendor + "CancelRequestAnimationFrame"];
  }
  if (w.requestAnimationFrame) {
    if (w.cancelAnimationFrame) {
      return;
    }
    browserRaf = w.requestAnimationFrame;
    canceled = {};
    w.requestAnimationFrame = function(callback) {
      var id;
      return id = browserRaf(function(time) {
        if (id in canceled) {
          return delete canceled[id];
        } else {
          return callback(time);
        }
      });
    };
    return w.cancelAnimationFrame = function(id) {
      return canceled[id] = true;
    };
  } else {
    targetTime = 0;
    w.requestAnimationFrame = function(callback) {
      var currentTime;
      targetTime = Math.max(targetTime + 16, currentTime = +(new Date));
      return w.setTimeout((function() {
        return callback(+(new Date));
      }), targetTime - currentTime);
    };
    return w.cancelAnimationFrame = function(id) {
      return clearTimeout(id);
    };
  }
})();

},{}],62:[function(require,module,exports){
var slice = [].slice;

ko.subscribable.fn.decorate = function() {
  var extenders, i, identifier, identifiers, len;
  identifiers = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  extenders = {};
  for (i = 0, len = identifiers.length; i < len; i++) {
    identifier = identifiers[i];
    if (_.isString(identifier) && !_.isEmpty(identifier)) {
      extenders[identifier] = true;
    }
  }
  return this.extend(extenders);
};

ko.extenders["errorable"] = function(target, options) {
  target.error = ko.observable("");
  target.has_error = ko.computed(function() {
    var err;
    err = target.error();
    if (!_.isString(err)) {
      err = "";
    }
    return Helpers.trim(err).length > 0;
  });
  target.clearError = function() {
    return target.error("");
  };
  return target;
};

ko.extenders["validatable"] = function(target, options) {
  target.is_valid = ko.observable(false);
  target.is_invalid = ko.observable(false);
  target.has_validation = ko.computed(function() {
    return target.is_invalid() || target.is_valid();
  });
  target.validation_message = ko.observable(null);
  target.setIsValid = function(is_valid, message) {
    var is_invalid;
    if (is_valid != null) {
      is_invalid = !is_valid;
      target.is_invalid(is_invalid);
      target.is_valid(is_valid);
      target.validation_message(message);
      return !is_invalid;
    } else {
      target.resetValidations();
      return null;
    }
  };
  target.resetValidations = function() {
    target.is_invalid(false);
    target.is_valid(false);
    target.validation_message(null);
    return target;
  };
  return target;
};

ko.extenders["resetAfter"] = function(target, duration) {
  var original_value, timeout;
  if (!_.isNumber(duration)) {
    duration = 1000;
  }
  if (duration < 0) {
    duration = 0;
  }
  original_value = target();
  timeout = null;
  target.subscribe(function(new_value) {
    if (timeout != null) {
      clearTimeout(timeout);
    }
    timeout = null;
    if (new_value === original_value) {
      return;
    }
    return timeout = setTimeout(function() {
      timeout = null;
      return target(original_value);
    }, duration);
  });
  return target;
};

ko.extenders["transactable"] = function(target, options) {
  var previous;
  previous = ko.observable(target());
  target.commit = function() {
    return previous(target());
  };
  target.revert = function() {
    return target(previous());
  };
  target.hasChanged = function() {
    return target() !== previous();
  };
  return target;
};

},{}],63:[function(require,module,exports){
var JSONApiExpander, JSONApiExpanderBase,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

module.exports = JSONApiExpanderBase = (function() {
  JSONApiExpanderBase.prototype.parent = null;

  JSONApiExpanderBase.prototype.data = null;

  JSONApiExpanderBase.prototype.output = null;

  JSONApiExpanderBase.prototype.debug = false;

  function JSONApiExpanderBase(data, output, parent) {
    if (!_.isObject(data)) {
      throw new Error("data must be an object");
    }
    if (!_.isArray(output)) {
      throw new Error("output must be an array");
    }
    this.data = data;
    this.output = output;
    this.parent = parent;
  }

  JSONApiExpanderBase.prototype.generateBaseOutputObject = function($included_datum) {
    if (!_.isObject($included_datum)) {
      throw new Error("$included_datum must be an object");
    }
    return {
      $included_datum: $included_datum
    };
  };

  JSONApiExpanderBase.prototype.cleanOutputObject = function(output_object) {
    if (!_.isObject(output_object)) {
      throw new Error("output_object must be an Object");
    }
    if ('$included_datum' in output_object) {
      return delete output_object['$included_datum'];
    }
  };

  JSONApiExpanderBase.prototype.getRelationships = function(output_object, key) {
    var $included_datum;
    if (!_.isObject(output_object)) {
      throw new Error("output_object must be an Object");
    }
    $included_datum = output_object.$included_datum;
    if ($included_datum == null) {
      if (this.debug) {
        if (typeof console !== "undefined" && console !== null) {
          console.warn("Missing '$included_datum' property on: ", output_object);
        }
      }
    } else if (!('relationships' in output_object['$included_datum'])) {
      if (this.debug) {
        if (typeof console !== "undefined" && console !== null) {
          console.warn("Missing 'relationships' property on '" + $included_datum['type'] + "', data given was:", $included_datum);
        }
      }
    } else if (!(key in $included_datum['relationships'])) {
      if (this.debug) {
        if (typeof console !== "undefined" && console !== null) {
          console.warn("Missing '" + key + "' property on '" + $included_datum['type'] + ".relationships', data given was: ", $included_datum['relationships']);
        }
      }
    } else if ($included_datum['relationships'][key] == null) {
      return null;
    } else if (!('data' in $included_datum['relationships'][key])) {
      if (this.debug) {
        if (typeof console !== "undefined" && console !== null) {
          console.warn("Missing 'data' property on '" + $included_datum['type'] + ".relationships." + key + "', data given was: ", $included_datum['relationships'][key]);
        }
      }
    } else {
      return $included_datum['relationships'][key]['data'];
    }
    return null;
  };

  JSONApiExpanderBase.prototype.generateOutputObject = function(linkage, existing_output_array) {
    var $included_datum, existing_output_object, i, id, j, len, len1, output_object, ref, resource, type;
    if (!_.isObject(linkage)) {
      throw new Error("linkage must be an object");
    }
    if (!('id' in linkage)) {
      throw new Error("Linked objects must contain an id");
    }
    if (!('type' in linkage)) {
      throw new Error("Linked objects must contain a type");
    }
    type = linkage.type, id = linkage.id;
    output_object = null;
    if (_.isArray(existing_output_array)) {
      for (i = 0, len = existing_output_array.length; i < len; i++) {
        existing_output_object = existing_output_array[i];
        $included_datum = existing_output_object.$included_datum;
        if ($included_datum['id'] !== id) {
          continue;
        }
        if ($included_datum['type'] !== type) {
          continue;
        }
        return existing_output_object;
      }
    }
    $included_datum = null;
    ref = this.data['included'];
    for (j = 0, len1 = ref.length; j < len1; j++) {
      resource = ref[j];
      if (!(resource != null)) {
        continue;
      }
      if (resource['id'] !== id) {
        continue;
      }
      if (resource['type'] !== type) {
        continue;
      }
      $included_datum = resource;
      break;
    }
    if ($included_datum == null) {
      $included_datum = {
        id: id
      };
    }
    output_object = this.generateBaseOutputObject($included_datum);
    return output_object;
  };

  JSONApiExpanderBase.prototype.attributes = function(attrs) {
    var $included_datum, attr, i, index, j, len, len1, output_object, ref;
    if (!_.isArray(attrs)) {
      attrs = [];
    }
    ref = this.output;
    for (index = i = 0, len = ref.length; i < len; index = ++i) {
      output_object = ref[index];
      $included_datum = output_object.$included_datum;
      if ($included_datum == null) {
        continue;
      }
      output_object['id'] = $included_datum['id'];
      if ($included_datum['attributes'] == null) {
        continue;
      }
      for (j = 0, len1 = attrs.length; j < len1; j++) {
        attr = attrs[j];
        if (attr in $included_datum['attributes']) {
          output_object[attr] = $included_datum['attributes'][attr];
        }
      }
    }
    return this;
  };

  JSONApiExpanderBase.prototype.relation = function(key) {
    var child_output_array, child_output_object, i, included, j, len, len1, output_object, ref, relationship, relationships;
    if (!_.isString(key)) {
      throw new Error("key must be a string");
    }
    included = this.data.included;
    child_output_array = [];
    ref = this.output;
    for (i = 0, len = ref.length; i < len; i++) {
      output_object = ref[i];
      relationships = this.getRelationships(output_object, key);
      if (_.isNull(relationships)) {
        output_object[key] = null;
      }
      if (_.isArray(relationships)) {
        for (j = 0, len1 = relationships.length; j < len1; j++) {
          relationship = relationships[j];
          if (!(relationship != null)) {
            continue;
          }
          child_output_object = this.generateOutputObject(relationship, child_output_array);
          if (child_output_object != null) {
            if (indexOf.call(child_output_array, child_output_object) < 0) {
              child_output_array.push(child_output_object);
            }
            (output_object[key] != null ? output_object[key] : output_object[key] = []).push(child_output_object);
          }
        }
      } else if (_.isObject(relationships)) {
        child_output_object = this.generateOutputObject(relationships, child_output_array);
        if (child_output_object != null) {
          child_output_array.push(child_output_object);
          output_object[key] = child_output_object;
        }
      }
    }
    return new JSONApiExpanderBase(this.data, child_output_array, this);
  };

  JSONApiExpanderBase.prototype.done = function() {
    var i, len, output_object, ref;
    ref = this.output;
    for (i = 0, len = ref.length; i < len; i++) {
      output_object = ref[i];
      this.cleanOutputObject(output_object);
    }
    return this.parent;
  };

  return JSONApiExpanderBase;

})();

module.exports = JSONApiExpander = (function(superClass) {
  extend(JSONApiExpander, superClass);

  function JSONApiExpander(data) {
    var output, root, root_datum;
    if (!_.isObject(data)) {
      throw new Error("data must be an object");
    }
    root = data['data'];
    if (_.isObject(root) && !_.isArray(root)) {
      root = [root];
    }
    if (!_.isArray(root)) {
      throw new Error("root must be an object or an array");
    }
    output = (function() {
      var i, len, results;
      results = [];
      for (i = 0, len = root.length; i < len; i++) {
        root_datum = root[i];
        results.push(this.generateBaseOutputObject(root_datum));
      }
      return results;
    }).call(this);
    JSONApiExpander.__super__.constructor.call(this, data, output, this);
  }

  JSONApiExpander.prototype.toArray = function() {
    return this.done().output;
  };

  JSONApiExpander.prototype.toObject = function() {
    return this.done().output[0];
  };

  return JSONApiExpander;

})(JSONApiExpanderBase);

},{}],64:[function(require,module,exports){
var JWTAdapater,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

module.exports = JWTAdapater = (function(superClass) {
  var JWT_KEY;

  extend(JWTAdapater, superClass);

  JWT_KEY = "__JWT__";

  JWTAdapater.prototype.token = null;

  JWTAdapater.prototype.getToken = function() {
    return this.token;
  };

  JWTAdapater.prototype.hasToken = function() {
    return this.token != null;
  };

  JWTAdapater.prototype.setToken = function(token) {
    var e, message, ref;
    this.token = token;
    try {
      return window.localStorage[JWT_KEY] = token;
    } catch (error) {
      e = error;
      message = (ref = e.message) != null ? ref : "QuotaExceededError";
      if (typeof Raven !== "undefined" && Raven !== null) {
        Raven.captureMessage(message, {
          'level': 'warning'
        });
      }
      return typeof console !== "undefined" && console !== null ? console.error(e) : void 0;
    }
  };

  JWTAdapater.prototype.clearToken = function() {
    var e, message, ref;
    this.token = null;
    try {
      if (JWT_KEY in window.localStorage) {
        return delete window.localStorage[JWT_KEY];
      }
    } catch (error) {
      e = error;
      message = (ref = e.message) != null ? ref : "QuotaExceededError";
      if (typeof Raven !== "undefined" && Raven !== null) {
        Raven.captureMessage(message, {
          'level': 'warning'
        });
      }
      return typeof console !== "undefined" && console !== null ? console.error(e) : void 0;
    }
  };

  function JWTAdapater() {
    var e, message, ref, ref1;
    JWTAdapater.__super__.constructor.apply(this, arguments);
    try {
      this.token = (ref = window.localStorage[JWT_KEY]) != null ? ref : null;
    } catch (error) {
      e = error;
      message = (ref1 = e.message) != null ? ref1 : "QuotaExceededError";
      if (typeof Raven !== "undefined" && Raven !== null) {
        Raven.captureMessage(message, {
          'level': 'warning'
        });
      }
      if (typeof console !== "undefined" && console !== null) {
        console.error(e);
      }
    }
  }

  JWTAdapater.prototype.standardizeOptions = function(data_object, type, options, context) {
    var base, sync_options;
    sync_options = JWTAdapater.__super__.standardizeOptions.apply(this, arguments);
    if (this.token == null) {
      return sync_options;
    }
    if (sync_options['headers'] == null) {
      sync_options['headers'] = {};
    }
    if ((base = sync_options['headers'])['Authorization'] == null) {
      base['Authorization'] = "Bearer " + this.token;
    }
    return sync_options;
  };

  JWTAdapater.prototype.errorResponseHandler = function(data_object, type, options, context, response_args) {
    var ref, ref1;
    switch (parseInt((ref = response_args != null ? (ref1 = response_args.xhr) != null ? ref1.status : void 0 : void 0) != null ? ref : 0)) {
      case 401:
        this.clearToken();
        this.trigger('unauthorized');
    }
    return JWTAdapater.__super__.errorResponseHandler.apply(this, arguments);
  };

  return JWTAdapater;

})(jQueryRestDataAdapter);

},{}],65:[function(require,module,exports){
var Contest, ContestFinalist, ContestFinalists, ContestWinner, ContestWinners, Entries, Entry, FPT, Franchise, Franchises, GameKit, Invite, RPC, Session, User;

User = require("./$models/user.model");

Invite = require("./$models/invite.model");

Entry = require("./$models/entry.model");

Entries = require("./$collections/entries.collection");

Franchise = require("./$models/franchise.model");

Franchises = require("./$collections/franchises.collection");

FPT = require("./$models/fpt.model");

Contest = require("./$models/contest.model");

ContestWinner = require("./$models/contest_winner.model");

ContestWinners = require("./$collections/contest_winners.collection");

ContestFinalist = require("./$models/contest_finalist.model");

ContestFinalists = require("./$collections/contest_finalists.collection");

GameKit = require("./$models/game_kit.model");

Session = require("./$models/session.model");

module.exports = RPC = new ((function() {
  function _Class() {}

  _Class.prototype.promiseGetPresignedUrl = function(arg) {
    var name, ref, size, type;
    ref = arg != null ? arg : {}, size = ref.size, name = ref.name, type = ref.type;
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        return (new Falcon.Model({
          endpoint: "rpc/presigned_url"
        })).set({
          size: size,
          name: name,
          type: type
        }).create({
          parent: null,
          attributes: ['size', 'name', 'type'],
          success: function(model, resp) {
            return resolve(resp);
          },
          error: function() {
            return reject("Could not retrieve a presigned url");
          }
        });
      };
    })(this));
  };

  _Class.prototype.promiseUploadFile = function(file) {
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        return RPC.promiseGetPresignedUrl(file).then(function(urls) {
          return $.ajax({
            url: urls.presigned_url,
            type: 'PUT',
            data: file,
            processData: false,
            headers: {
              'Accept': file.type,
              'Content-Type': file.type
            }
          }).success(function() {
            return resolve(urls.public_url);
          }).error(reject);
        });
      };
    })(this));
  };

  _Class.prototype.promiseForgotPassword = function(email, app_level) {
    if (app_level == null) {
      app_level = "web";
    }
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        if (!email) {
          throw new Error("email must be present");
        }
        if (!Helpers.isEmail(email)) {
          throw new Error("email must be an valid email");
        }
        return (new Falcon.Model({
          endpoint: "rpc/forgot_password"
        })).set({
          email: email,
          app_level: app_level,
          campaign: "rollin-cold"
        }).create({
          parent: null,
          attributes: ['email', 'app_level', 'campaign'],
          success: function() {
            return resolve();
          },
          error: function() {
            return reject({
              human: "No account found for this email."
            });
          }
        });
      };
    })(this));
  };

  _Class.prototype.promiseResetPassword = function(arg) {
    var email, password, ref, reset_code;
    ref = arg != null ? arg : {}, email = ref.email, reset_code = ref.reset_code, password = ref.password;
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        if (!email) {
          throw new Error("email must be present");
        }
        if (!Helpers.isEmail(email)) {
          throw new Error("email must be an valid email");
        }
        if (!reset_code) {
          throw new Error("reset_code must be present");
        }
        if (!password) {
          throw new Error("password must be present");
        }
        return (new Falcon.Model({
          endpoint: "rpc/reset_password"
        })).set({
          email: email,
          reset_code: reset_code,
          password: password
        }).create({
          parent: null,
          attributes: ['email', 'reset_code', 'password'],
          success: function(model, data) {
            var user, user_data;
            user_data = User.prototype.expand(data).toObject();
            user = new User(user_data);
            return resolve(user);
          },
          error: function() {
            return reject("Could not reset password");
          }
        });
      };
    })(this));
  };

  _Class.prototype.promiseChangePassword = function(old_password, new_password) {
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        if (!_.isString(old_password)) {
          throw new Error("old_password must be a string");
        }
        if (!_.isString(new_password)) {
          throw new Error("new_password must be a string");
        }
        if (_.isEmpty(old_password)) {
          throw new Error("old_password must not be empty");
        }
        if (_.isEmpty(new_password)) {
          throw new Error("new_password must not be empty");
        }
        return (new Falcon.Model({
          endpoint: "rpc/change_password"
        })).set({
          old_password: old_password,
          new_password: new_password
        }).create({
          parent: null,
          attributes: ['old_password', 'new_password'],
          success: function(model, data) {
            var user, user_data;
            user_data = User.prototype.expand(data);
            user = new User(user_data);
            return resolve(user);
          },
          error: function() {
            return reject("Could not change password");
          }
        });
      };
    })(this));
  };

  _Class.prototype.promiseCheckBPNumber = function(bp_number) {
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        if (!_.isString(bp_number)) {
          throw new Error("bp_number must be a string");
        }
        return (new Falcon.Model({
          endpoint: "rpc/check_bp_number"
        })).set({
          bp_number: bp_number
        }).create({
          parent: null,
          attributes: ['bp_number'],
          success: function(model, data) {
            if ((data != null ? data.success : void 0)) {
              return resolve();
            }
            return reject({});
          },
          error: function(model, error) {
            if (error == null) {
              error = {};
            }
            return reject(error);
          }
        });
      };
    })(this));
  };

  _Class.prototype.promiseInviteByBPNumber = function(bp_number) {
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        if (!_.isString(bp_number)) {
          throw new Error("bp_number must be a string");
        }
        return (new Falcon.Model({
          endpoint: "rpc/invite_by_bp_number"
        })).set({
          bp_number: bp_number,
          campaign: "rollin-cold"
        }).create({
          parent: null,
          attributes: ['bp_number', 'campaign'],
          success: function(model, data) {
            var invite, invite_data;
            invite_data = Invite.prototype.expand(data).toObject();
            invite = new Invite(invite_data);
            return resolve(invite);
          },
          error: function(model, error) {
            if (error == null) {
              error = {};
            }
            return reject(error);
          }
        });
      };
    })(this));
  };

  _Class.prototype.promiseRegisterFranchise = function(arg) {
    var invite_code, password, ref;
    ref = arg != null ? arg : {}, password = ref.password, invite_code = ref.invite_code;
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        if (!_.isString(password)) {
          throw new Error("Password must be a string");
        }
        if (_.isEmpty(password)) {
          throw new Error("Password must not be empty");
        }
        if (!_.isString(invite_code)) {
          throw new Error("Invite code must be a string");
        }
        if (_.isEmpty(invite_code)) {
          throw new Error("Invite code must not be empty");
        }
        return (new Falcon.Model({
          endpoint: "rpc/register_franchise"
        })).set({
          password: password,
          invite_code: invite_code
        }).create({
          parent: null,
          attributes: ['password', 'invite_code'],
          success: function(model, data) {
            var user, user_data;
            user_data = User.prototype.expand(data).toObject();
            user = new User(user_data);
            return resolve(user);
          },
          error: function(model, error) {
            return reject(error);
          }
        });
      };
    })(this));
  };

  _Class.prototype.promiseRegisterFPT = function(arg) {
    var invite_code, password, ref;
    ref = arg != null ? arg : {}, password = ref.password, invite_code = ref.invite_code;
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        if (!_.isString(password)) {
          throw new Error("Password must be a string");
        }
        if (_.isEmpty(password)) {
          throw new Error("Password must not be empty");
        }
        if (!_.isString(invite_code)) {
          throw new Error("Invite code must be a string");
        }
        if (_.isEmpty(invite_code)) {
          throw new Error("Invite code must not be empty");
        }
        return (new Falcon.Model({
          endpoint: "rpc/register_fpt"
        })).set({
          password: password,
          invite_code: invite_code
        }).create({
          parent: null,
          attributes: ['password', 'invite_code'],
          success: function(model, data) {
            var user, user_data;
            user_data = User.prototype.expand(data).toObject();
            user = new User(user_data);
            return resolve(user);
          },
          error: function(model, error) {
            return reject(error);
          }
        });
      };
    })(this));
  };

  _Class.prototype.promiseClaimGameKit = function(arg) {
    var franchise_id, game_kit_code, ref;
    ref = arg != null ? arg : {}, franchise_id = ref.franchise_id, game_kit_code = ref.game_kit_code;
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        if (franchise_id == null) {
          throw new Error("Franchise Id must be specified");
        }
        if (game_kit_code == null) {
          throw new Error("GameKit code must be specified");
        }
        if (!GameKit.isValidCode(game_kit_code)) {
          throw new Error("Valid GameKit code must be given");
        }
        return (new Falcon.Model({
          endpoint: "rpc/claim_game_kit"
        })).set({
          franchise_id: franchise_id,
          game_kit_code: game_kit_code
        }).create({
          parent: null,
          attributes: ['franchise_id', 'game_kit_code'],
          success: function(model, data) {
            var game_kit, game_kit_data;
            game_kit_data = GameKit.prototype.expand(data).toObject();
            game_kit = new GameKit(game_kit_data);
            return resolve(game_kit);
          },
          error: function(model, error) {
            return reject(error);
          }
        });
      };
    })(this));
  };

  _Class.prototype.promiseCheckGameCode = function(code) {
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        return (new Falcon.Model({
          endpoint: "rpc/check_game_code"
        })).set({
          code: code
        }).create({
          parent: null,
          attributes: ['code'],
          success: function(model, data) {
            var entry, entry_data;
            entry_data = Entry.prototype.expand(data).toObject();
            entry = new Entry(entry_data);
            return resolve(entry);
          },
          error: function(model, error) {
            if (typeof console !== "undefined" && console !== null) {
              console.error(error);
            }
            return reject(error);
          }
        });
      };
    })(this));
  };

  _Class.prototype.promiseClaimGameCode = function(code) {
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        if (code == null) {
          throw new Error("Game code must be specified");
        }
        if (!Entry.isValidCode(code)) {
          throw new Error("Valid game code must be given");
        }
        return (new Falcon.Model({
          endpoint: "rpc/claim_game_code"
        })).set({
          code: code
        }).create({
          parent: null,
          attributes: ['code'],
          success: function(model, data) {
            var entry, entry_data;
            entry_data = Entry.prototype.expand(data).toObject();
            entry = new Entry(entry_data);
            return resolve(entry);
          },
          error: function(model, error) {
            if (typeof console !== "undefined" && console !== null) {
              console.error(error);
            }
            return reject(error);
          }
        });
      };
    })(this));
  };

  _Class.prototype.promisePickGlobalContestWinner = function(arg) {
    var contest;
    contest = (arg != null ? arg : {}).contest;
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        if (!(contest instanceof Contest)) {
          throw new Error("contest must be an instanceof Contest");
        }
        if (contest.isNew()) {
          throw new Error("contest must not be new");
        }
        if (contest.get('type') !== Contest.GLOBAL_TYPE) {
          throw new Error("contest must be a franchise type contest");
        }
        return (new Falcon.Model({
          endpoint: "rpc/pick_global_contest_winner"
        })).set({
          contest_id: contest.get('id')
        }).create({
          parent: null,
          attributes: ['contest_id'],
          success: function(model, data) {
            var contest_winner, contest_winner_data;
            contest_winner_data = ContestWinner.prototype.expand(data).toObject();
            contest_winner = new ContestWinner(contest_winner_data);
            return resolve(contest_winner);
          },
          error: function(model, error) {
            if (typeof console !== "undefined" && console !== null) {
              console.error(error);
            }
            return reject(error);
          }
        });
      };
    })(this));
  };

  _Class.prototype.promiseManuallyPickGlobalContestWinner = function(arg) {
    var contest, ref, winner_name;
    ref = arg != null ? arg : {}, contest = ref.contest, winner_name = ref.winner_name;
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        if (!(contest instanceof Contest)) {
          throw new Error("contest must be an instanceof Contest");
        }
        if (contest.isNew()) {
          throw new Error("contest must not be new");
        }
        if (contest.get('type') !== Contest.GLOBAL_TYPE) {
          throw new Error("contest must be a global type contest");
        }
        return (new Falcon.Model({
          endpoint: "rpc/manually_pick_global_contest_winner"
        })).set({
          contest_id: contest.get('id'),
          winner_name: winner_name
        }).create({
          parent: null,
          attributes: ['contest_id', 'winner_name'],
          success: function(model, data) {
            var contest_winner, contest_winner_data;
            contest_winner_data = ContestWinner.prototype.expand(data).toObject();
            contest_winner = new ContestWinner(contest_winner_data);
            return resolve(contest_winner);
          },
          error: function(model, error) {
            if (typeof console !== "undefined" && console !== null) {
              console.error(error);
            }
            return reject(error);
          }
        });
      };
    })(this));
  };

  _Class.prototype.promisePickFPTContestWinners = function(arg) {
    var contest;
    contest = (arg != null ? arg : {}).contest;
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        if (!(contest instanceof Contest)) {
          throw new Error("contest must be an instanceof Contest");
        }
        if (contest.isNew()) {
          throw new Error("contest must not be new");
        }
        if (contest.get('type') !== Contest.FPT_TYPE) {
          throw new Error("contest must be a franchise type contest");
        }
        return (new Falcon.Model({
          endpoint: "rpc/pick_fpt_contest_winners"
        })).set({
          contest_id: contest.get('id')
        }).create({
          parent: null,
          attributes: ['contest_id'],
          success: function(model, data) {
            var contest_winners, contest_winners_data;
            contest_winners_data = ContestWinner.prototype.expand(data).toArray();
            contest_winners = new ContestWinners(contest_winners_data);
            return resolve(contest_winners);
          },
          error: function(model, error) {
            if (typeof console !== "undefined" && console !== null) {
              console.error(error);
            }
            return reject(error);
          }
        });
      };
    })(this));
  };

  _Class.prototype.promisePickFPTContestWinner = function(arg) {
    var contest, fpt, ref;
    ref = arg != null ? arg : {}, fpt = ref.fpt, contest = ref.contest;
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        if (!(fpt instanceof FPT)) {
          throw new Error("fpt must be an instanceof FPT");
        }
        if (fpt.isNew()) {
          throw new Error("fpt must not be new");
        }
        if (!(contest instanceof Contest)) {
          throw new Error("contest must be an instanceof Contest");
        }
        if (contest.isNew()) {
          throw new Error("contest must not be new");
        }
        if (contest.get('type') !== Contest.FPT_TYPE) {
          throw new Error("contest must be a fpt type contest");
        }
        return (new Falcon.Model({
          endpoint: "rpc/pick_fpt_contest_winner"
        })).set({
          fpt_id: fpt.get('id'),
          contest_id: contest.get('id')
        }).create({
          parent: null,
          attributes: ['fpt_id', 'contest_id'],
          success: function(model, data) {
            var contest_winner, contest_winner_data;
            contest_winner_data = ContestWinner.prototype.expand(data).toObject();
            contest_winner = new ContestWinner(contest_winner_data);
            return resolve(contest_winner);
          },
          error: function(model, error) {
            if (typeof console !== "undefined" && console !== null) {
              console.error(error);
            }
            return reject(error);
          }
        });
      };
    })(this));
  };

  _Class.prototype.promiseManuallyPickFPTContestWinner = function(arg) {
    var contest, fpt, ref, winner_name;
    ref = arg != null ? arg : {}, fpt = ref.fpt, contest = ref.contest, winner_name = ref.winner_name;
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        if (!(fpt instanceof FPT)) {
          throw new Error("fpt must be an instanceof FPT");
        }
        if (fpt.isNew()) {
          throw new Error("fpt must not be new");
        }
        if (!(contest instanceof Contest)) {
          throw new Error("contest must be an instanceof Contest");
        }
        if (contest.isNew()) {
          throw new Error("contest must not be new");
        }
        if (contest.get('type') !== Contest.FPT_TYPE) {
          throw new Error("contest must be a fpt type contest");
        }
        return (new Falcon.Model({
          endpoint: "rpc/manually_pick_fpt_contest_winner"
        })).set({
          fpt_id: fpt.get('id'),
          contest_id: contest.get('id'),
          winner_name: winner_name
        }).create({
          parent: null,
          attributes: ['fpt_id', 'contest_id', 'winner_name'],
          success: function(model, data) {
            var contest_winner, contest_winner_data;
            contest_winner_data = ContestWinner.prototype.expand(data).toObject();
            contest_winner = new ContestWinner(contest_winner_data);
            return resolve(contest_winner);
          },
          error: function(model, error) {
            if (typeof console !== "undefined" && console !== null) {
              console.error(error);
            }
            return reject(error);
          }
        });
      };
    })(this));
  };

  _Class.prototype.promisePickFranchiseContestWinner = function(arg) {
    var contest, franchise, ref;
    ref = arg != null ? arg : {}, franchise = ref.franchise, contest = ref.contest;
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        if (!(franchise instanceof Franchise)) {
          throw new Error("franchise must be an instanceof Franchise");
        }
        if (franchise.isNew()) {
          throw new Error("franchise must not be new");
        }
        if (!(contest instanceof Contest)) {
          throw new Error("contest must be an instanceof Contest");
        }
        if (contest.isNew()) {
          throw new Error("contest must not be new");
        }
        if (contest.get('type') !== Contest.FRANCHISE_TYPE) {
          throw new Error("contest must be a franchise type contest");
        }
        return (new Falcon.Model({
          endpoint: "rpc/pick_franchise_contest_winner"
        })).set({
          franchise_id: franchise.get('id'),
          contest_id: contest.get('id')
        }).create({
          parent: null,
          attributes: ['franchise_id', 'contest_id'],
          success: function(model, data) {
            var contest_winner, contest_winner_data;
            contest_winner_data = ContestWinner.prototype.expand(data).toObject();
            contest_winner = new ContestWinner(contest_winner_data);
            return resolve(contest_winner);
          },
          error: function(model, error) {
            if (typeof console !== "undefined" && console !== null) {
              console.error(error);
            }
            return reject(error);
          }
        });
      };
    })(this));
  };

  _Class.prototype.promiseManuallyPickFranchiseContestWinner = function(arg) {
    var contest, franchise, ref, winner_name;
    ref = arg != null ? arg : {}, franchise = ref.franchise, contest = ref.contest, winner_name = ref.winner_name;
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        if (!(franchise instanceof Franchise)) {
          throw new Error("franchise must be an instanceof Franchise");
        }
        if (franchise.isNew()) {
          throw new Error("franchise must not be new");
        }
        if (!(contest instanceof Contest)) {
          throw new Error("contest must be an instanceof Contest");
        }
        if (contest.isNew()) {
          throw new Error("contest must not be new");
        }
        if (contest.get('type') !== Contest.FRANCHISE_TYPE) {
          throw new Error("contest must be a franchise type contest");
        }
        return (new Falcon.Model({
          endpoint: "rpc/manually_pick_franchise_contest_winner"
        })).set({
          franchise_id: franchise.get('id'),
          contest_id: contest.get('id'),
          winner_name: winner_name
        }).create({
          parent: null,
          attributes: ['franchise_id', 'contest_id', 'winner_name'],
          success: function(model, data) {
            var contest_winner, contest_winner_data;
            contest_winner_data = ContestWinner.prototype.expand(data).toObject();
            contest_winner = new ContestWinner(contest_winner_data);
            return resolve(contest_winner);
          },
          error: function(model, error) {
            if (typeof console !== "undefined" && console !== null) {
              console.error(error);
            }
            return reject(error);
          }
        });
      };
    })(this));
  };

  _Class.prototype.promiseDrawContestFinalists = function(arg) {
    var contest, fpt, franchise;
    contest = arg.contest, fpt = arg.fpt, franchise = arg.franchise;
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        var data;
        if (!(contest instanceof Contest)) {
          throw new Error("contest must be provided");
        }
        if (contest.isNew()) {
          throw new Error("contest must not be new");
        }
        data = {};
        data['contest_id'] = contest.get('id');
        if (contest.get('type') === Contest.FPT_TYPE) {
          if (!(fpt instanceof FPT)) {
            throw new Error("fpt must be provided");
          }
          if (fpt.isNew()) {
            throw new Error("fpt must not be new");
          }
          data["fpt_id"] = fpt.get('id');
        } else if (contest.get('type') === Contest.FRANCHISE_TYPE) {
          if (!(franchise instanceof Franchise)) {
            throw new Error("franchise must be provided");
          }
          if (franchise.isNew()) {
            throw new Error("franchise must not be new");
          }
          data["franchise_id"] = franchise.get('id');
        }
        return new Falcon.Model({
          endpoint: "rpc/draw_contest_finalists"
        }).set(data).create({
          parent: null,
          attributes: _.keys(data),
          success: function(model, data) {
            var contest_finalist_data, contest_finalists;
            contest_finalist_data = ContestFinalist.prototype.expand(data).toArray();
            contest_finalists = new ContestFinalists(contest_finalist_data);
            return resolve(contest_finalists);
          },
          error: function(model, error) {
            if (typeof console !== "undefined" && console !== null) {
              console.error(error);
            }
            return reject(error);
          }
        });
      };
    })(this));
  };

  _Class.prototype.promiseMoveParticipantEntries = function(arg) {
    var contest_id, franchise_id, user_id;
    user_id = arg.user_id, contest_id = arg.contest_id, franchise_id = arg.franchise_id;
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        if (user_id == null) {
          throw new Error("user_id must be present");
        }
        if (contest_id == null) {
          throw new Error("contest_id must be present");
        }
        if (franchise_id == null) {
          throw new Error("franchise_id must be present");
        }
        return new Falcon.Model({
          endpoint: "rpc/move_participant_entries",
          user_id: user_id,
          contest_id: contest_id,
          franchise_id: franchise_id
        }).create({
          attributes: ['user_id', 'contest_id', 'franchise_id'],
          parent: null,
          success: function(model, data) {
            var entries, entries_data;
            entries_data = Entry.prototype.expand(data).toArray();
            entries = new Entries(entries_data);
            return resolve(entries);
          },
          error: function(model, error) {
            if (typeof console !== "undefined" && console !== null) {
              console.error(error);
            }
            return reject(error);
          }
        });
      };
    })(this));
  };

  _Class.prototype.promiseAdditionalContestStatistics = function(arg) {
    var contest_id;
    contest_id = arg.contest_id;
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        if (contest_id == null) {
          throw new Error("contest_id must be present");
        }
        return new Falcon.Model({
          endpoint: "rpc/additional_contest_statistics",
          contest_id: contest_id
        }).create({
          attributes: ['contest_id'],
          parent: null,
          success: function(model, data) {
            return resolve(data);
          },
          error: function(model, error) {
            if (typeof console !== "undefined" && console !== null) {
              console.error(error);
            }
            return reject(error);
          }
        });
      };
    })(this));
  };

  return _Class;

})());

},{"./$collections/contest_finalists.collection":24,"./$collections/contest_winners.collection":25,"./$collections/entries.collection":27,"./$collections/franchises.collection":31,"./$models/contest.model":44,"./$models/contest_finalist.model":45,"./$models/contest_winner.model":46,"./$models/entry.model":47,"./$models/fpt.model":48,"./$models/franchise.model":50,"./$models/game_kit.model":52,"./$models/invite.model":53,"./$models/session.model":57,"./$models/user.model":58}],66:[function(require,module,exports){
var Application, Environment, LayoutView, Session,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Environment = require("./environment");

Session = require("../$models/session.model");

LayoutView = require("./views/layout.view");

module.exports = Application = new ((function(superClass) {
  var ref;

  extend(_Class, superClass);

  function _Class() {
    return _Class.__super__.constructor.apply(this, arguments);
  }

  _Class.prototype.observables = {
    'is_online': (ref = typeof navigator !== "undefined" && navigator !== null ? navigator.onLine : void 0) != null ? ref : true,
    'is_checking_session': false,
    'current_session': null,
    'is_logged_in': function() {
      return this.current_session() instanceof Session;
    },
    'is_on_mobile': false,
    'current_user': function() {
      if (!this.is_logged_in()) {
        return null;
      }
      return this.current_session().get('user');
    }
  };

  _Class.prototype.init = function() {
    Environment.resolve();
    Language.loadFromCache();
    window.RPC = require("../rpc");
    this.checkIsOnMobile();
    this.attachWindowEvents();
    this.attachAdapterEvents();
    this.Layout = new LayoutView;
    return this.promiseCheckSession().then((function(_this) {
      return function(session) {
        return _this.login(session);
      };
    })(this)).fail((function(_this) {
      return function(error) {
        if (error == null) {
          return;
        }
        return _this.flashError(error);
      };
    })(this)).fin((function(_this) {
      return function() {
        return Falcon.apply(_this.Layout, '#application', function() {
          return Finch.options({
            CoerceParameterTypes: true
          }).listen();
        });
      };
    })(this)).done();
  };

  _Class.prototype.promiseCheckSession = function() {
    return Q.Promise((function(_this) {
      return function(resolve, reject) {
        if (_this.is_checking_session()) {
          return reject(null);
        }
        if (!Falcon.dataAdapter.hasToken()) {
          return reject(null);
        }
        _this.is_checking_session(true);
        return (new Session).promiseFetch().then(resolve, reject).fin(function() {
          return _this.is_checking_session(false);
        }).done();
      };
    })(this));
  };

  _Class.prototype.login = function(session) {
    session = ko.unwrap(session);
    if (!(session instanceof Session)) {
      throw new Error("session must be an instance of Session");
    }
    this.current_session(session);
    Application.trigger('login', session);
    return this;
  };

  _Class.prototype.logout = function() {
    if (!this.is_logged_in()) {
      return this;
    }
    Falcon.dataAdapter.clearToken();
    this.current_session(null);
    this.trigger('logout');
    return this;
  };

  _Class.prototype.flashError = function(error) {
    switch (false) {
      case !RequestHelpers.isUnauthorized(error):
        return typeof console !== "undefined" && console !== null ? console.error("Session Expired") : void 0;
      default:
        return Application.reportError(error);
    }
  };

  _Class.prototype.reportError = function(error) {
    var ref1, ref2;
    if (error == null) {
      error = {
        human: "An error occurred"
      };
    }
    if (typeof console !== "undefined" && console !== null) {
      console.error((ref1 = (ref2 = error.stack) != null ? ref2 : error.human) != null ? ref1 : "An error occurred");
    }
    return this;
  };

  _Class.prototype.attachWindowEvents = function() {
    window.addEventListener('online', (function(_this) {
      return function() {
        return _this.is_online(true);
      };
    })(this));
    window.addEventListener('offline', (function(_this) {
      return function() {
        return _this.is_online(false);
      };
    })(this));
    window.addEventListener('resize', (function(_this) {
      return function() {
        return _this.checkIsOnMobile();
      };
    })(this));
    window.addEventListener('click', (function(_this) {
      return function() {
        return Application.trigger("window:click");
      };
    })(this));
    return this;
  };

  _Class.prototype.attachAdapterEvents = function() {
    this.listenTo(Falcon.dataAdapter, 'unauthorized', this.logout);
    return this;
  };

  _Class.prototype.checkIsOnMobile = function() {
    if (window.hasOwnProperty('matchMedia')) {
      return this.is_on_mobile(window.matchMedia("(max-width: 640px) and (orientation: portrait), screen and (max-width: 1138px) and (orientation: landscape)").matches);
    } else {
      return this.is_on_mobile(false);
    }
  };

  return _Class;

})(Falcon.Object));

},{"../$models/session.model":57,"../rpc":65,"./environment":70,"./views/layout.view":79}],67:[function(require,module,exports){
var DOMHelpers;

DOMHelpers = require("../../$helpers/dom.helpers");

Falcon.addBinding("customHeroAnimation", {
  init: function(element, valueAccessor) {
    var $activeSlide, $element, $images, $nextSlide, $slides, $videos, duration, promiseChain, recurse;
    duration = ko.unwrap(valueAccessor()) || 1000;
    $element = $(element);
    $slides = $element.find(".so-hero--slide");
    $activeSlide = $slides.filter(".is-active");
    $nextSlide = $activeSlide.next(".so-hero--slide");
    if ($nextSlide.length === 0) {
      $nextSlide = $slides.first();
    }
    $images = $slides.find("img[data-src]");
    $videos = $slides.find("video");
    recurse = (function(_this) {
      return function() {
        var _ended, next, player, videoElm;
        next = function() {
          var delay;
          delay = 250;
          $activeSlide.find(".so-hero--layer").each(function(index, layer) {
            DOMHelpers.defer(index * 150, function() {
              return DOMHelpers.removeClass(layer, "is-visible");
            });
            return delay = Math.max(DOMHelpers.getDuration(layer) + (index * 100), delay);
          });
          return DOMHelpers.defer(delay, function() {
            $activeSlide.removeClass("is-active");
            $nextSlide.addClass("is-active");
            delay = 250;
            $nextSlide.find(".so-hero--layer").each(function(index, layer) {
              DOMHelpers.defer(index * 150, (function(_this) {
                return function() {
                  return DOMHelpers.addClass(layer, "is-visible");
                };
              })(this));
              return delay = Math.max(DOMHelpers.getDuration(layer) + (index * 100), delay);
            });
            return DOMHelpers.defer(delay, function() {
              $activeSlide = $nextSlide;
              $nextSlide = $activeSlide.next(".so-hero--slide");
              if ($nextSlide.length === 0) {
                $nextSlide = $slides.first();
              }
              return recurse();
            });
          });
        };
        videoElm = $activeSlide.find('video');
        player = videoElm.data('player');
        if (player != null) {
          player.on('ended', _ended = function() {
            player.off('ended', _ended);
            return next();
          });
          return player.play();
        } else {
          return DOMHelpers.defer(duration, next);
        }
      };
    })(this);
    promiseChain = Q.fcall(function() {});
    $images.each(function(index, image) {
      return promiseChain = promiseChain.then(function() {
        return Q.Promise(function(resolve, reject) {
          var img, src;
          img = new Image();
          img.onload = function() {
            image.src = img.src;
            return resolve();
          };
          img.onerror = reject;
          src = $(image).data('src');
          return ko.computed({
            disposeWhenNodeIsRemoved: element,
            read: function() {
              return img.src = Language(src);
            }
          });
        });
      });
    });
    $videos.each(function(index, video) {
      return promiseChain = promiseChain.then(function() {
        return Q.Promise(function(resolve, reject) {
          var $sources, $video, player;
          if (typeof videojs === "undefined" || videojs === null) {
            return reject("VideoJS is Undefined");
          }
          $video = $(video);
          $sources = $video.find("source[data-src]");
          player = videojs(video);
          ko.computed({
            disposeWhenNodeIsRemoved: element,
            read: function() {
              var is_playing, source_array;
              is_playing = !player.paused();
              source_array = [];
              $sources.each(function(index, source) {
                var $source;
                $source = $(source);
                return source_array.push({
                  type: $source.attr('type'),
                  src: Language($source.data('src'))
                });
              });
              player.src(source_array);
              if (is_playing) {
                return player.play();
              }
            }
          });
          player.ready(function() {
            $video.addClass('is-ready');
            $video.data('player', player);
            return resolve(player);
          });
          return player.on('error', function(err) {
            if (typeof Raven !== "undefined" && Raven !== null) {
              Raven.captureException(err);
            }
            return reject();
          });
        });
      });
    });
    return promiseChain.fail(function(err) {
      console.log("Error", err);
      return typeof Raven !== "undefined" && Raven !== null ? Raven.captureException(err) : void 0;
    }).fin(recurse).done();
  }
});

},{"../../$helpers/dom.helpers":39}],68:[function(require,module,exports){
var tempElm;

tempElm = document.createElement("div");

Falcon.addBinding("lang", true, function(element, valueAccessor) {
  tempElm.innerHTML = Language(ko.unwrap(valueAccessor()));
  return ko.virtualElements.setDomNodeChildren(element, Array.prototype.slice.call(tempElm.childNodes));
});

},{}],69:[function(require,module,exports){
(function (global){
require("../$polyfills/function.bind");

require("../$polyfills/requestAnimationFrame");

require("../$bindings/dateText.binding");

require("../$bindings/dateTimeText.binding");

require("../$bindings/dateValue.binding");

require("../$bindings/daysUntilText.binding");

require("../$bindings/fromNowText.binding");

require("../$bindings/hashHref.binding");

require("../$bindings/href.binding");

require("../$bindings/isHovered.binding");

require("../$bindings/moment.binding");

require("../$bindings/monthText.binding");

require("../$bindings/monthYearText.binding");

require("../$bindings/followCursor.binding");

require("../$bindings/onEnter.binding");

require("../$bindings/onScrollBottom.binding");

require("../$bindings/preventDefault.binding");

require("../$bindings/s3Upload.binding");

require("../$bindings/selectize.binding");

require("../$bindings/src.binding");

require("../$bindings/stopEvent.binding");

require("../$bindings/stopPropagation.binding");

require("../$bindings/percent.binding");

require("../$bindings/integer.binding");

require("../$bindings/decimal.binding");

require("./bindings/lang.binding");

require("./bindings/customHeroAnimation.binding");

require("../extenders");

require("./ipinfo");

global.Helpers = require("../$helpers/default.helpers");

global.DOMHelpers = require("../$helpers/dom.helpers");

global.RequestHelpers = require("../$helpers/request.helpers");

global.Router = require("./router");

global.Application = require("./application");

global.Language = require("./language");

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../$bindings/dateText.binding":1,"../$bindings/dateTimeText.binding":2,"../$bindings/dateValue.binding":3,"../$bindings/daysUntilText.binding":4,"../$bindings/decimal.binding":5,"../$bindings/followCursor.binding":6,"../$bindings/fromNowText.binding":7,"../$bindings/hashHref.binding":8,"../$bindings/href.binding":9,"../$bindings/integer.binding":10,"../$bindings/isHovered.binding":11,"../$bindings/moment.binding":12,"../$bindings/monthText.binding":13,"../$bindings/monthYearText.binding":14,"../$bindings/onEnter.binding":15,"../$bindings/onScrollBottom.binding":16,"../$bindings/percent.binding":17,"../$bindings/preventDefault.binding":18,"../$bindings/s3Upload.binding":19,"../$bindings/selectize.binding":20,"../$bindings/src.binding":21,"../$bindings/stopEvent.binding":22,"../$bindings/stopPropagation.binding":23,"../$helpers/default.helpers":38,"../$helpers/dom.helpers":39,"../$helpers/request.helpers":40,"../$polyfills/function.bind":60,"../$polyfills/requestAnimationFrame":61,"../extenders":62,"./application":66,"./bindings/customHeroAnimation.binding":67,"./bindings/lang.binding":68,"./ipinfo":71,"./language":72,"./router":73}],70:[function(require,module,exports){
var Environment, JWTAdapater;

JWTAdapater = require("../jwt_adapter");

module.exports = Environment = new ((function() {
  function _Class() {}

  window.ENV = {};

  _Class.prototype.configure = function(environment) {
    var setup_method;
    if (!_.isString(environment)) {
      environment = "local";
    }
    environment = Helpers.trim(environment).toLowerCase();
    if (environment === "configure") {
      environment = "local";
    }
    setup_method = this[environment];
    if (!_.isFunction(setup_method)) {
      setup_method = this.local;
    }
    if (setup_method == null) {
      setup_method = (function() {});
    }
    this.all();
    setup_method();
    return this;
  };

  _Class.prototype.resolve = function() {
    var _match;
    _match = function(url) {
      return window.location.href.indexOf(url) > -1;
    };
    if (_match("localhost.com:9000")) {
      return this.redirect('localhost:9000');
    }
    if (_match("localhost:9000")) {
      return this.configure('local');
    }
    if (_match("www-dev.snaponrollincold.com")) {
      return this.configure('development');
    }
    if (_match("www.snaponrollincold.com")) {
      return this.configure('production');
    }
    throw "Could not resolve the environment.";
  };

  _Class.prototype.redirect = function(url) {
    url = url + "/" + window.location.hash;
    url = (" " + url).replace(/([^:])\/+/gi, "$1/");
    url = Helpers.trim(url);
    if (!/^https?:\/\//gi.test(url)) {
      url = "http://" + url;
    }
    window.location.href = url;
    return this;
  };

  _Class.prototype.all = function() {
    Falcon.dataAdapter = new JWTAdapater;
    Falcon.dataAdapter.cache = true;
    $.ajaxSetup({
      headers: {
        'Accept': "application/json; charset=utf-8",
        'Content-Type': "application/json; charset=utf-8"
      },
      crossDomain: true
    });
    $.support.cors = true;
    if (typeof Bugsnag !== "undefined" && Bugsnag !== null) {
      Bugsnag.notifyReleaseStages = ["development", "staging", "production"];
    }
    if (typeof Bugsnag !== "undefined" && Bugsnag !== null) {
      Bugsnag.appVersion = "0.0.1";
    }
    return this;
  };

  _Class.prototype.production = function() {
    Falcon.baseApiUrl = "https://snapon-api-prod.herokuapp.com";
    if (typeof Raven !== "undefined" && Raven !== null) {
      Raven.config('https://d8fbbcda1e4043c3b9b455ca187f4286@sentry.io/125775').install({
        environment: "production",
        tags: {
          app: "web"
        }
      });
    }
    return this;
  };

  _Class.prototype.development = function() {
    Falcon.baseApiUrl = "https://snapon-api-dev.herokuapp.com";
    if (typeof Raven !== "undefined" && Raven !== null) {
      Raven.config('https://598429aaa4334a659b88987a62c69973@sentry.io/125702').install({
        environment: "development",
        tags: {
          app: "web"
        }
      });
    }
    return this;
  };

  _Class.prototype.local = function() {
    Falcon.baseApiUrl = "http://localhost:9292";
    if (typeof Raven !== "undefined" && Raven !== null) {
      Raven.config('https://598429aaa4334a659b88987a62c69973@sentry.io/125702').install({
        environment: "local",
        tags: {
          app: "web"
        }
      });
    }
    return this;
  };

  return _Class;

})());

},{"../jwt_adapter":64}],71:[function(require,module,exports){
(function() {
  var country, ip, script;
  ip = ko.observable();
  country = ko.observable();
  window.IPInfo = {
    ip: ip,
    country: country,
    isLoaded: ko.observable(false),
    isInUnitedStates: ko.computed(function() {
      return /^(united states|us)$/i.test(country());
    }),
    isInCanada: ko.computed(function() {
      return /^ca(nada)?$/i.test(country());
    })
  };
  window.ipinfoJsonpResponse = function(data) {
    IPInfo.ip(data.ip);
    IPInfo.country(data.country);
    return IPInfo.isLoaded(true);
  };
  script = document.createElement('script');
  script.src = 'http://ipinfo.io?callback=ipinfoJsonpResponse';
  return document.head.appendChild(script);
})();

},{}],72:[function(require,module,exports){
var LANGUAGE_CODE_KEY, Language;

LANGUAGE_CODE_KEY = "__SO_LANGUAGE_CODE__";

Language = function(translationText) {
  var language;
  if (!_.isString(translationText)) {
    return translationText;
  }
  language = Language.resolveLanguage();
  if ((translationText in language.translations) && (language.translations[translationText] != null)) {
    return language.translations[translationText];
  }
  if (language !== Language.DEFAULT) {
    if (typeof console !== "undefined" && console !== null) {
      console.warn("Couldn't find translation for: '" + translationText + "'");
    }
  }
  return translationText;
};

Language.LANGUAGES = {
  "us/en": require("../$languages/en-us.language"),
  "ca/en": require("../$languages/en-ca.language"),
  "ca/fr": require("../$languages/fr-ca.language")
};

Language.DEFAULT = Language.LANGUAGES["us/en"];

Language.selectedLanguageCode = ko.observable(void 0);

Language.hasSelectedLanguage = ko.computed(function() {
  var code;
  code = Language.selectedLanguageCode();
  if (code == null) {
    return false;
  }
  return code in Language.LANGUAGES;
});

Language.selectCode = function(code) {
  var e, message, ref;
  if (_.isString(code) && (code in Language.LANGUAGES)) {
    Language.selectedLanguageCode(code);
    try {
      localStorage[LANGUAGE_CODE_KEY] = code;
    } catch (error) {
      e = error;
      message = (ref = e.message) != null ? ref : "QuotaExceededError";
      if (typeof Raven !== "undefined" && Raven !== null) {
        Raven.captureMessage(message, {
          'level': 'warning'
        });
      }
      if (typeof console !== "undefined" && console !== null) {
        console.error(e);
      }
    }
  }
  return Language.selectedLanguageCode();
};

Language.loadFromCache = function() {
  var code, e, language, message, ref;
  try {
    if (localStorage[LANGUAGE_CODE_KEY] == null) {
      return;
    }
    code = localStorage[LANGUAGE_CODE_KEY];
    if (!_.isString(code)) {
      delete localStorage[LANGUAGE_CODE_KEY];
      return;
    }
    language = Language.LANGUAGES[code];
    if (code in Language.LANGUAGES) {
      return Language.selectedLanguageCode(code);
    } else {
      return delete localStorage[LANGUAGE_CODE_KEY];
    }
  } catch (error) {
    e = error;
    message = (ref = e.message) != null ? ref : "QuotaExceededError";
    if (typeof Raven !== "undefined" && Raven !== null) {
      Raven.captureMessage(message, {
        'level': 'warning'
      });
    }
    return typeof console !== "undefined" && console !== null ? console.error(e) : void 0;
  }
};

Language.clear = function() {
  var code, e, message, ref;
  if (!Language.hasSelectedLanguage()) {
    return;
  }
  code = Language.selectedLanguageCode();
  Language.selectedLanguageCode(void 0);
  try {
    return delete localStorage[code];
  } catch (error) {
    e = error;
    message = (ref = e.message) != null ? ref : "QuotaExceededError";
    if (typeof Raven !== "undefined" && Raven !== null) {
      Raven.captureMessage(message, {
        'level': 'warning'
      });
    }
    return typeof console !== "undefined" && console !== null ? console.error(e) : void 0;
  }
};

Language.resolveLanguage = function() {
  var code, ref;
  code = Language.selectedLanguageCode() || "";
  return (ref = Language.LANGUAGES[code]) != null ? ref : Language.DEFAULT;
};

Language.isWithinUnitedStates = ko.computed(function() {
  var ref;
  return (ref = Language.selectedLanguageCode()) === "us/en";
});

Language.isWithinCanada = ko.computed(function() {
  var ref;
  return (ref = Language.selectedLanguageCode()) === "ca/en" || ref === "ca/fr";
});

module.exports = Language;

},{"../$languages/en-ca.language":41,"../$languages/en-us.language":42,"../$languages/fr-ca.language":43}],73:[function(require,module,exports){
var ChangePasswordView, CheckGameCodeView, DashboardView, ForgotPasswordView, HomeView, LoginView, ManageAccountInformationView, ManageAccountView, RegistrationView, ResetPasswordView, Router, User;

User = require("../$models/user.model");

ChangePasswordView = require("./views/change_password.view");

CheckGameCodeView = require("./views/check_game_code.view");

DashboardView = require("./views/dashboard.view");

ForgotPasswordView = require("./views/forgot_password.view");

HomeView = require("./views/home.view");

LoginView = require("./views/login.view");

ManageAccountView = require("./views/manage_account.view");

ManageAccountInformationView = require("./views/manage_account_information.view");

RegistrationView = require("./views/registration.view");

ResetPasswordView = require("./views/reset_password.view");

module.exports = Router = new ((function() {
  var appendParams;

  function _Class() {}

  appendParams = function(url, params) {
    var key, value;
    url = Helpers.trim(url);
    if (params == null) {
      return url;
    }
    url += (url.indexOf("?") === -1 ? "?" : "&");
    url += ((function() {
      var results;
      results = [];
      for (key in params) {
        value = params[key];
        results.push(key + "=" + value);
      }
      return results;
    })()).join("&");
    return url;
  };

  Finch.route("/", {
    setup: function() {
      if (!Application.is_logged_in()) {
        Finch.abort();
        return Router.gotoCheckGameCode();
      }
    },
    load: function() {
      Application.Layout.setAuthorizedView(this.view = new HomeView);
      return Finch.observe("did_create_session_with_code", (function(_this) {
        return function(did_create_session_with_code) {
          if (did_create_session_with_code !== true && did_create_session_with_code !== "true") {
            return;
          }
          return _this.view.showDidCreateSessionWithCode();
        };
      })(this));
    }
  });

  _Class.prototype.makeMainUrl = function(params) {
    return appendParams("/", params);
  };

  _Class.prototype.gotoMain = function(params) {
    var main_url;
    main_url = Router.makeMainUrl(params);
    Finch.navigate(main_url);
    return Router;
  };

  Finch.route("/check_game_code", {
    load: function() {
      Application.Layout.forceShowUnauthorizedView();
      this.view = new CheckGameCodeView();
      Finch.observe("not_authorized", (function(_this) {
        return function(not_authorized) {
          if (not_authorized) {
            return _this.view.showNotAuthorized();
          }
        };
      })(this));
      return Application.Layout.setUnauthorizedView(this.view);
    },
    unload: function() {
      Application.Layout.tryShowAuthorizedView();
      return this.view.off();
    }
  });

  _Class.prototype.makeCheckGameCodeUrl = function(params) {
    return appendParams("/check_game_code", params);
  };

  _Class.prototype.gotoCheckGameCode = function(params) {
    var url;
    url = Router.makeCheckGameCodeUrl(params);
    Finch.navigate(url);
    return Router;
  };

  Finch.route("/login", {
    load: function() {
      Application.Layout.forceShowUnauthorizedView();
      this.view = new LoginView();
      Finch.observe((function(_this) {
        return function(params) {
          var game_code, not_authorized;
          not_authorized = params('not_authorized');
          if (not_authorized) {
            _this.view.showNotAuthorized();
          }
          game_code = params('game_code');
          return _this.view.setGameCode(game_code);
        };
      })(this));
      return Application.Layout.setUnauthorizedView(this.view);
    },
    unload: function() {
      Application.Layout.tryShowAuthorizedView();
      return this.view.off();
    }
  });

  _Class.prototype.makeLoginUrl = function(params) {
    return appendParams("/login", params);
  };

  _Class.prototype.gotoLogin = function(params) {
    var url;
    url = Router.makeLoginUrl(params);
    Finch.navigate(url);
    return Router;
  };

  Finch.route("/forgot_password", {
    load: function() {
      Application.Layout.forceShowUnauthorizedView();
      this.view = new ForgotPasswordView();
      return Application.Layout.setUnauthorizedView(this.view);
    },
    unload: function() {
      Application.Layout.tryShowAuthorizedView();
      return this.view.off();
    }
  });

  _Class.prototype.makeForgotPasswordUrl = function(params) {
    return appendParams("/forgot_password", params);
  };

  _Class.prototype.gotoForgotPassword = function() {
    var url;
    url = Router.makeForgotPasswordUrl();
    Finch.navigate(url);
    return Router;
  };

  Finch.route("/reset_password", {
    load: function() {
      Application.Layout.forceShowUnauthorizedView();
      this.view = new ResetPasswordView();
      Finch.observe((function(_this) {
        return function(params) {
          _this.view.setEmail(params('email'));
          return _this.view.setResetCode(params('reset_code'));
        };
      })(this));
      return Application.Layout.setUnauthorizedView(this.view);
    },
    unload: function() {
      Application.Layout.tryShowAuthorizedView();
      return this.view.off();
    }
  });

  _Class.prototype.makeResetPasswordUrl = function(params) {
    return appendParams("/forgot_password", params);
  };

  _Class.prototype.gotoResetPassword = function() {
    var url;
    url = Router.makeResetPasswordUrl();
    Finch.navigate(url);
    return Router;
  };

  Finch.route("/registration", {
    load: function() {
      Application.Layout.forceShowUnauthorizedView();
      this.view = new RegistrationView();
      Finch.observe("game_code", (function(_this) {
        return function(game_code) {
          return _this.view.setGameCode(game_code);
        };
      })(this));
      return Application.Layout.setUnauthorizedView(this.view);
    },
    unload: function() {
      Application.Layout.tryShowAuthorizedView();
      return this.view.off();
    }
  });

  _Class.prototype.makeRegistrationUrl = function(params) {
    return appendParams("/registration", params);
  };

  _Class.prototype.gotoRegistration = function(params) {
    var url;
    url = Router.makeRegistrationUrl(params);
    Finch.navigate(url);
    return Router;
  };

  Finch.route("[/]manage_account", {
    setup: function() {
      this.view = new ManageAccountView();
      return Application.Layout.setAuthorizedView(this.view);
    },
    load: function() {
      this.info_view = new ManageAccountInformationView;
      return this.view.setInternalView(this.info_view);
    },
    unload: function() {
      return this.info_view.off();
    },
    teardown: function() {
      return this.view.off();
    }
  });

  _Class.prototype.makeManageAccountUrl = function(params) {
    return appendParams("/manage_account", params);
  };

  _Class.prototype.gotoManageAccount = function() {
    var url;
    url = Router.makeManageAccountUrl();
    Finch.navigate(url);
    return Router;
  };

  Finch.route("[/manage_account]/change_password", {
    load: function() {
      this.view = new ChangePasswordView();
      return this.parent.view.setInternalView(this.view);
    },
    unload: function() {
      return this.view.off();
    }
  });

  _Class.prototype.createChangePasswordUrl = function(params) {
    return appendParams("/manage_account/change_password", params);
  };

  _Class.prototype.gotoChangePassword = function() {
    var url;
    url = Router.createChangePasswordUrl();
    Finch.navigate(url);
    return Router;
  };

  return _Class;

})());

},{"../$models/user.model":58,"./views/change_password.view":74,"./views/check_game_code.view":75,"./views/dashboard.view":76,"./views/forgot_password.view":77,"./views/home.view":78,"./views/login.view":80,"./views/manage_account.view":81,"./views/manage_account_information.view":82,"./views/registration.view":83,"./views/reset_password.view":84}],74:[function(require,module,exports){
var ChangePasswordView, RPC,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

RPC = require("../../rpc");

module.exports = ChangePasswordView = (function(superClass) {
  extend(ChangePasswordView, superClass);

  function ChangePasswordView() {
    return ChangePasswordView.__super__.constructor.apply(this, arguments);
  }

  ChangePasswordView.prototype.endpoint = "#change_password-template";

  ChangePasswordView.prototype.observables = {
    'is_saving': false,
    'alert': "",
    'old_password': "",
    'new_password': "",
    'retype_password': ""
  };

  ChangePasswordView.prototype.initialize = function() {
    this.alert.decorate('validatable');
    this.old_password.decorate('validatable').subscribe(this.validateOldPassword, this);
    this.new_password.decorate('validatable').subscribe(this.validateNewPassword, this);
    return this.retype_password.decorate('validatable').subscribe(this.validateRetypePassword, this);
  };

  ChangePasswordView.prototype.validateOldPassword = function() {
    var old_password;
    old_password = Helpers.trim(this.old_password());
    if (_.isEmpty(old_password)) {
      return this.old_password.setIsValid(false, "Please enter your current password");
    }
    return this.old_password.setIsValid(true);
  };

  ChangePasswordView.prototype.validateNewPassword = function() {
    var new_password;
    new_password = Helpers.trim(this.new_password());
    if (_.isEmpty(new_password)) {
      return this.new_password.setIsValid(false, "Please enter a new password");
    }
    return this.new_password.setIsValid(true);
  };

  ChangePasswordView.prototype.validateRetypePassword = function() {
    var new_password, retype_password;
    retype_password = Helpers.trim(this.retype_password());
    if (_.isEmpty(retype_password)) {
      return this.retype_password.setIsValid(false, "Please retype your new password");
    }
    new_password = Helpers.trim(this.new_password());
    if (new_password !== retype_password) {
      return this.retype_password.setIsValid(false, "Passwords don't match");
    }
    return this.retype_password.setIsValid(true);
  };

  ChangePasswordView.prototype.save = function() {
    var new_password, old_password;
    if (!Application.is_logged_in()) {
      return this;
    }
    if (this.is_saving()) {
      return this;
    }
    if (!(this.validateOldPassword() && this.validateNewPassword() && this.validateRetypePassword())) {
      return this;
    }
    old_password = ko.unwrap(this.old_password);
    new_password = ko.unwrap(this.new_password);
    this.is_saving(true);
    RPC.promiseChangePassword(old_password, new_password).then((function(_this) {
      return function(user) {
        _this.alert.setIsValid(true, "Successfully changed password!");
        return _this.resetFields();
      };
    })(this)).fail((function(_this) {
      return function() {
        return _this.alert.setIsValid(false, "An error occurred while saving account information");
      };
    })(this)).fin((function(_this) {
      return function() {
        return _this.is_saving(false);
      };
    })(this)).done();
    return this;
  };

  ChangePasswordView.prototype.resetFields = function() {
    this.old_password("");
    this.old_password.resetValidations();
    this.new_password("");
    this.new_password.resetValidations();
    this.retype_password("");
    this.retype_password.resetValidations();
    return this;
  };

  return ChangePasswordView;

})(Falcon.View);

},{"../../rpc":65}],75:[function(require,module,exports){
var CheckGameCodeView, Entry, RPC,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Entry = require("../../$models/entry.model");

RPC = require("../../rpc");

module.exports = CheckGameCodeView = (function(superClass) {
  extend(CheckGameCodeView, superClass);

  function CheckGameCodeView() {
    return CheckGameCodeView.__super__.constructor.apply(this, arguments);
  }

  CheckGameCodeView.prototype.endpoint = '#check_game_code-template';

  CheckGameCodeView.prototype.observables = {
    'alert': "",
    'is_checking': false,
    'submit_is_disabled': function() {
      if (this.is_checking()) {
        return true;
      }
      if (this.game_code().length !== 10) {
        return true;
      }
      return false;
    },
    'game_code': ""
  };

  CheckGameCodeView.prototype.initialize = function() {
    this.alert.decorate('validatable');
    return this.game_code.decorate('validatable').subscribe(this.validateGameCode, this);
  };

  CheckGameCodeView.prototype.validateGameCode = function() {
    var game_code;
    game_code = this.game_code();
    if (!Entry.isValidCode(game_code)) {
      return this.game_code.setIsValid(false, "Please enter a valid Game Code");
    }
    return this.game_code.setIsValid(true);
  };

  CheckGameCodeView.prototype.resetFields = function() {
    this.alert("");
    this.alert.resetValidations();
    this.game_code("");
    this.game_code.resetValidations();
    return this;
  };

  CheckGameCodeView.prototype.check = function() {
    var game_code, game_code_is_valid;
    game_code_is_valid = this.validateGameCode();
    if (!game_code_is_valid) {
      return this;
    }
    if (this.is_checking()) {
      return this;
    }
    game_code = this.game_code();
    this.is_checking(true);
    RPC.promiseCheckGameCode(game_code).then((function(_this) {
      return function(entry) {
        _this.resetFields();
        return Router.gotoRegistration({
          game_code: game_code
        });
      };
    })(this)).fail((function(_this) {
      return function(error) {
        if ((error != null ? error.human : void 0) != null) {
          alert(error.human);
        }
        Application.flashError(error);
        return _this.alert.setIsValid(false, error.human);
      };
    })(this)).fin((function(_this) {
      return function() {
        return _this.is_checking(false);
      };
    })(this)).done();
    return this;
  };

  CheckGameCodeView.prototype.showNotAuthorized = function() {
    return this.alert.setIsValid(false, "You're not authorized to login here");
  };

  CheckGameCodeView.prototype.gotoLogin = function() {
    return Router.gotoLogin();
  };

  CheckGameCodeView.prototype.gotoRegistration = function() {
    return Router.gotoRegistration();
  };

  return CheckGameCodeView;

})(Falcon.View);

},{"../../$models/entry.model":47,"../../rpc":65}],76:[function(require,module,exports){
var DashboardView, HomeView, ManageAccountView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

HomeView = require("./home.view");

ManageAccountView = require("./manage_account.view");

module.exports = DashboardView = (function(superClass) {
  extend(DashboardView, superClass);

  function DashboardView() {
    return DashboardView.__super__.constructor.apply(this, arguments);
  }

  DashboardView.prototype.endpoint = "#dashboard-template";

  DashboardView.prototype.observables = {
    'internal_view': null,
    'home_is_selected': function() {
      return this.internal_view() instanceof HomeView;
    },
    'manage_account_is_selected': function() {
      return this.internal_view() instanceof ManageAccountView;
    }
  };

  DashboardView.prototype.setInternalView = function(view) {
    if (!Falcon.isView(view)) {
      throw new Error("view must be a Falcon.View");
    }
    this.internal_view(view);
    return this;
  };

  DashboardView.prototype.gotoHome = function() {
    return Router.gotoMain();
  };

  DashboardView.prototype.gotoManageAccount = function() {
    return Router.gotoManageAccount();
  };

  DashboardView.prototype.logout = function() {
    Application.logout();
    return Router.gotoLogin();
  };

  return DashboardView;

})(Falcon.View);

},{"./home.view":78,"./manage_account.view":81}],77:[function(require,module,exports){
var ForgotPasswordView, RPC,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

RPC = require("../../rpc");

module.exports = ForgotPasswordView = (function(superClass) {
  extend(ForgotPasswordView, superClass);

  function ForgotPasswordView() {
    return ForgotPasswordView.__super__.constructor.apply(this, arguments);
  }

  ForgotPasswordView.prototype.endpoint = '#forgot_password-template';

  ForgotPasswordView.prototype.observables = {
    'alert': "",
    'is_sending': false,
    'reset_did_send': false,
    'email': ""
  };

  ForgotPasswordView.prototype.initialize = function() {
    this.alert.decorate('validatable');
    return this.email.decorate('validatable').subscribe(this.validateEmail, this);
  };

  ForgotPasswordView.prototype.validateEmail = function() {
    var email;
    email = Helpers.trim(this.email());
    if (_.isEmpty(email)) {
      return this.email.setIsValid(false, "Email must not be empty");
    }
    if (!Helpers.isEmail(email)) {
      return this.email.setIsValid(false, "Email is formatted incorrectly");
    }
    return this.email.setIsValid(true);
  };

  ForgotPasswordView.prototype.resetFields = function() {
    this.alert("");
    this.alert.resetValidations();
    this.email("");
    this.email.resetValidations();
    return this;
  };

  ForgotPasswordView.prototype.send = function() {
    var email;
    if (!this.validateEmail()) {
      return this;
    }
    if (this.is_sending()) {
      return this;
    }
    email = Helpers.trim(this.email());
    this.is_sending(true);
    RPC.promiseForgotPassword(email).then((function(_this) {
      return function() {
        _this.reset_did_send(true);
        return _this.resetFields();
      };
    })(this)).fail((function(_this) {
      return function(error) {
        Application.flashError(error);
        return _this.alert.setIsValid(false, error.human);
      };
    })(this)).fin((function(_this) {
      return function() {
        return _this.is_sending(false);
      };
    })(this)).done();
    return this;
  };

  ForgotPasswordView.prototype.gotoLogin = function() {
    return Router.gotoLogin();
  };

  return ForgotPasswordView;

})(Falcon.View);

},{"../../rpc":65}],78:[function(require,module,exports){
var Contest, Contests, Entry, HomeView, RPC, User, UserContestStatistic, UserContestStatistics,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

User = require("../../$models/user.model");

Entry = require("../../$models/entry.model");

Contest = require("../../$models/contest.model");

Contests = require("../../$collections/contests.collection");

UserContestStatistic = require("../../$models/user_contest_statistic.model");

UserContestStatistics = require("../../$collections/user_contest_statistics.collection");

RPC = require("../../rpc");

module.exports = HomeView = (function(superClass) {
  extend(HomeView, superClass);

  function HomeView() {
    return HomeView.__super__.constructor.apply(this, arguments);
  }

  HomeView.prototype.endpoint = "#home-template";

  HomeView.prototype.defaults = {
    'contests': function() {
      return (new Contests).setFilter('codes', [Contest.ROLLIN_COLD_2017]);
    },
    'user_contest_statistics': function() {
      return (new UserContestStatistics).setFilter('contest_codes', [Contest.ROLLIN_COLD_2017]);
    }
  };

  HomeView.prototype.observables = {
    'alert': "",
    'is_loading': false,
    'is_claiming': false,
    'game_code': "",
    'game_code_has_focus': false,
    'should_show_add_code_button': function() {
      if (this.game_code_has_focus()) {
        return true;
      }
      if (!_.isEmpty(this.game_code())) {
        return true;
      }
      return false;
    },
    'add_is_disabled': function() {
      if (Helpers.trim(this.game_code()).length !== 10) {
        return true;
      }
      return false;
    },
    'claimed_game_code_count': 0,
    'did_create_session_with_code': false,
    'has_claimed_codes': function() {
      return this.claimed_game_code_count() > 0;
    },
    'current_user_first_name': function() {
      var ref, ref1;
      if (!Application.is_logged_in()) {
        return "";
      }
      return (ref = (ref1 = Application.current_user()) != null ? ref1.get('first_name') : void 0) != null ? ref : "";
    }
  };

  HomeView.prototype.showDidCreateSessionWithCode = function() {
    this.claimed_game_code_count(this.claimed_game_code_count() + 1);
    return this.did_create_session_with_code(true);
  };

  HomeView.prototype.initialize = function() {
    this.alert.decorate('validatable');
    this.game_code.decorate('validatable').subscribe(this.validateGameCode, this);
    if (Application.is_logged_in()) {
      return this.fetchInformation();
    } else {
      return this.listenToOnce(Application, 'login', this.fetchInformation);
    }
  };

  HomeView.prototype.validateGameCode = function() {
    var game_code;
    game_code = ko.unwrap(this.game_code);
    if (!Entry.isValidCode(game_code)) {
      return this.game_code.setIsValid(false, "Invalid Game Code");
    }
    return this.game_code.setIsValid(true);
  };

  HomeView.prototype.fetchInformation = function() {
    var current_user;
    if (!Application.is_logged_in()) {
      return this;
    }
    if (this.is_loading()) {
      return this;
    }
    this.is_loading(true);
    current_user = Application.current_user();
    Q.all([
      this.contests.promiseFetch({
        parent: current_user
      }), this.user_contest_statistics.promiseFetch({
        parent: current_user
      })
    ]).fail((function(_this) {
      return function() {};
    })(this)).fin((function(_this) {
      return function() {
        return _this.is_loading(false);
      };
    })(this));
    return this;
  };

  HomeView.prototype.resetFields = function() {
    this.game_code("");
    this.game_code.resetValidations();
    return this;
  };

  HomeView.prototype.claimGameCode = function() {
    var game_code;
    if (!Application.is_logged_in()) {
      return this;
    }
    if (this.is_claiming()) {
      return this;
    }
    if (!(this.validateGameCode())) {
      return this;
    }
    game_code = this.game_code();
    this.is_claiming(true);
    RPC.promiseClaimGameCode(game_code).then((function(_this) {
      return function(entry) {
        _this.resetFields();
        _this.claimed_game_code_count(_this.claimed_game_code_count() + 1);
        _this.did_create_session_with_code(false);
        Application.trigger("entry:save", entry);
        _this.trigger("entry:save", entry);
        return Q.all([
          _this.user_contest_statistics.promiseFetch({
            parent: Application.current_user()
          })
        ]);
      };
    })(this)).fail((function(_this) {
      return function(error) {
        if ((error != null ? error.human : void 0) != null) {
          alert(error.human);
        }
        Application.flashError(error);
        return _this.game_code.setIsValid(false, error.human);
      };
    })(this)).fin((function(_this) {
      return function() {
        return _this.is_claiming(false);
      };
    })(this));
    return this;
  };

  HomeView.prototype.getContest = function(code) {
    return this.contests.first(function(contest) {
      return contest.get('code') === code;
    });
  };

  HomeView.prototype.getStatisticsFor = function(contest) {
    return this.user_contest_statistics.first(function(statistic) {
      return contest.equals(statistic.get('contest_id'));
    });
  };

  return HomeView;

})(Falcon.View);

},{"../../$collections/contests.collection":26,"../../$collections/user_contest_statistics.collection":34,"../../$models/contest.model":44,"../../$models/entry.model":47,"../../$models/user.model":58,"../../$models/user_contest_statistic.model":59,"../../rpc":65}],79:[function(require,module,exports){
var LayoutView, ManageAccountView, RulesView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

RulesView = require("./rules.view");

ManageAccountView = require("./manage_account.view");

module.exports = LayoutView = (function(superClass) {
  extend(LayoutView, superClass);

  function LayoutView() {
    return LayoutView.__super__.constructor.apply(this, arguments);
  }

  LayoutView.prototype.endpoint = '#layout-template';

  LayoutView.prototype.observables = {
    'is_displayed': false,
    'should_show_loader': function() {
      return ko.unwrap(Application.is_checking_session);
    },
    'should_render_views': function() {
      return !ko.unwrap(Application.is_checking_session);
    },
    'force_show_unauthorized_view': false,
    'authorized_view': null,
    'should_show_authorized_view': function() {
      if (Application.is_checking_session()) {
        return false;
      }
      if (!Application.is_logged_in()) {
        return false;
      }
      return !this.force_show_unauthorized_view();
    },
    'unauthorized_view': null,
    'should_show_unauthorized_view': function() {
      if (Application.is_checking_session()) {
        return false;
      }
      return !this.should_show_authorized_view();
    },
    'modal_view': null,
    'should_show_modal_view': function() {
      if (Application.is_checking_session()) {
        return false;
      }
      return Falcon.isView(this.modal_view());
    },
    'rules_view': null,
    'should_show_rules_view': function() {
      if (Application.is_checking_session()) {
        return false;
      }
      return Falcon.isView(this.rules_view());
    },
    'current_user_first_name': function() {
      var current_user, ref;
      if (!Application.is_logged_in()) {
        return "";
      }
      current_user = Application.current_user();
      return (ref = current_user != null ? current_user.get('first_name') : void 0) != null ? ref : "";
    },
    'select_language_is_visible': false,
    'is_showing_manage_account': function() {
      return this.authorized_view() instanceof ManageAccountView;
    }
  };

  LayoutView.prototype.initialize = function() {
    var computed;
    return computed = ko.computed((function(_this) {
      return function() {
        if (!Language.hasSelectedLanguage() && IPInfo.isLoaded()) {
          if (IPInfo.isInCanada()) {
            _this.showSelectLanguage();
          } else {
            _this.selectEnUsLanguage();
          }
          return computed != null ? computed.dispose() : void 0;
        }
      };
    })(this));
  };

  LayoutView.prototype.setAuthorizedView = function(view) {
    if (!Falcon.isView(view)) {
      throw new Error("view must be an instanceof a Falcon.View");
    }
    this.authorized_view(view);
    return view;
  };

  LayoutView.prototype.clearAuthorizedView = function() {
    return this.authorized_view(null);
  };

  LayoutView.prototype.tryShowAuthorizedView = function() {
    this.force_show_unauthorized_view(false);
    return this;
  };

  LayoutView.prototype.setUnauthorizedView = function(view) {
    if (!Falcon.isView(view)) {
      throw new Error("view must be an instanceof a Falcon.View");
    }
    this.unauthorized_view(view);
    return view;
  };

  LayoutView.prototype.clearUnauthorizedView = function() {
    this.unauthorized_view(null);
    return this;
  };

  LayoutView.prototype.forceShowUnauthorizedView = function() {
    this.force_show_unauthorized_view(true);
    return this;
  };

  LayoutView.prototype.setModalView = function(view) {
    if (!Falcon.isView(view)) {
      throw new Error("view must be an instanceof Falcon.View");
    }
    this.modal_view(view);
    return view;
  };

  LayoutView.prototype.clearModalView = function() {
    this.modal_view(null);
    return this;
  };

  LayoutView.prototype.showRules = function() {
    return this.rules_view(new RulesView);
  };

  LayoutView.prototype.hideRules = function() {
    return this.rules_view(null);
  };

  LayoutView.prototype.logout = function() {
    Application.logout();
    return Router.gotoLogin();
  };

  LayoutView.prototype.showSelectLanguage = function() {
    return this.select_language_is_visible(true);
  };

  LayoutView.prototype.hideSelectLanguage = function() {
    return this.select_language_is_visible(false);
  };

  LayoutView.prototype.selectEnUsLanguage = function() {
    Language.selectCode("us/en");
    return this.hideSelectLanguage();
  };

  LayoutView.prototype.selectEnCaLanguage = function() {
    Language.selectCode("ca/en");
    return this.hideSelectLanguage();
  };

  LayoutView.prototype.selectFrCaLanguage = function() {
    Language.selectCode("ca/fr");
    return this.hideSelectLanguage();
  };

  LayoutView.prototype.gotoMain = function() {
    return Router.gotoMain();
  };

  return LayoutView;

})(Falcon.View);

},{"./manage_account.view":81,"./rules.view":85}],80:[function(require,module,exports){
var Entry, LoginView, RPC, Session,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Session = require("../../$models/session.model");

Entry = require("../../$models/entry.model");

RPC = require("../../rpc");

module.exports = LoginView = (function(superClass) {
  extend(LoginView, superClass);

  function LoginView() {
    return LoginView.__super__.constructor.apply(this, arguments);
  }

  LoginView.prototype.endpoint = '#login-template';

  LoginView.prototype.observables = {
    'alert': "",
    'is_logging_in': false,
    'email': "",
    'password': "",
    'game_code': "",
    'has_game_code': function() {
      return Entry.isValidCode(this.game_code());
    }
  };

  LoginView.prototype.initialize = function() {
    this.alert.decorate('validatable');
    this.email.decorate('validatable').subscribe(this.validateEmail, this);
    return this.password.decorate('validatable').subscribe(this.validatePassword, this);
  };

  LoginView.prototype.validateEmail = function() {
    var email;
    email = Helpers.trim(this.email());
    if (_.isEmpty(email)) {
      return this.email.setIsValid(false, "Email must not be empty");
    }
    if (!Helpers.isEmail(email)) {
      return this.email.setIsValid(false, "Email is formatted incorrectly");
    }
    return this.email.setIsValid(true);
  };

  LoginView.prototype.validatePassword = function() {
    var password;
    password = this.password();
    if (!Helpers.isPassword(password)) {
      return this.password.setIsValid(false, "Password must be at least 6 characters long and must not contain white space");
    }
    return this.password.setIsValid(true);
  };

  LoginView.prototype.resetFields = function() {
    this.alert("");
    this.alert.resetValidations();
    this.email("");
    this.email.resetValidations();
    this.password("");
    this.password.resetValidations();
    return this;
  };

  LoginView.prototype.login = function() {
    var email, email_is_valid, password, password_is_valid;
    email_is_valid = this.validateEmail();
    password_is_valid = this.validatePassword();
    if (!(email_is_valid && password_is_valid)) {
      return this;
    }
    if (this.is_logging_in()) {
      return this;
    }
    email = Helpers.trim(this.email());
    password = this.password();
    this.is_logging_in(true);
    new Session({
      email: email,
      password: password
    }).promiseCreate({
      attributes: ['email', 'password']
    }).then((function(_this) {
      return function(session) {
        Application.login(session);
        _this.trigger('session:create', session);
        return Application.trigger('session:create', session);
      };
    })(this)).then((function(_this) {
      return function() {
        if (!_this.has_game_code()) {
          return null;
        }
        return RPC.promiseClaimGameCode(_this.game_code());
      };
    })(this)).then((function(_this) {
      return function(entry) {
        _this.resetFields();
        return Router.gotoMain({
          did_create_session_with_code: entry instanceof Entry
        });
      };
    })(this)).fail((function(_this) {
      return function(error) {
        if (typeof console !== "undefined" && console !== null) {
          console.log(error);
        }
        if (typeof console !== "undefined" && console !== null) {
          console.log(JSON.stringify(error));
        }
        Application.flashError(error);
        return _this.alert.setIsValid(false, error.human);
      };
    })(this)).fin((function(_this) {
      return function() {
        return _this.is_logging_in(false);
      };
    })(this)).done();
    return this;
  };

  LoginView.prototype.setGameCode = function(game_code) {
    this.game_code(game_code);
    return this;
  };

  LoginView.prototype.showNotAuthorized = function() {
    return this.alert.setIsValid(false, "You're not authorized to login here");
  };

  LoginView.prototype.gotoRegistration = function() {
    var params;
    params = {};
    if (this.has_game_code()) {
      params['game_code'] = this.game_code();
    }
    return Router.gotoRegistration(params);
  };

  LoginView.prototype.gotoForgotPassword = function() {
    return Router.gotoForgotPassword();
  };

  return LoginView;

})(Falcon.View);

},{"../../$models/entry.model":47,"../../$models/session.model":57,"../../rpc":65}],81:[function(require,module,exports){
var ChangePasswordView, ManageAccountInformationView, ManageAccountView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

ManageAccountInformationView = require("./manage_account_information.view");

ChangePasswordView = require("./change_password.view");

module.exports = ManageAccountView = (function(superClass) {
  extend(ManageAccountView, superClass);

  function ManageAccountView() {
    return ManageAccountView.__super__.constructor.apply(this, arguments);
  }

  ManageAccountView.prototype.endpoint = "#manage_account-template";

  ManageAccountView.prototype.observables = {
    'internal_view': null,
    'account_information_is_selected': function() {
      return this.internal_view() instanceof ManageAccountInformationView;
    },
    'change_password_is_selected': function() {
      return this.internal_view() instanceof ChangePasswordView;
    }
  };

  ManageAccountView.prototype.setInternalView = function(view) {
    if (!Falcon.isView(view)) {
      throw new Error("view must be an instanceof Falcon.View");
    }
    return this.internal_view(view);
  };

  ManageAccountView.prototype.gotoManageAccount = function() {
    return Router.gotoManageAccount();
  };

  ManageAccountView.prototype.gotoChangePassword = function() {
    return Router.gotoChangePassword();
  };

  return ManageAccountView;

})(Falcon.View);

},{"./change_password.view":74,"./manage_account_information.view":82}],82:[function(require,module,exports){
var ManageAccountInformationView, STATES,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

STATES = require("../../$constants/states.constants");

module.exports = ManageAccountInformationView = (function(superClass) {
  extend(ManageAccountInformationView, superClass);

  function ManageAccountInformationView() {
    return ManageAccountInformationView.__super__.constructor.apply(this, arguments);
  }

  ManageAccountInformationView.prototype.endpoint = "#manage_account_information-template";

  ManageAccountInformationView.prototype.STATES = STATES;

  ManageAccountInformationView.prototype.observables = {
    'is_saving': false,
    'alert': "",
    'name': null,
    'email': null,
    'address_1': null,
    'address_2': null,
    'city': null,
    'state': null,
    'zip_code': null,
    'phone_number': null,
    'formatted_phone_number': {
      write: function(value) {
        value = (value || "").toString().replace(/[^0-9]*/gi, "");
        return this.phone_number(value);
      },
      read: function() {
        var first_piece, phone, second_piece, third_piece;
        phone = (this.phone_number() || "").toString().replace(/[^0-9]*/gi, "");
        first_piece = phone.slice(0, 3);
        second_piece = phone.slice(3, 6);
        third_piece = phone.slice(6, 10);
        if (third_piece.length > 0) {
          return "(" + first_piece + ") " + second_piece + "-" + third_piece;
        } else if (second_piece.length > 0) {
          return first_piece + "-" + second_piece;
        } else {
          return "" + first_piece;
        }
      }
    }
  };

  ManageAccountInformationView.prototype.initialize = function() {
    this.alert.decorate('validatable');
    this.name.decorate('validatable').subscribe(this.validateName, this);
    this.email.decorate('validatable').subscribe(this.validateEmail, this);
    this.phone_number.decorate('validatable').subscribe(this.validatePhoneNumber, this);
    if (Application.is_logged_in()) {
      return this.populateData();
    } else {
      return this.listenToOnce(Application, 'login', this.populateData);
    }
  };

  ManageAccountInformationView.prototype.validateName = function() {
    var name;
    name = Helpers.trim(this.name());
    if (_.isEmpty(name)) {
      return this.name.setIsValid(false, "Name must not be empty");
    }
    return this.name.setIsValid(true);
  };

  ManageAccountInformationView.prototype.validateEmail = function() {
    var email;
    email = Helpers.trim(this.email());
    if (_.isEmpty(email)) {
      return this.email.setIsValid(false, "Email must not be empty");
    }
    if (!Helpers.isEmail(email)) {
      return this.email.setIsValid(false, "Email is formatted incorrectly");
    }
    return this.email.setIsValid(true);
  };

  ManageAccountInformationView.prototype.validatePhoneNumber = function() {
    var phone_number;
    phone_number = this.phone_number() || "";
    if (phone_number.length !== 10 && !/[0-9]{10}/.test(phone_number)) {
      return this.phone_number.setIsValid(false, "Please enter a valid phone number");
    }
    return this.phone_number.setIsValid(true);
  };

  ManageAccountInformationView.prototype.populateData = function() {
    var current_user;
    if (!Application.is_logged_in()) {
      return this;
    }
    current_user = Application.current_user();
    this.name(current_user.get("name"));
    this.email(current_user.get("email"));
    this.address_1(current_user.get('address_1'));
    this.address_2(current_user.get('address_2'));
    this.city(current_user.get('city'));
    this.state(current_user.get('state'));
    this.zip_code(current_user.get('zip_code'));
    return this.phone_number(current_user.get('phone_number'));
  };

  ManageAccountInformationView.prototype.save = function() {
    if (!Application.is_logged_in()) {
      return this;
    }
    if (this.is_saving()) {
      return this;
    }
    if (!(this.validateName() && this.validateEmail() && this.validatePhoneNumber())) {
      return this;
    }
    this.is_saving(true);
    Application.current_user().clone(['id']).set({
      name: this.name(),
      email: this.email(),
      address_1: this.address_1(),
      address_2: this.address_2(),
      city: this.city(),
      state: this.state(),
      zip_code: this.zip_code(),
      phone_number: this.phone_number()
    }).promiseSave({
      parent: null,
      attributes: ['name', 'email', 'address_1', 'address_2', 'city', 'state', 'zip_code', 'phone_number']
    }).then((function(_this) {
      return function(user) {
        _this.alert.setIsValid(true, "Successfully saved account information!");
        return Application.current_user().set({
          name: user.get('name'),
          email: user.get('email'),
          ddress_1: user.get('address_1'),
          address_2: user.get('address_2'),
          city: user.get('city'),
          state: user.get('state'),
          zip_code: user.get('zip_code'),
          phone_number: user.get('phone_number')
        });
      };
    })(this)).fail((function(_this) {
      return function() {
        return _this.alert.setIsValid(false, "An error occurred while saving account information");
      };
    })(this)).fin((function(_this) {
      return function() {
        return _this.is_saving(false);
      };
    })(this)).done();
    return this;
  };

  return ManageAccountInformationView;

})(Falcon.View);

},{"../../$constants/states.constants":37}],83:[function(require,module,exports){
var Entry, RPC, RegistrationView, Session, User,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Session = require("../../$models/session.model");

Entry = require("../../$models/entry.model");

User = require("../../$models/user.model");

RPC = require("../../rpc");

module.exports = RegistrationView = (function(superClass) {
  extend(RegistrationView, superClass);

  function RegistrationView() {
    return RegistrationView.__super__.constructor.apply(this, arguments);
  }

  RegistrationView.prototype.endpoint = '#registration-template';

  RegistrationView.prototype.observables = {
    'alert': "",
    'is_registering': false,
    'name': "",
    'email': "",
    'repeat_email': "",
    'phone': "",
    'password': "",
    'repeat_password': "",
    'game_code': "",
    'has_game_code': function() {
      return Entry.isValidCode(this.game_code());
    },
    'formatted_phone': {
      write: function(value) {
        value = (value || "").toString().replace(/[^0-9]+/gi, "");
        return this.phone(value);
      },
      read: function() {
        var first_piece, phone, second_piece, third_piece;
        phone = (this.phone() || "").toString();
        if (!/^[0-9]+$/.test(phone)) {
          return phone;
        }
        first_piece = phone.slice(0, 3);
        second_piece = phone.slice(3, 6);
        third_piece = phone.slice(6, 10);
        if (third_piece.length > 0) {
          return "(" + first_piece + ") " + second_piece + "-" + third_piece;
        } else if (second_piece.length > 0) {
          return first_piece + "-" + second_piece;
        } else {
          return "" + first_piece;
        }
      }
    },
    '_opted_in_emails': void 0,
    'opted_in_emails': {
      write: function(value) {
        return this._opted_in_emails(value);
      },
      read: function() {
        var opted_in_emails;
        opted_in_emails = this._opted_in_emails();
        if (opted_in_emails != null) {
          return opted_in_emails;
        }
        return Language.isWithinUnitedStates();
      }
    },
    'can_register': function() {
      if (this.is_registering()) {
        return false;
      }
      if (!this.name.is_valid()) {
        return false;
      }
      if (!this.email.is_valid()) {
        return false;
      }
      if (!this.repeat_email.is_valid()) {
        return false;
      }
      if (!this.phone.is_valid()) {
        return false;
      }
      if (!this.password.is_valid()) {
        return false;
      }
      if (!this.repeat_password.is_valid()) {
        return false;
      }
      return true;
    }
  };

  RegistrationView.prototype.initialize = function() {
    this.alert.decorate('validatable');
    this.name.decorate('validatable').subscribe(this.validateName, this);
    this.email.decorate('validatable').subscribe(this.validateEmail, this);
    this.repeat_email.decorate('validatable').subscribe(this.validateRepeatEmail, this);
    this.phone.decorate('validatable').subscribe(this.validatePhone, this);
    this.password.decorate('validatable').subscribe(this.validatePassword, this);
    return this.repeat_password.decorate('validatable').subscribe(this.validateRepeatPassword, this);
  };

  RegistrationView.prototype.validateName = function() {
    var name;
    name = Helpers.trim(this.name());
    if (_.isEmpty(name)) {
      return this.name.setIsValid(false, "Name must not be empty");
    }
    return this.name.setIsValid(true);
  };

  RegistrationView.prototype.validateEmail = function() {
    var email;
    email = Helpers.trim(this.email());
    if (_.isEmpty(email)) {
      return this.email.setIsValid(false, "Email must not be empty");
    }
    if (!Helpers.isEmail(email)) {
      return this.email.setIsValid(false, "Email is formatted incorrectly");
    }
    return this.email.setIsValid(true);
  };

  RegistrationView.prototype.validateRepeatEmail = function() {
    var email, repeat_email;
    email = this.email();
    repeat_email = this.repeat_email();
    if (_.isEmpty(repeat_email)) {
      return this.repeat_email.setIsValid(false, "Please re-enter your email");
    }
    if (email !== repeat_email) {
      return this.repeat_email.setIsValid(false, "Emails do not match");
    }
    return this.repeat_email.setIsValid(true);
  };

  RegistrationView.prototype.validatePassword = function() {
    var password;
    password = this.password();
    if (!Helpers.isPassword(password)) {
      return this.password.setIsValid(false, "Password must be at least 6 characters long and must not contain white space");
    }
    if (!_.isEmpty(this.repeat_password())) {
      this.validateRepeatPassword();
    }
    return this.password.setIsValid(true);
  };

  RegistrationView.prototype.validateRepeatPassword = function() {
    var password, repeat_password;
    password = this.password();
    repeat_password = this.repeat_password();
    if (_.isEmpty(repeat_password)) {
      return this.repeat_password.setIsValid(false, "Please re-enter your password");
    }
    if (password !== repeat_password) {
      return this.repeat_password.setIsValid(false, "Passwords do not match");
    }
    return this.repeat_password.setIsValid(true);
  };

  RegistrationView.prototype.validatePhone = function() {
    var phone;
    phone = this.phone() || "";
    if (phone.length !== 10 && !/[0-9]{10}/.test(phone)) {
      return this.phone.setIsValid(false, "Please enter a valid phone number");
    }
    return this.phone.setIsValid(true);
  };

  RegistrationView.prototype.resetFields = function() {
    this.alert("");
    this.alert.resetValidations();
    this.name("");
    this.name.resetValidations();
    this.email("");
    this.email.resetValidations();
    this.repeat_email("");
    this.repeat_email.resetValidations();
    this.password("");
    this.password.resetValidations();
    this.repeat_password("");
    this.repeat_password.resetValidations();
    this.phone("");
    this.phone.resetValidations();
    return this;
  };

  RegistrationView.prototype.register = function() {
    var attributes, email, email_is_valid, is_subscribed_to_newsletter, name, name_is_valid, password, password_is_valid, phone_is_valid, phone_number, repeat_email_is_valid, repeat_password_is_valid, user;
    name_is_valid = this.validateName();
    email_is_valid = this.validateEmail();
    repeat_email_is_valid = this.validateRepeatEmail();
    password_is_valid = this.validatePassword();
    repeat_password_is_valid = this.validateRepeatPassword();
    phone_is_valid = this.validatePhone();
    if (!(name_is_valid && email_is_valid && repeat_email_is_valid && password_is_valid && repeat_password_is_valid && phone_is_valid)) {
      return this;
    }
    if (!this.can_register()) {
      return this;
    }
    if (this.is_registering()) {
      return this;
    }
    name = Helpers.trim(this.name());
    email = Helpers.trim(this.email());
    phone_number = this.formatted_phone();
    password = this.password();
    is_subscribed_to_newsletter = this.opted_in_emails();
    this.is_registering(true);
    user = new User({
      name: name,
      email: email,
      password: password,
      phone_number: phone_number,
      is_subscribed_to_newsletter: is_subscribed_to_newsletter
    });
    attributes = ['name', 'email', 'password', 'phone_number', 'is_subscribed_to_newsletter'];
    user.promiseCreate({
      attributes: attributes
    }).then((function(_this) {
      return function(user) {
        _this.trigger('user:create', user);
        Application.trigger('user:create', user);
        return user;
      };
    })(this)).then((function(_this) {
      return function(user) {
        return new Session({
          email: email,
          password: password
        }).promiseCreate({
          attributes: ['email', 'password']
        });
      };
    })(this)).then((function(_this) {
      return function(session) {
        Application.login(session);
        _this.trigger('session:create', session);
        return Application.trigger('session:create', session);
      };
    })(this)).then((function(_this) {
      return function() {
        if (!_this.has_game_code()) {
          return null;
        }
        return RPC.promiseClaimGameCode(_this.game_code());
      };
    })(this)).then((function(_this) {
      return function(entry) {
        _this.resetFields();
        return Router.gotoMain({
          did_create_session_with_code: entry instanceof Entry
        });
      };
    })(this)).fail((function(_this) {
      return function(error) {
        Application.flashError(error);
        return _this.alert.setIsValid(false, error.human);
      };
    })(this)).fin((function(_this) {
      return function() {
        return _this.is_registering(false);
      };
    })(this)).done();
    return this;
  };

  RegistrationView.prototype.setGameCode = function(game_code) {
    this.game_code(game_code);
    return this;
  };

  RegistrationView.prototype.gotoLogin = function() {
    var params;
    params = {};
    if (this.has_game_code()) {
      params['game_code'] = this.game_code();
    }
    return Router.gotoLogin(params);
  };

  RegistrationView.prototype.showRules = function() {
    return Application.Layout.showRules();
  };

  return RegistrationView;

})(Falcon.View);

},{"../../$models/entry.model":47,"../../$models/session.model":57,"../../$models/user.model":58,"../../rpc":65}],84:[function(require,module,exports){
var RPC, ResetPasswordView, Session,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

RPC = require("../../rpc");

Session = require("../../$models/session.model");

module.exports = ResetPasswordView = (function(superClass) {
  extend(ResetPasswordView, superClass);

  function ResetPasswordView() {
    return ResetPasswordView.__super__.constructor.apply(this, arguments);
  }

  ResetPasswordView.prototype.endpoint = '#reset_password-template';

  ResetPasswordView.prototype.observables = {
    'alert': "",
    'is_resetting': false,
    'email': "",
    'reset_code': "",
    'password': "",
    'email_is_valid': function() {
      return Helpers.isEmail(this.email());
    },
    'reset_code_is_valid': function() {
      return !_.isEmpty(this.reset_code());
    },
    'can_reset_password': function() {
      if (!this.email_is_valid()) {
        return false;
      }
      if (!this.reset_code_is_valid()) {
        return false;
      }
      return true;
    }
  };

  ResetPasswordView.prototype.initialize = function() {
    this.alert.decorate('validatable');
    return this.password.decorate('validatable').subscribe(this.validatePassword, this);
  };

  ResetPasswordView.prototype.setEmail = function(email) {
    return this.email(email);
  };

  ResetPasswordView.prototype.setResetCode = function(reset_code) {
    return this.reset_code(reset_code);
  };

  ResetPasswordView.prototype.validatePassword = function() {
    var password;
    password = this.password();
    if (!Helpers.isPassword(password)) {
      return this.password.setIsValid(false, "Password must be at least 6 characters long and must not contain white space");
    }
    return this.password.setIsValid(true);
  };

  ResetPasswordView.prototype.resetFields = function() {
    this.alert("");
    this.alert.resetValidations();
    this.password("");
    this.password.resetValidations();
    return this;
  };

  ResetPasswordView.prototype.reset = function() {
    var email, password, reset_code;
    if (!this.validatePassword()) {
      return this;
    }
    if (!this.can_reset_password()) {
      return this;
    }
    if (this.is_resetting()) {
      return this;
    }
    email = Helpers.trim(this.email());
    reset_code = Helpers.trim(this.reset_code());
    password = Helpers.trim(this.password());
    this.is_resetting(true);
    RPC.promiseResetPassword({
      email: email,
      reset_code: reset_code,
      password: password
    }).then((function(_this) {
      return function(user) {
        return new Session({
          email: email,
          password: password
        }).promiseCreate({
          attributes: ['email', 'password']
        });
      };
    })(this)).then((function(_this) {
      return function(session) {
        Application.login(session);
        _this.resetFields();
        _this.trigger('session:create', session);
        Application.trigger('session:create', session);
        return Router.gotoMain();
      };
    })(this)).fail((function(_this) {
      return function(error) {
        Application.flashError(error);
        return _this.alert.setIsValid(false, error.human);
      };
    })(this)).fin((function(_this) {
      return function() {
        return _this.is_resetting(false);
      };
    })(this)).done();
    return this;
  };

  ResetPasswordView.prototype.gotoLogin = function() {
    return Router.gotoLogin();
  };

  return ResetPasswordView;

})(Falcon.View);

},{"../../$models/session.model":57,"../../rpc":65}],85:[function(require,module,exports){
var Language, RulesView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Language = require("../language");

module.exports = RulesView = (function(superClass) {
  extend(RulesView, superClass);

  function RulesView() {
    return RulesView.__super__.constructor.apply(this, arguments);
  }

  RulesView.prototype.endpoint = function() {
    var ret;
    ret = (function() {
      switch (Language.selectedLanguageCode()) {
        case "ca/en":
          return "#rules_ca_en-template";
        case "ca/fr":
          return "#rules_ca_fr-template";
        default:
          return "#rules_us_en-template";
      }
    })();
    return ret;
  };

  return RulesView;

})(Falcon.View);

},{"../language":72}]},{},[69]);
